/* tslint:disable */
/* eslint-disable */
/**
 * Fintron REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountAdminServiceAdminCloseAccountRequest
 */
export interface AccountAdminServiceAdminCloseAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminServiceAdminCloseAccountRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface AccountAdminServiceReviewProgramEnrollmentRequest
 */
export interface AccountAdminServiceReviewProgramEnrollmentRequest {
    /**
     * 
     * @type {V1ProgramType}
     * @memberof AccountAdminServiceReviewProgramEnrollmentRequest
     */
    'programType'?: V1ProgramType;
    /**
     * 
     * @type {V1ProgramApprovalStatus}
     * @memberof AccountAdminServiceReviewProgramEnrollmentRequest
     */
    'approvalStatus'?: V1ProgramApprovalStatus;
    /**
     * 
     * @type {string}
     * @memberof AccountAdminServiceReviewProgramEnrollmentRequest
     */
    'reason'?: string;
}


/**
 * SetAdminProgramEnrollmentRequest allows admin to set the program enrollment for a user\'s account. account_uid is the user account that the program enrollment is being set for. program_type is the type of program that the user is enrolling in. program_election_preference is the user\'s preference for the program i.e. opt-in or opt-out. positive_consent_given_on is the date that the user gave positive consent to enroll in the program. Only required if Admin is opting in on behalf of the user. reason is the reason for setting the program enrollment.
 * @export
 * @interface AccountAdminServiceSetAdminProgramEnrollmentRequest
 */
export interface AccountAdminServiceSetAdminProgramEnrollmentRequest {
    /**
     * 
     * @type {V1ProgramType}
     * @memberof AccountAdminServiceSetAdminProgramEnrollmentRequest
     */
    'programType'?: V1ProgramType;
    /**
     * 
     * @type {V1ProgramElectionPreference}
     * @memberof AccountAdminServiceSetAdminProgramEnrollmentRequest
     */
    'programElectionPreference'?: V1ProgramElectionPreference;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof AccountAdminServiceSetAdminProgramEnrollmentRequest
     */
    'positiveConsentGivenOn'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof AccountAdminServiceSetAdminProgramEnrollmentRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {V1ProgramEnrollmentOptions}
     * @memberof AccountAdminServiceSetAdminProgramEnrollmentRequest
     */
    'programEnrollment'?: V1ProgramEnrollmentOptions;
}


/**
 * 
 * @export
 * @interface AccountServiceClearBeneficiarySetRequest
 */
export interface AccountServiceClearBeneficiarySetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AccountServiceClearBeneficiarySetRequest
     */
    'contingentOnly'?: boolean;
}
/**
 * SetProgramEnrollmentRequest is used to set the program enrollment for a user account. account_uid is the user account that the program enrollment is being set for. program_type is the type of program that the user is enrolling in. program_election_preference is the user\'s preference for the program i.e. opt-in or opt-out. positive_consent_given_on is the date that the user gave positive consent to enroll in the program. reason is the reason for setting the program enrollment.
 * @export
 * @interface AccountServiceSetProgramEnrollmentRequest
 */
export interface AccountServiceSetProgramEnrollmentRequest {
    /**
     * 
     * @type {V1ProgramType}
     * @memberof AccountServiceSetProgramEnrollmentRequest
     */
    'programType'?: V1ProgramType;
    /**
     * 
     * @type {V1ProgramElectionPreference}
     * @memberof AccountServiceSetProgramEnrollmentRequest
     */
    'programElectionPreference'?: V1ProgramElectionPreference;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof AccountServiceSetProgramEnrollmentRequest
     */
    'positiveConsentGivenOn'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof AccountServiceSetProgramEnrollmentRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {V1ProgramEnrollmentOptions}
     * @memberof AccountServiceSetProgramEnrollmentRequest
     */
    'programEnrollment'?: V1ProgramEnrollmentOptions;
}


/**
 * 
 * @export
 * @interface AccountServiceUpdateBeneficiaryRequest
 */
export interface AccountServiceUpdateBeneficiaryRequest {
    /**
     * 
     * @type {V1AccountBeneficiaryElection}
     * @memberof AccountServiceUpdateBeneficiaryRequest
     */
    'accountBeneficiaryElection'?: V1AccountBeneficiaryElection;
}
/**
 * AccountStatus represents the status in the lifecycle of an account.   - ACCOUNT_STATUS_NEW: ACCOUNT_STATUS_NEW indicates an account has been created but not yet submitted to the external account provider.  - ACCOUNT_STATUS_PENDING: ACCOUNT_STATUS_PENDING indicates an account has been submitted to the external account provider but has not yet been approved.  - ACCOUNT_STATUS_ACTIVE: ACCOUNT_STATUS_ACTIVE indicates an account has been approved by the external account provider.  - ACCOUNT_STATUS_REJECTED: ACCOUNT_STATUS_REJECTED indicates an account has been rejected by the external account provider.  - ACCOUNT_STATUS_SUSPENDED: ACCOUNT_STATUS_SUSPENDED indicates an account has been suspended by the external account provider.  - ACCOUNT_STATUS_CLOSED: ACCOUNT_STATUS_CLOSED indicates an account has been closed.  - ACCOUNT_STATUS_CANCELLED: ACCOUNT_STATUS_CANCELLED indicates an account application was cancelled before completion.  - ACCOUNT_STATUS_ERROR: ACCOUNT_STATUS_ERROR indicates an account application is in an error state.  - ACCOUNT_STATUS_DENIED: ACCOUNT_STATUS_DENIED indicates an account application was denied from opening.  - ACCOUNT_STATUS_CONTACTED: ACCOUNT_STATUS_CONTACTED indicates an account application was contacted for additional information before submission.  - ACCOUNT_STATUS_SUBMITTED: ACCOUNT_STATUS_SUBMITTED indicates an account application was submitted to the external account provider.  - ACCOUNT_STATUS_APPEALED: ACCOUNT_STATUS_APPEALED indicates an account application was appealed after rejection from an external provider.
 * @export
 * @enum {string}
 */

export const Accountpbv1AccountStatus = {
    Unspecified: 'ACCOUNT_STATUS_UNSPECIFIED',
    New: 'ACCOUNT_STATUS_NEW',
    Pending: 'ACCOUNT_STATUS_PENDING',
    Active: 'ACCOUNT_STATUS_ACTIVE',
    Rejected: 'ACCOUNT_STATUS_REJECTED',
    Suspended: 'ACCOUNT_STATUS_SUSPENDED',
    Closed: 'ACCOUNT_STATUS_CLOSED',
    Cancelled: 'ACCOUNT_STATUS_CANCELLED',
    Error: 'ACCOUNT_STATUS_ERROR',
    Denied: 'ACCOUNT_STATUS_DENIED',
    Contacted: 'ACCOUNT_STATUS_CONTACTED',
    Submitted: 'ACCOUNT_STATUS_SUBMITTED',
    Appealed: 'ACCOUNT_STATUS_APPEALED'
} as const;

export type Accountpbv1AccountStatus = typeof Accountpbv1AccountStatus[keyof typeof Accountpbv1AccountStatus];


/**
 * 
 * @export
 * @interface Accountpbv1EmploymentInfo
 */
export interface Accountpbv1EmploymentInfo {
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1EmploymentInfo
     */
    'employerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1EmploymentInfo
     */
    'jobPosition'?: string;
}
/**
 * 
 * @export
 * @interface Accountpbv1Instrument
 */
export interface Accountpbv1Instrument {
    /**
     * Quote is the asset that is being used to price the trade, e.g. USD.
     * @type {string}
     * @memberof Accountpbv1Instrument
     */
    'quote'?: string;
    /**
     * Base is the asset that is being traded, e.g. AAPL.
     * @type {string}
     * @memberof Accountpbv1Instrument
     */
    'base'?: string;
}
/**
 * 
 * @export
 * @interface Accountpbv1TrustedContact
 */
export interface Accountpbv1TrustedContact {
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1TrustedContact
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1TrustedContact
     */
    'lastName'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof Accountpbv1TrustedContact
     */
    'dateOfBirth'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1TrustedContact
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1TrustedContact
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Accountpbv1TrustedContact
     */
    'middleName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Accountpbv1TrustedContactStatus = {
    Unspecified: 'TRUSTED_CONTACT_STATUS_UNSPECIFIED',
    Pending: 'TRUSTED_CONTACT_STATUS_PENDING',
    Active: 'TRUSTED_CONTACT_STATUS_ACTIVE',
    Inactive: 'TRUSTED_CONTACT_STATUS_INACTIVE'
} as const;

export type Accountpbv1TrustedContactStatus = typeof Accountpbv1TrustedContactStatus[keyof typeof Accountpbv1TrustedContactStatus];


/**
 * 
 * @export
 * @interface AddAdvisoryFeeScheduleRequestAssetRebate
 */
export interface AddAdvisoryFeeScheduleRequestAssetRebate {
    /**
     * AssetId is the id of the asset that should receive the rebate.
     * @type {string}
     * @memberof AddAdvisoryFeeScheduleRequestAssetRebate
     */
    'assetId'?: string;
    /**
     * 
     * @type {Array<V1RateBracket>}
     * @memberof AddAdvisoryFeeScheduleRequestAssetRebate
     */
    'rebateBrackets'?: Array<V1RateBracket>;
}
/**
 * 
 * @export
 * @interface AddDocumentSetRequestOtherDocument
 */
export interface AddDocumentSetRequestOtherDocument {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddDocumentSetRequestOtherDocument
     */
    'documentId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddDocumentSetRequestSingleSidedDocument
 */
export interface AddDocumentSetRequestSingleSidedDocument {
    /**
     * 
     * @type {string}
     * @memberof AddDocumentSetRequestSingleSidedDocument
     */
    'documentId'?: string;
}
/**
 * 
 * @export
 * @interface AddDocumentSetRequestTwoSidedDocument
 */
export interface AddDocumentSetRequestTwoSidedDocument {
    /**
     * 
     * @type {string}
     * @memberof AddDocumentSetRequestTwoSidedDocument
     */
    'front'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentSetRequestTwoSidedDocument
     */
    'back'?: string;
}
/**
 * 
 * @export
 * @interface AdminServiceSetAccountTagsRequest
 */
export interface AdminServiceSetAccountTagsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminServiceSetAccountTagsRequest
     */
    'tags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Adminpbv1GetTokensRequest
 */
export interface Adminpbv1GetTokensRequest {
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1GetTokensRequest
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1GetTokensRequest
     */
    'redirectUri'?: string;
}
/**
 * 
 * @export
 * @interface Adminpbv1GetTokensResponse
 */
export interface Adminpbv1GetTokensResponse {
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1GetTokensResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1GetTokensResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1GetTokensResponse
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Adminpbv1LogoutRequest
 */
export interface Adminpbv1LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1LogoutRequest
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface Adminpbv1RefreshTokenRequest
 */
export interface Adminpbv1RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1RefreshTokenRequest
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1RefreshTokenRequest
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Adminpbv1RefreshTokenResponse
 */
export interface Adminpbv1RefreshTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1RefreshTokenResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1RefreshTokenResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adminpbv1RefreshTokenResponse
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1CreateUserRequest
 */
export interface Authpbv1CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof Authpbv1CreateUserRequest
     */
    'dateOfBirth'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1CreateUserResponse
 */
export interface Authpbv1CreateUserResponse {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserResponse
     */
    'idToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1CreateUserResponse
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1GetTokensRequest
 */
export interface Authpbv1GetTokensRequest {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1GetTokensRequest
     */
    'code'?: string;
    /**
     * RedirectUri - location where the authorization server sends the user once the app has been successfully authorized and granted an authorization code or access token.
     * @type {string}
     * @memberof Authpbv1GetTokensRequest
     */
    'redirectUri'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1GetTokensResponse
 */
export interface Authpbv1GetTokensResponse {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1GetTokensResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1GetTokensResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1GetTokensResponse
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1LoginRequest
 */
export interface Authpbv1LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1LoginResponse
 */
export interface Authpbv1LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginResponse
     */
    'idToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LoginResponse
     */
    'session'?: string;
    /**
     * 
     * @type {V1ChallengeName}
     * @memberof Authpbv1LoginResponse
     */
    'challengeName'?: V1ChallengeName;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Authpbv1LoginResponse
     */
    'challengeParameters'?: { [key: string]: string; };
}


/**
 * 
 * @export
 * @interface Authpbv1LogoutRequest
 */
export interface Authpbv1LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1LogoutRequest
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1RefreshTokenRequest
 */
export interface Authpbv1RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1RefreshTokenRequest
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1RefreshTokenRequest
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Authpbv1RefreshTokenResponse
 */
export interface Authpbv1RefreshTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof Authpbv1RefreshTokenResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1RefreshTokenResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Authpbv1RefreshTokenResponse
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface Blobpbv1GetLinkRequest
 */
export interface Blobpbv1GetLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof Blobpbv1GetLinkRequest
     */
    'uid'?: string;
}
/**
 * 
 * @export
 * @interface Blobpbv1GetLinkResponse
 */
export interface Blobpbv1GetLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof Blobpbv1GetLinkResponse
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface Commonpbv1Date
 */
export interface Commonpbv1Date {
    /**
     * Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @type {number}
     * @memberof Commonpbv1Date
     */
    'year'?: number;
    /**
     * Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @type {number}
     * @memberof Commonpbv1Date
     */
    'month'?: number;
    /**
     * Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @type {number}
     * @memberof Commonpbv1Date
     */
    'day'?: number;
}
/**
 * 
 * @export
 * @interface CreateAdminOrderRequestAssetTransfer
 */
export interface CreateAdminOrderRequestAssetTransfer {
    /**
     * 
     * @type {string}
     * @memberof CreateAdminOrderRequestAssetTransfer
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdminOrderRequestAssetTransfer
     */
    'assetId'?: string;
    /**
     * Amount is the quantity of the asset at the time of the order.
     * @type {string}
     * @memberof CreateAdminOrderRequestAssetTransfer
     */
    'amount'?: string;
    /**
     * Notional is the value of the asset at the time of the order.
     * @type {string}
     * @memberof CreateAdminOrderRequestAssetTransfer
     */
    'notional'?: string;
    /**
     * IsDeposit is a flag to indicate if the asset should be added to the account or removed from the account.
     * @type {boolean}
     * @memberof CreateAdminOrderRequestAssetTransfer
     */
    'isDeposit'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateNewLevelSetRequestPortfolioLevel
 */
export interface CreateNewLevelSetRequestPortfolioLevel {
    /**
     * 
     * @type {string}
     * @memberof CreateNewLevelSetRequestPortfolioLevel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewLevelSetRequestPortfolioLevel
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateReconOrderRequestAssets
 */
export interface CreateReconOrderRequestAssets {
    /**
     * 
     * @type {string}
     * @memberof CreateReconOrderRequestAssets
     */
    'porfolioId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReconOrderRequestAssets
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReconOrderRequestAssets
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReconOrderRequestAssets
     */
    'notional'?: string;
}
/**
 * 
 * @export
 * @interface GooglerpcStatus
 */
export interface GooglerpcStatus {
    /**
     * 
     * @type {number}
     * @memberof GooglerpcStatus
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof GooglerpcStatus
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ProtobufAny>}
     * @memberof GooglerpcStatus
     */
    'details'?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @interface LiquidateOrderQuantifiedTransferTarget
 */
export interface LiquidateOrderQuantifiedTransferTarget {
    /**
     * 
     * @type {string}
     * @memberof LiquidateOrderQuantifiedTransferTarget
     */
    'amount'?: string;
    /**
     * LiabilityId indicates that a liability should be satisfied with the proceeds. The liability itself indicates how the transfer of the proceeds should be carried out. If the amount of the indicated here is greater than the amount of the liability, the liquidation will error. If the amount is less than the liability, the liquidation will only partially satisfy the liability.
     * @type {string}
     * @memberof LiquidateOrderQuantifiedTransferTarget
     */
    'liabilityId'?: string;
    /**
     * ExternalAccountId indicates that the proceeds should be transferred to an external account. The external account itself indicates how the transfer of the proceeds should be carried out.
     * @type {string}
     * @memberof LiquidateOrderQuantifiedTransferTarget
     */
    'externalAccountId'?: string;
    /**
     * PortfolioId indicates that the proceeds should be transferred to another portfolio. If the portfolio is not part of the same UserAccount, the liquidation will error.
     * @type {string}
     * @memberof LiquidateOrderQuantifiedTransferTarget
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {V1LiquidationFeeTransfer}
     * @memberof LiquidateOrderQuantifiedTransferTarget
     */
    'fee'?: V1LiquidationFeeTransfer;
}
/**
 * 
 * @export
 * @interface LiquidateOrderRemainderTransferTarget
 */
export interface LiquidateOrderRemainderTransferTarget {
    /**
     * ExternalAccountId indicates that the proceeds should be transferred to an external account. The external account itself indicates how the transfer of the proceeds should be carried out.
     * @type {string}
     * @memberof LiquidateOrderRemainderTransferTarget
     */
    'externalAccountId'?: string;
    /**
     * PortfolioId indicates that the proceeds should be transferred to another portfolio. If the portfolio is not part of the same UserAccount, the liquidation will error.
     * @type {string}
     * @memberof LiquidateOrderRemainderTransferTarget
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {object}
     * @memberof LiquidateOrderRemainderTransferTarget
     */
    'redistribute'?: object;
    /**
     * 
     * @type {V1LiquidationFeeTransfer}
     * @memberof LiquidateOrderRemainderTransferTarget
     */
    'fee'?: V1LiquidationFeeTransfer;
}
/**
 * 
 * @export
 * @interface LiquidateOrderSellAllAccount
 */
export interface LiquidateOrderSellAllAccount {
    /**
     * 
     * @type {string}
     * @memberof LiquidateOrderSellAllAccount
     */
    'accountId'?: string;
}
/**
 * 
 * @export
 * @interface LiquidateOrderSellAllPortfolio
 */
export interface LiquidateOrderSellAllPortfolio {
    /**
     * PortfolioIds are the portfolios use \"sell all from\". If empty, the call will error.
     * @type {Array<string>}
     * @memberof LiquidateOrderSellAllPortfolio
     */
    'portfolioIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ModifyExistingOrderRequestTransaction
 */
export interface ModifyExistingOrderRequestTransaction {
    /**
     * 
     * @type {string}
     * @memberof ModifyExistingOrderRequestTransaction
     */
    'sourceAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyExistingOrderRequestTransaction
     */
    'destinationAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyExistingOrderRequestTransaction
     */
    'amount'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Pbv1AccountType = {
    Unspecified: 'ACCOUNT_TYPE_UNSPECIFIED',
    Brokerage: 'ACCOUNT_TYPE_BROKERAGE',
    BrokerageDiscretionary: 'ACCOUNT_TYPE_BROKERAGE_DISCRETIONARY',
    Ira: 'ACCOUNT_TYPE_IRA',
    IraDiscretionary: 'ACCOUNT_TYPE_IRA_DISCRETIONARY',
    RothIra: 'ACCOUNT_TYPE_ROTH_IRA',
    RothIraDiscretionary: 'ACCOUNT_TYPE_ROTH_IRA_DISCRETIONARY'
} as const;

export type Pbv1AccountType = typeof Pbv1AccountType[keyof typeof Pbv1AccountType];


/**
 * Asset holds information on the various asset classes in the system.
 * @export
 * @interface Pbv1Asset
 */
export interface Pbv1Asset {
    /**
     * 
     * @type {V1FiatAsset}
     * @memberof Pbv1Asset
     */
    'fiat'?: V1FiatAsset;
    /**
     * 
     * @type {V1SecurityAsset}
     * @memberof Pbv1Asset
     */
    'security'?: V1SecurityAsset;
    /**
     * 
     * @type {V1CryptoAsset}
     * @memberof Pbv1Asset
     */
    'crypto'?: V1CryptoAsset;
}
/**
 * 
 * @export
 * @interface Pbv1Beneficiary
 */
export interface Pbv1Beneficiary {
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'lastName'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof Pbv1Beneficiary
     */
    'dateOfBirth'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'streetAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'additionalStreetAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'zipCode'?: string;
    /**
     * 
     * @type {V1BeneficiaryRelationType}
     * @memberof Pbv1Beneficiary
     */
    'relationship'?: V1BeneficiaryRelationType;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'ssn'?: string;
    /**
     * 
     * @type {number}
     * @memberof Pbv1Beneficiary
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pbv1Beneficiary
     */
    'middleName'?: string;
}


/**
 * 
 * @export
 * @interface PingResponseExtra
 */
export interface PingResponseExtra {
    /**
     * 
     * @type {string}
     * @memberof PingResponseExtra
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PingResponseExtra
     */
    'value'?: string;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }  Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...  Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON  The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface RoboServiceUpdateGoalRequest
 */
export interface RoboServiceUpdateGoalRequest {
    /**
     * 
     * @type {string}
     * @memberof RoboServiceUpdateGoalRequest
     */
    'name'?: string;
    /**
     * 
     * @type {V1UpdateGoalParameters}
     * @memberof RoboServiceUpdateGoalRequest
     */
    'parameters'?: V1UpdateGoalParameters;
    /**
     * enable_auto_infusion grants us flexibility to allow a client to create a goal without having regular infusions set up off the bat. When this is set to false, the funding account uid is not required, and the goal will be created without recurring rules. If no value is provided, the default value (set in tenant configs) will be assumed.
     * @type {boolean}
     * @memberof RoboServiceUpdateGoalRequest
     */
    'enableAutoInfusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RoboServiceUpdateGoalRequest
     */
    'autoInfusionCount'?: number;
    /**
     * FundingAccountUid is the account to use when creating the recurring infusions and the initial investment.
     * @type {string}
     * @memberof RoboServiceUpdateGoalRequest
     */
    'fundingAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface RoboServiceUpdateRoboGeneralInvestmentRequest
 */
export interface RoboServiceUpdateRoboGeneralInvestmentRequest {
    /**
     * ModelPortfolioUid is the uid of the managed portfolio to use for the general investment.
     * @type {string}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'modelPortfolioUid'?: string;
    /**
     * FundingAccountUid is the account to use when creating the recurring infusions and the initital investment. If not specified, the default account is used.
     * @type {string}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'fundingAccountUid'?: string;
    /**
     * RecurringInfusionAmount is the amount to invest in the general investment on a recurring basis.
     * @type {string}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'recurringInfusionAmount'?: string;
    /**
     * 
     * @type {V1RoboInfusionFreq}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'infusionFreq'?: V1RoboInfusionFreq;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'infusionStartDate'?: Commonpbv1Date;
    /**
     * Substitutions is a list of substitutions to apply to the recommended portfolio.
     * @type {Array<V1RoboAssetSubstitution>}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'substitutions'?: Array<V1RoboAssetSubstitution>;
    /**
     * 
     * @type {string}
     * @memberof RoboServiceUpdateRoboGeneralInvestmentRequest
     */
    'reason'?: string;
}


/**
 * 
 * @export
 * @interface Robopbv1WithdrawRequest
 */
export interface Robopbv1WithdrawRequest {
    /**
     * 
     * @type {V1RoboUid}
     * @memberof Robopbv1WithdrawRequest
     */
    'uid'?: V1RoboUid;
    /**
     * Amount to withdraw from the goal.
     * @type {string}
     * @memberof Robopbv1WithdrawRequest
     */
    'amount'?: string;
    /**
     * WithdrawAll indicates that the entire goal should be withdrawn. If true, the amount field is ignored.
     * @type {boolean}
     * @memberof Robopbv1WithdrawRequest
     */
    'withdrawAll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Robopbv1WithdrawRequest
     */
    'targetAccount'?: string;
    /**
     * WithholdingYear is the year to attribute the goal withdrawal to. Only required for retirement account type goals.
     * @type {number}
     * @memberof Robopbv1WithdrawRequest
     */
    'withholdingYear'?: number;
    /**
     * WithholdingPct is the percentage of withdrawal to withold for tax purposes. Whole number percentages only, for example 15 -> 15%.
     * @type {number}
     * @memberof Robopbv1WithdrawRequest
     */
    'withholdingPct'?: number;
    /**
     * 
     * @type {string}
     * @memberof Robopbv1WithdrawRequest
     */
    'externalAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Robopbv1WithdrawRequest
     */
    'portfolioId'?: string;
}
/**
 * 
 * @export
 * @interface S3pbv1GetLinkResponse
 */
export interface S3pbv1GetLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof S3pbv1GetLinkResponse
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface TradeOrderSendAll
 */
export interface TradeOrderSendAll {
    /**
     * Amount is the total amount to transact. Base or Quote depends on the side of the trade. This value is only used internally. If the requestor populates this value, it will be ignored.
     * @type {string}
     * @memberof TradeOrderSendAll
     */
    'amount'?: string;
}
/**
 * 
 * @export
 * @interface TradeServiceSkipRepeatTradeRequest
 */
export interface TradeServiceSkipRepeatTradeRequest {
    /**
     * count is the number of times to skip the rule. If zero, the call will return an error.
     * @type {number}
     * @memberof TradeServiceSkipRepeatTradeRequest
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface TradeServiceUpdateRepeatTradeRequest
 */
export interface TradeServiceUpdateRepeatTradeRequest {
    /**
     * 
     * @type {V1RecurringRuleInterval}
     * @memberof TradeServiceUpdateRepeatTradeRequest
     */
    'interval'?: V1RecurringRuleInterval;
    /**
     * Amount is the amount in USD to buy the asset.
     * @type {string}
     * @memberof TradeServiceUpdateRepeatTradeRequest
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeServiceUpdateRepeatTradeRequest
     */
    'fundingAccountUid'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof TradeServiceUpdateRepeatTradeRequest
     */
    'next'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof TradeServiceUpdateRepeatTradeRequest
     */
    'end'?: Commonpbv1Date;
}


/**
 * 
 * @export
 * @interface TradeServiceUpdateTradeRequest
 */
export interface TradeServiceUpdateTradeRequest {
    /**
     * 
     * @type {V1TradeOrder}
     * @memberof TradeServiceUpdateTradeRequest
     */
    'tradeOrder'?: V1TradeOrder;
}
/**
 * 
 * @export
 * @interface TransferServiceSkipRepeatTransferRequest
 */
export interface TransferServiceSkipRepeatTransferRequest {
    /**
     * Count is the number of times to skip the rule. If zero, the call will return an error.
     * @type {number}
     * @memberof TransferServiceSkipRepeatTransferRequest
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface TransferServiceUpdateRepeatTransferRequest
 */
export interface TransferServiceUpdateRepeatTransferRequest {
    /**
     * Amount is the amount to deposit on a schemedulte.
     * @type {string}
     * @memberof TransferServiceUpdateRepeatTransferRequest
     */
    'amount'?: string;
    /**
     * 
     * @type {V1RecurringRuleInterval}
     * @memberof TransferServiceUpdateRepeatTransferRequest
     */
    'interval'?: V1RecurringRuleInterval;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof TransferServiceUpdateRepeatTransferRequest
     */
    'next'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof TransferServiceUpdateRepeatTransferRequest
     */
    'end'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof TransferServiceUpdateRepeatTransferRequest
     */
    'fundingAccountUid'?: string;
}


/**
 * 
 * @export
 * @interface Userpbv1CreateUserRequest
 */
export interface Userpbv1CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'ssn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {V1UserPhoneNumberType}
     * @memberof Userpbv1CreateUserRequest
     */
    'phoneNumberType'?: V1UserPhoneNumberType;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'streetAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserRequest
     */
    'country'?: string;
}


/**
 * 
 * @export
 * @interface Userpbv1CreateUserResponse
 */
export interface Userpbv1CreateUserResponse {
    /**
     * 
     * @type {string}
     * @memberof Userpbv1CreateUserResponse
     */
    'userUid'?: string;
}
/**
 * 
 * @export
 * @interface Userpbv1EmploymentInfo
 */
export interface Userpbv1EmploymentInfo {
    /**
     * 
     * @type {string}
     * @memberof Userpbv1EmploymentInfo
     */
    'employerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1EmploymentInfo
     */
    'jobPosition'?: string;
}
/**
 * 
 * @export
 * @interface Userpbv1OtherSourcesOfWealth
 */
export interface Userpbv1OtherSourcesOfWealth {
    /**
     * 
     * @type {boolean}
     * @memberof Userpbv1OtherSourcesOfWealth
     */
    'hasOtherSourcesOfWealth'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Userpbv1OtherSourcesOfWealth
     */
    'otherSourcesOfWealth'?: string;
}
/**
 * 
 * @export
 * @interface V1AccountBeneficiaryElection
 */
export interface V1AccountBeneficiaryElection {
    /**
     * 
     * @type {Array<Pbv1Beneficiary>}
     * @memberof V1AccountBeneficiaryElection
     */
    'primary'?: Array<Pbv1Beneficiary>;
    /**
     * 
     * @type {Array<Pbv1Beneficiary>}
     * @memberof V1AccountBeneficiaryElection
     */
    'contingent'?: Array<Pbv1Beneficiary>;
}
/**
 * 
 * @export
 * @interface V1AddAdvisoryFeeScheduleRequest
 */
export interface V1AddAdvisoryFeeScheduleRequest {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1AddAdvisoryFeeScheduleRequest
     */
    'effectiveDate'?: Commonpbv1Date;
    /**
     * 
     * @type {Array<V1RateBracket>}
     * @memberof V1AddAdvisoryFeeScheduleRequest
     */
    'feeBrackets'?: Array<V1RateBracket>;
    /**
     * 
     * @type {Array<AddAdvisoryFeeScheduleRequestAssetRebate>}
     * @memberof V1AddAdvisoryFeeScheduleRequest
     */
    'assetRebates'?: Array<AddAdvisoryFeeScheduleRequestAssetRebate>;
}
/**
 * 
 * @export
 * @interface V1AddAdvisoryFeeScheduleResponse
 */
export interface V1AddAdvisoryFeeScheduleResponse {
    /**
     * ScheduleId is the id of the schedule that was created.
     * @type {string}
     * @memberof V1AddAdvisoryFeeScheduleResponse
     */
    'scheduleId'?: string;
}
/**
 * 
 * @export
 * @interface V1AddDocumentSetRequest
 */
export interface V1AddDocumentSetRequest {
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'driversLicense'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'stateIdCard'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'passport'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'militaryId'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'ssnCard'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'ssaLetter'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'irsItinLetter'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'otherGovernmentId'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'cddDocument'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'allPassingCipResults'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'signatureImage'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'idDocument'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'accountTransferForm'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'affiliatedApproval'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'depositExplanation'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'identificationCard'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'iraDepositSlip'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'limitedMarginAgreement'?: AddDocumentSetRequestSingleSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestTwoSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'nationalIdCard'?: AddDocumentSetRequestTwoSidedDocument;
    /**
     * 
     * @type {AddDocumentSetRequestOtherDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'other'?: AddDocumentSetRequestOtherDocument;
    /**
     * 
     * @type {AddDocumentSetRequestSingleSidedDocument}
     * @memberof V1AddDocumentSetRequest
     */
    'transferOnDeathAgreement'?: AddDocumentSetRequestSingleSidedDocument;
}
/**
 * 
 * @export
 * @interface V1AddDocumentSetResponse
 */
export interface V1AddDocumentSetResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AddDocumentSetResponse
     */
    'uid'?: string;
}
/**
 * 
 * @export
 * @interface V1AddDocumentToInvestigationRequest
 */
export interface V1AddDocumentToInvestigationRequest {
    /**
     * 
     * @type {string}
     * @memberof V1AddDocumentToInvestigationRequest
     */
    'documentSetUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AddDocumentToInvestigationRequest
     */
    'investigationUid'?: string;
    /**
     * 
     * @type {V1InvestigationDocumentTag}
     * @memberof V1AddDocumentToInvestigationRequest
     */
    'tag'?: V1InvestigationDocumentTag;
    /**
     * 
     * @type {string}
     * @memberof V1AddDocumentToInvestigationRequest
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface V1AddToBulkOrderResponse
 */
export interface V1AddToBulkOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AddToBulkOrderResponse
     */
    'orderUid'?: string;
}
/**
 * 
 * @export
 * @interface V1AdminServiceGetAuthorizeUrlRequest
 */
export interface V1AdminServiceGetAuthorizeUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceGetAuthorizeUrlRequest
     */
    'email'?: string;
    /**
     * RedirectUri - location where the authorization server sends the user once the app has been successfully authorized and granted an authorization code or access token.
     * @type {string}
     * @memberof V1AdminServiceGetAuthorizeUrlRequest
     */
    'redirectUri'?: string;
}
/**
 * 
 * @export
 * @interface V1AdminServiceGetAuthorizeUrlResponse
 */
export interface V1AdminServiceGetAuthorizeUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceGetAuthorizeUrlResponse
     */
    'authorizeUrl'?: string;
}
/**
 * 
 * @export
 * @interface V1AdminServiceRegisterRequest
 */
export interface V1AdminServiceRegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterRequest
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface V1AdminServiceRegisterResponse
 */
export interface V1AdminServiceRegisterResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterResponse
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AdminServiceRegisterResponse
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface V1AdvisoryKYCParameters
 */
export interface V1AdvisoryKYCParameters {
    /**
     * 
     * @type {V1UserRiskTolerance}
     * @memberof V1AdvisoryKYCParameters
     */
    'riskTolerance'?: V1UserRiskTolerance;
    /**
     * 
     * @type {V1UserInvestmentObjective}
     * @memberof V1AdvisoryKYCParameters
     */
    'investmentObjective'?: V1UserInvestmentObjective;
    /**
     * 
     * @type {V1UserAnnualIncome}
     * @memberof V1AdvisoryKYCParameters
     */
    'annualIncomeRange'?: V1UserAnnualIncome;
    /**
     * 
     * @type {V1UserNetWorth}
     * @memberof V1AdvisoryKYCParameters
     */
    'netWorthRange'?: V1UserNetWorth;
    /**
     * 
     * @type {V1UserEmploymentStatus}
     * @memberof V1AdvisoryKYCParameters
     */
    'employmentStatus'?: V1UserEmploymentStatus;
    /**
     * 
     * @type {Userpbv1EmploymentInfo}
     * @memberof V1AdvisoryKYCParameters
     */
    'employmentInfo'?: Userpbv1EmploymentInfo;
}


/**
 * 
 * @export
 * @interface V1AffiliatedExchangeOrFINRADetails
 */
export interface V1AffiliatedExchangeOrFINRADetails {
    /**
     * The name of the firm the user is affiliated with.
     * @type {string}
     * @memberof V1AffiliatedExchangeOrFINRADetails
     */
    'firmName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1AffiliatedExchangeOrFINRADetails
     */
    'isAffiliated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1AffiliatedExchangeOrFINRADetails
     */
    'isAffiliatedDiscretionaryRegulatedEntity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1AffiliatedExchangeOrFINRADetails
     */
    'isAffiliatedNonDiscretionaryRegulatedEntity'?: boolean;
}
/**
 * 
 * @export
 * @interface V1AnalyzeGoalRequest
 */
export interface V1AnalyzeGoalRequest {
    /**
     * 
     * @type {V1GoalParameters}
     * @memberof V1AnalyzeGoalRequest
     */
    'parameters'?: V1GoalParameters;
    /**
     * 
     * @type {V1UserRiskTolerance}
     * @memberof V1AnalyzeGoalRequest
     */
    'riskProfile'?: V1UserRiskTolerance;
    /**
     * GoalUID is optional here and should be set when manually updating goal parameters.
     * @type {string}
     * @memberof V1AnalyzeGoalRequest
     */
    'goalUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AnalyzeGoalRequest
     */
    'withdraw'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1AnalyzeGoalRequest
     */
    'deposit'?: string;
}


/**
 * 
 * @export
 * @interface V1AnalyzeGoalResponse
 */
export interface V1AnalyzeGoalResponse {
    /**
     * 
     * @type {V1GoalProjection}
     * @memberof V1AnalyzeGoalResponse
     */
    'projection'?: V1GoalProjection;
    /**
     * RecommendedPortfolio is the uid of the recommended portfolio.
     * @type {string}
     * @memberof V1AnalyzeGoalResponse
     */
    'recommendedPortfolio'?: string;
}
/**
 * 
 * @export
 * @interface V1ApexAccountParameters
 */
export interface V1ApexAccountParameters {
    /**
     * 
     * @type {string}
     * @memberof V1ApexAccountParameters
     */
    'id'?: string;
    /**
     * 
     * @type {V1ApexApplicationStatus}
     * @memberof V1ApexAccountParameters
     */
    'accountStatus'?: V1ApexApplicationStatus;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1ApexApplicationStatus = {
    Unspecified: 'APEX_APPLICATION_STATUS_UNSPECIFIED',
    New: 'APEX_APPLICATION_STATUS_NEW',
    Pending: 'APEX_APPLICATION_STATUS_PENDING',
    VendorRequestSubmitted: 'APEX_APPLICATION_STATUS_VENDOR_REQUEST_SUBMITTED',
    InvestigationSubmitted: 'APEX_APPLICATION_STATUS_INVESTIGATION_SUBMITTED',
    ReadyForBackOffice: 'APEX_APPLICATION_STATUS_READY_FOR_BACK_OFFICE',
    BackOffice: 'APEX_APPLICATION_STATUS_BACK_OFFICE',
    AccountSetup: 'APEX_APPLICATION_STATUS_ACCOUNT_SETUP',
    Complete: 'APEX_APPLICATION_STATUS_COMPLETE',
    ActionRequired: 'APEX_APPLICATION_STATUS_ACTION_REQUIRED',
    Rejected: 'APEX_APPLICATION_STATUS_REJECTED',
    Suspended: 'APEX_APPLICATION_STATUS_SUSPENDED',
    Error: 'APEX_APPLICATION_STATUS_ERROR',
    Canceled: 'APEX_APPLICATION_STATUS_CANCELED'
} as const;

export type V1ApexApplicationStatus = typeof V1ApexApplicationStatus[keyof typeof V1ApexApplicationStatus];


/**
 * 
 * @export
 * @interface V1AppealApexApplicationRequest
 */
export interface V1AppealApexApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof V1AppealApexApplicationRequest
     */
    'userUid'?: string;
    /**
     * UserUid investigation_uid the investigation that the appeal is associated with.
     * @type {string}
     * @memberof V1AppealApexApplicationRequest
     */
    'investigationUid'?: string;
    /**
     * Comment explains why the application is being appealed.
     * @type {string}
     * @memberof V1AppealApexApplicationRequest
     */
    'reason'?: string;
}
/**
 * AssetID represents as an asset\'s basic information in the system. This can be used to get additional asset information. The uid is the only field required but adding the type can make queries more efficient.
 * @export
 * @interface V1AssetID
 */
export interface V1AssetID {
    /**
     * Uid is a unique identifier for the asset.
     * @type {string}
     * @memberof V1AssetID
     */
    'uid'?: string;
    /**
     * 
     * @type {V1AssetType}
     * @memberof V1AssetID
     */
    'type'?: V1AssetType;
}


/**
 * AssetType enumerates the different types of assets supported in our system.
 * @export
 * @enum {string}
 */

export const V1AssetType = {
    Unspecified: 'ASSET_TYPE_UNSPECIFIED',
    Fiat: 'ASSET_TYPE_FIAT',
    Security: 'ASSET_TYPE_SECURITY',
    Crypto: 'ASSET_TYPE_CRYPTO'
} as const;

export type V1AssetType = typeof V1AssetType[keyof typeof V1AssetType];


/**
 * 
 * @export
 * @interface V1AssociateSoftwareTokenResponse
 */
export interface V1AssociateSoftwareTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof V1AssociateSoftwareTokenResponse
     */
    'secretCode'?: string;
}
/**
 * 
 * @export
 * @interface V1AssociateTokenRequest
 */
export interface V1AssociateTokenRequest {
    /**
     * Token is the remote authentication system\'s session token to be associated with the user.
     * @type {string}
     * @memberof V1AssociateTokenRequest
     */
    'token'?: string;
    /**
     * Payload is any required information needed to validate the token and is dependent on the remote authentication system.
     * @type {{ [key: string]: string; }}
     * @memberof V1AssociateTokenRequest
     */
    'payload'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface V1BalanceChangeHistory
 */
export interface V1BalanceChangeHistory {
    /**
     * 
     * @type {string}
     * @memberof V1BalanceChangeHistory
     */
    'primitiveAccountUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1BalanceChangeHistory
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1BalanceChangeHistory
     */
    'initialBalance'?: string;
    /**
     * BalanceChanges is the balance of the asset.
     * @type {Array<string>}
     * @memberof V1BalanceChangeHistory
     */
    'balanceChanges'?: Array<string>;
    /**
     * Timestampt is the time of the balance change.
     * @type {Array<string>}
     * @memberof V1BalanceChangeHistory
     */
    'timestamps'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1BeneficiaryRelationType = {
    Unspecified: 'BENEFICIARY_RELATION_TYPE_UNSPECIFIED',
    Spouse: 'BENEFICIARY_RELATION_TYPE_SPOUSE',
    Trust: 'BENEFICIARY_RELATION_TYPE_TRUST',
    Other: 'BENEFICIARY_RELATION_TYPE_OTHER'
} as const;

export type V1BeneficiaryRelationType = typeof V1BeneficiaryRelationType[keyof typeof V1BeneficiaryRelationType];


/**
 * 
 * @export
 * @interface V1BrokerageAccountParameters
 */
export interface V1BrokerageAccountParameters {
    /**
     * 
     * @type {V1UserInvestmentExperience}
     * @memberof V1BrokerageAccountParameters
     */
    'experienceLevel'?: V1UserInvestmentExperience;
    /**
     * 
     * @type {V1UserInvestmentObjective}
     * @memberof V1BrokerageAccountParameters
     */
    'investmentObjective'?: V1UserInvestmentObjective;
    /**
     * 
     * @type {V1UserTimeHorizon}
     * @memberof V1BrokerageAccountParameters
     */
    'investmentHorizon'?: V1UserTimeHorizon;
    /**
     * 
     * @type {V1UserLiquidityNeeds}
     * @memberof V1BrokerageAccountParameters
     */
    'liquidityNeeds'?: V1UserLiquidityNeeds;
    /**
     * 
     * @type {V1UserRiskTolerance}
     * @memberof V1BrokerageAccountParameters
     */
    'riskTolerance'?: V1UserRiskTolerance;
    /**
     * 
     * @type {V1UserMaritalStatus}
     * @memberof V1BrokerageAccountParameters
     */
    'maritalStatus'?: V1UserMaritalStatus;
    /**
     * 
     * @type {V1UserEmploymentStatus}
     * @memberof V1BrokerageAccountParameters
     */
    'employmentStatus'?: V1UserEmploymentStatus;
    /**
     * 
     * @type {V1UserAnnualIncome}
     * @memberof V1BrokerageAccountParameters
     */
    'annualIncomeRange'?: V1UserAnnualIncome;
    /**
     * 
     * @type {V1UserNetWorth}
     * @memberof V1BrokerageAccountParameters
     */
    'netWorthRange'?: V1UserNetWorth;
    /**
     * 
     * @type {Accountpbv1EmploymentInfo}
     * @memberof V1BrokerageAccountParameters
     */
    'employmentInfo'?: Accountpbv1EmploymentInfo;
}


/**
 * 
 * @export
 * @interface V1BrokerageDiscretionaryAccountParameters
 */
export interface V1BrokerageDiscretionaryAccountParameters {
    /**
     * 
     * @type {V1UserRiskTolerance}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'riskTolerance'?: V1UserRiskTolerance;
    /**
     * 
     * @type {V1UserInvestmentObjective}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'investmentObjective'?: V1UserInvestmentObjective;
    /**
     * 
     * @type {V1UserAnnualIncome}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'annualIncomeRange'?: V1UserAnnualIncome;
    /**
     * 
     * @type {V1UserNetWorth}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'netWorthRange'?: V1UserNetWorth;
    /**
     * 
     * @type {V1UserEmploymentStatus}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'employmentStatus'?: V1UserEmploymentStatus;
    /**
     * 
     * @type {Accountpbv1EmploymentInfo}
     * @memberof V1BrokerageDiscretionaryAccountParameters
     */
    'employmentInfo'?: Accountpbv1EmploymentInfo;
}


/**
 * 
 * @export
 * @interface V1BrokerageKYCParameters
 */
export interface V1BrokerageKYCParameters {
    /**
     * 
     * @type {V1UserInvestmentExperience}
     * @memberof V1BrokerageKYCParameters
     */
    'experienceLevel'?: V1UserInvestmentExperience;
    /**
     * 
     * @type {V1UserInvestmentObjective}
     * @memberof V1BrokerageKYCParameters
     */
    'investmentObjective'?: V1UserInvestmentObjective;
    /**
     * 
     * @type {V1UserTimeHorizon}
     * @memberof V1BrokerageKYCParameters
     */
    'investmentHorizon'?: V1UserTimeHorizon;
    /**
     * 
     * @type {V1UserLiquidityNeeds}
     * @memberof V1BrokerageKYCParameters
     */
    'liquidityNeeds'?: V1UserLiquidityNeeds;
    /**
     * 
     * @type {V1UserRiskTolerance}
     * @memberof V1BrokerageKYCParameters
     */
    'riskTolerance'?: V1UserRiskTolerance;
    /**
     * 
     * @type {V1UserMaritalStatus}
     * @memberof V1BrokerageKYCParameters
     */
    'maritalStatus'?: V1UserMaritalStatus;
    /**
     * 
     * @type {V1UserEmploymentStatus}
     * @memberof V1BrokerageKYCParameters
     */
    'employmentStatus'?: V1UserEmploymentStatus;
    /**
     * 
     * @type {V1UserAnnualIncome}
     * @memberof V1BrokerageKYCParameters
     */
    'annualIncomeRange'?: V1UserAnnualIncome;
    /**
     * 
     * @type {V1UserNetWorth}
     * @memberof V1BrokerageKYCParameters
     */
    'netWorthRange'?: V1UserNetWorth;
    /**
     * 
     * @type {Userpbv1EmploymentInfo}
     * @memberof V1BrokerageKYCParameters
     */
    'employmentInfo'?: Userpbv1EmploymentInfo;
}


/**
 * 
 * @export
 * @interface V1BusinessDayStatus
 */
export interface V1BusinessDayStatus {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1BusinessDayStatus
     */
    'date'?: Commonpbv1Date;
    /**
     * 
     * @type {V1MarketStatus}
     * @memberof V1BusinessDayStatus
     */
    'marketStatus'?: V1MarketStatus;
    /**
     * Open is the timestamp of the first open of the day.
     * @type {string}
     * @memberof V1BusinessDayStatus
     */
    'open'?: string;
    /**
     * Close is the timestamp of the last close of the day.
     * @type {string}
     * @memberof V1BusinessDayStatus
     */
    'close'?: string;
    /**
     * AdditionalStatus designates special periods of time throughout the day, such as Pre-Market and maintenance windows.
     * @type {Array<V1BusinessHourStatus>}
     * @memberof V1BusinessDayStatus
     */
    'additionalStatus'?: Array<V1BusinessHourStatus>;
}


/**
 * BusinessHourStatus represents an additional status of business and the hours where that status applies.
 * @export
 * @interface V1BusinessHourStatus
 */
export interface V1BusinessHourStatus {
    /**
     * 
     * @type {V1SpecialHoursStatus}
     * @memberof V1BusinessHourStatus
     */
    'status'?: V1SpecialHoursStatus;
    /**
     * 
     * @type {string}
     * @memberof V1BusinessHourStatus
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1BusinessHourStatus
     */
    'end'?: string;
}


/**
 * 
 * @export
 * @interface V1CancelPendingApplicationRequest
 */
export interface V1CancelPendingApplicationRequest {
    /**
     * UserUid is the user that the Apex application is associated with.
     * @type {string}
     * @memberof V1CancelPendingApplicationRequest
     */
    'userAccountUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CancelPendingApplicationRequest
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface V1CancelPendingApplicationResponse
 */
export interface V1CancelPendingApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CancelPendingApplicationResponse
     */
    'accountCancelRequestUid'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1ChallengeName = {
    TypeUnspecified: 'CHALLENGE_NAME_TYPE_UNSPECIFIED',
    SmsMfa: 'CHALLENGE_NAME_SMS_MFA',
    SoftwareTokenMfa: 'CHALLENGE_NAME_SOFTWARE_TOKEN_MFA',
    SelectMfaType: 'CHALLENGE_NAME_SELECT_MFA_TYPE',
    MfaSetup: 'CHALLENGE_NAME_MFA_SETUP',
    PasswordVerifier: 'CHALLENGE_NAME_PASSWORD_VERIFIER',
    CustomChallenge: 'CHALLENGE_NAME_CUSTOM_CHALLENGE',
    DeviceSrpAuth: 'CHALLENGE_NAME_DEVICE_SRP_AUTH',
    DevicePasswordVerifier: 'CHALLENGE_NAME_DEVICE_PASSWORD_VERIFIER',
    AdminNoSrpAuth: 'CHALLENGE_NAME_ADMIN_NO_SRP_AUTH',
    NewPasswordRequired: 'CHALLENGE_NAME_NEW_PASSWORD_REQUIRED'
} as const;

export type V1ChallengeName = typeof V1ChallengeName[keyof typeof V1ChallengeName];


/**
 * 
 * @export
 * @interface V1CheckUniquenessRequest
 */
export interface V1CheckUniquenessRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CheckUniquenessRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CheckUniquenessRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CheckUniquenessRequest
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface V1CheckUniquenessResponse
 */
export interface V1CheckUniquenessResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1CheckUniquenessResponse
     */
    'username'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1CheckUniquenessResponse
     */
    'email'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1CheckUniquenessResponse
     */
    'phoneNumber'?: boolean;
}
/**
 * CheckUserExistsRequest is the request message for CheckUserExists.
 * @export
 * @interface V1CheckUserExistsRequest
 */
export interface V1CheckUserExistsRequest {
    /**
     * 
     * @type {V1UserContactInfo}
     * @memberof V1CheckUserExistsRequest
     */
    'info'?: V1UserContactInfo;
}
/**
 * ClaimUserRequest is the request message for ClaimUser.
 * @export
 * @interface V1ClaimUserRequest
 */
export interface V1ClaimUserRequest {
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'emailVerificationToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'phoneVerificationToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ClaimUserRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface V1ClearBeneficiarySetResponse
 */
export interface V1ClearBeneficiarySetResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1ClearBeneficiarySetResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1ConfirmForgotPasswordRequest
 */
export interface V1ConfirmForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof V1ConfirmForgotPasswordRequest
     */
    'confirmationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ConfirmForgotPasswordRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ConfirmForgotPasswordRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface V1ConnectAccountRequest
 */
export interface V1ConnectAccountRequest {
    /**
     * AccountId is the account id of the partner institution. It must be the agreed upon account id between the partner institution and the clearing house.
     * @type {string}
     * @memberof V1ConnectAccountRequest
     */
    'accountId'?: string;
    /**
     * ICTPartnerInstitutionId is the authorized entity (brokerage/advisory) that is allowed to use this account. If only a single entity exists then this field may be omitted.
     * @type {string}
     * @memberof V1ConnectAccountRequest
     */
    'ictPartnerInstitutionId'?: string;
}
/**
 * 
 * @export
 * @interface V1ConnectAccountResponse
 */
export interface V1ConnectAccountResponse {
    /**
     * ExternalAccountId is the id of the newly created account which should be used to reference this connection in future requests.
     * @type {string}
     * @memberof V1ConnectAccountResponse
     */
    'externalAccountId'?: string;
}
/**
 * 
 * @export
 * @interface V1ControlPersonDetails
 */
export interface V1ControlPersonDetails {
    /**
     * List of company symbols the user is a control person of.
     * @type {Array<string>}
     * @memberof V1ControlPersonDetails
     */
    'companySymbols'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof V1ControlPersonDetails
     */
    'isControlPerson'?: boolean;
}
/**
 * 
 * @export
 * @interface V1ConvertSamlToHtmlFormRequest
 */
export interface V1ConvertSamlToHtmlFormRequest {
    /**
     * 
     * @type {string}
     * @memberof V1ConvertSamlToHtmlFormRequest
     */
    'SAMLResponse'?: string;
}
/**
 * 
 * @export
 * @interface V1ConvertSamlToHtmlFormResponse
 */
export interface V1ConvertSamlToHtmlFormResponse {
    /**
     * 
     * @type {string}
     * @memberof V1ConvertSamlToHtmlFormResponse
     */
    'content'?: string;
}
/**
 * 
 * @export
 * @interface V1ConvertUIDResponse
 */
export interface V1ConvertUIDResponse {
    /**
     * 
     * @type {string}
     * @memberof V1ConvertUIDResponse
     */
    'stringUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ConvertUIDResponse
     */
    'bytesUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ConvertUIDResponse
     */
    'base64Rep'?: string;
}
/**
 * CostBasisValue is the cost basis for an asset.
 * @export
 * @interface V1CostBasisValue
 */
export interface V1CostBasisValue {
    /**
     * 
     * @type {string}
     * @memberof V1CostBasisValue
     */
    'assetUid'?: string;
    /**
     * 
     * @type {number}
     * @memberof V1CostBasisValue
     */
    'costBasis'?: number;
}
/**
 * 
 * @export
 * @interface V1CreateAccountRequest
 */
export interface V1CreateAccountRequest {
    /**
     * 
     * @type {Pbv1AccountType}
     * @memberof V1CreateAccountRequest
     */
    'accountType'?: Pbv1AccountType;
    /**
     * 
     * @type {V1BrokerageAccountParameters}
     * @memberof V1CreateAccountRequest
     */
    'brokerage'?: V1BrokerageAccountParameters;
    /**
     * 
     * @type {V1BrokerageDiscretionaryAccountParameters}
     * @memberof V1CreateAccountRequest
     */
    'discretionary'?: V1BrokerageDiscretionaryAccountParameters;
    /**
     * 
     * @type {V1IRAAccountParameters}
     * @memberof V1CreateAccountRequest
     */
    'ira'?: V1IRAAccountParameters;
    /**
     * 
     * @type {V1RothIRAAccountParameters}
     * @memberof V1CreateAccountRequest
     */
    'rothIra'?: V1RothIRAAccountParameters;
    /**
     * 
     * @type {Accountpbv1TrustedContact}
     * @memberof V1CreateAccountRequest
     */
    'trustedContact'?: Accountpbv1TrustedContact;
    /**
     * 
     * @type {V1ApexAccountParameters}
     * @memberof V1CreateAccountRequest
     */
    'apex'?: V1ApexAccountParameters;
    /**
     * ProgramEnrollmentOptions is used to enroll a user in one of the offered programs (e.g. Cash Sweep).
     * @type {Array<V1ProgramEnrollmentOptions>}
     * @memberof V1CreateAccountRequest
     */
    'programEnrollments'?: Array<V1ProgramEnrollmentOptions>;
}


/**
 * 
 * @export
 * @interface V1CreateAccountResponse
 */
export interface V1CreateAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateAccountResponse
     */
    'accountUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateAccountResponse
     */
    'userUid'?: string;
    /**
     * 
     * @type {Accountpbv1AccountStatus}
     * @memberof V1CreateAccountResponse
     */
    'accountStatus'?: Accountpbv1AccountStatus;
}


/**
 * 
 * @export
 * @interface V1CreateAdminOrderRequest
 */
export interface V1CreateAdminOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<CreateAdminOrderRequestAssetTransfer>}
     * @memberof V1CreateAdminOrderRequest
     */
    'transfers'?: Array<CreateAdminOrderRequestAssetTransfer>;
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V1CreateAdminOrderRequest
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderRequest
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateAdminOrderResponse
 */
export interface V1CreateAdminOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateAdminOrderResponse
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateApexAccountRequest
 */
export interface V1CreateApexAccountRequest {
    /**
     * The UUID of the user account for which the new account request is being submitted.
     * @type {string}
     * @memberof V1CreateApexAccountRequest
     */
    'userAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateApexAccountResponse
 */
export interface V1CreateApexAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateApexAccountResponse
     */
    'apexAccountId'?: string;
    /**
     * 
     * @type {Accountpbv1AccountStatus}
     * @memberof V1CreateApexAccountResponse
     */
    'accountStatus'?: Accountpbv1AccountStatus;
    /**
     * 
     * @type {string}
     * @memberof V1CreateApexAccountResponse
     */
    'externalRequestId'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateAssetResponse
 */
export interface V1CreateAssetResponse {
    /**
     * 
     * @type {Pbv1Asset}
     * @memberof V1CreateAssetResponse
     */
    'asset'?: Pbv1Asset;
}
/**
 * 
 * @export
 * @interface V1CreateCreditRequest
 */
export interface V1CreateCreditRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {V1CreditType}
     * @memberof V1CreateCreditRequest
     */
    'type'?: V1CreditType;
    /**
     * Title is the title of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'title'?: string;
    /**
     * Description is the description of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'description'?: string;
    /**
     * Amount is the amount to transfer with this order request.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'amount'?: string;
    /**
     * AccountDescription is the explanation that appears in the user\'s statement. If not provided, the title will be used.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'accountDescription'?: string;
    /**
     * Note is an admin note that is not displayed to the user.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'note'?: string;
    /**
     * AccountId is the id of the account that should be charged the fee. If not provided, the portfolio ids below will be used to determine the account.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'accountId'?: string;
    /**
     * Distributions details how the fee should be distributed among the portfolios in the user\'s account. All portfolio ids must be part of the same account. May be ommitted if the account_id is provided and only one portfolio is in the account. All amounts must sum to the amount in the request.
     * @type {Array<V1FeeAndCreditDistribution>}
     * @memberof V1CreateCreditRequest
     */
    'distributions'?: Array<V1FeeAndCreditDistribution>;
    /**
     * ClientRequestId is the id of the request that is being made by the client to ensure that requests are not duplicated. The request id should be unique for the user. It is recommended that the client use a time based id format like a ulid or uuid-v4.
     * @type {string}
     * @memberof V1CreateCreditRequest
     */
    'clientRequestId'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateCreditResponse
 */
export interface V1CreateCreditResponse {
    /**
     * SubmissionId is the id of the submission that was created for the fee.
     * @type {string}
     * @memberof V1CreateCreditResponse
     */
    'submissionId'?: string;
    /**
     * OrderIds are the individual order ids of the orders that were created for the fee.
     * @type {Array<string>}
     * @memberof V1CreateCreditResponse
     */
    'orderIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1CreateDepositSummaryRequest
 */
export interface V1CreateDepositSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateDepositSummaryRequest
     */
    'externalAccountUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateDepositSummaryRequest
     */
    'amount'?: string;
    /**
     * PortfolioUid is the uid of the portfolio that the transfer is being executed in.
     * @type {string}
     * @memberof V1CreateDepositSummaryRequest
     */
    'portfolioUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateDepositSummaryResponse
 */
export interface V1CreateDepositSummaryResponse {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateDepositSummaryResponse
     */
    'expectedSettlementDate'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateDepositSummaryResponse
     */
    'expectedUnsettledDate'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof V1CreateDepositSummaryResponse
     */
    'amountAvailableInstantly'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateDepositSummaryResponse
     */
    'amountAvailableAfterSettle'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateFeeRequest
 */
export interface V1CreateFeeRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {V1FeeType}
     * @memberof V1CreateFeeRequest
     */
    'type'?: V1FeeType;
    /**
     * Title is the title of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'title'?: string;
    /**
     * Description is the description of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'description'?: string;
    /**
     * Amount is the amount to transfer with this order request.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'amount'?: string;
    /**
     * AccountDescription is the explanation that appears in the user\'s statement. If not provided, the title will be used.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'accountDescription'?: string;
    /**
     * Note is an admin note that is not displayed to the user.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'note'?: string;
    /**
     * AccountId is the id of the account that should be charged the fee. If not provided, the portfolio ids below will be used to determine the account.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'accountId'?: string;
    /**
     * Distributions details how the fee should be distributed among the portfolios in the user\'s account. All portfolio ids must be part of the same account. May be ommitted if the account_id is provided and only one portfolio is in the account. All amounts must sum to the amount in the request.
     * @type {Array<V1FeeAndCreditDistribution>}
     * @memberof V1CreateFeeRequest
     */
    'distributions'?: Array<V1FeeAndCreditDistribution>;
    /**
     * ClientRequestId is the id of the request that is being made by the client to ensure that requests are not duplicated. The request id should be unique for the user. It is recommended that the client use a time based id format like a ulid or uuid-v4.
     * @type {string}
     * @memberof V1CreateFeeRequest
     */
    'clientRequestId'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateFeeResponse
 */
export interface V1CreateFeeResponse {
    /**
     * SubmissionId is the id of the submission that was created for the fee.
     * @type {string}
     * @memberof V1CreateFeeResponse
     */
    'submissionId'?: string;
    /**
     * OrderIds are the individual order ids of the orders that were created for the fee.
     * @type {Array<string>}
     * @memberof V1CreateFeeResponse
     */
    'orderIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1CreateLinkTokenForUpdateModeResponse
 */
export interface V1CreateLinkTokenForUpdateModeResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateLinkTokenForUpdateModeResponse
     */
    'linkToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateLinkTokenForUpdateModeResponse
     */
    'expiration'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateLinkTokenResponse
 */
export interface V1CreateLinkTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateLinkTokenResponse
     */
    'linkToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateLinkTokenResponse
     */
    'expiration'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateNewLevelSetRequest
 */
export interface V1CreateNewLevelSetRequest {
    /**
     * levels are the portfolio levels to be created as part of the level set. The order of the submitted levels will be used as the index of the level.
     * @type {Array<CreateNewLevelSetRequestPortfolioLevel>}
     * @memberof V1CreateNewLevelSetRequest
     */
    'levels'?: Array<CreateNewLevelSetRequestPortfolioLevel>;
}
/**
 * 
 * @export
 * @interface V1CreateNewLevelSetResponse
 */
export interface V1CreateNewLevelSetResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateNewLevelSetResponse
     */
    'levelSetId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateNoteRequest
 */
export interface V1CreateNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateNoteRequest
     */
    'objectId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof V1CreateNoteRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof V1CreateNoteRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateNoteResponse
 */
export interface V1CreateNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateNoteResponse
     */
    'noteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateNoteResponse
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface V1CreatePrimitiveTransferResponse
 */
export interface V1CreatePrimitiveTransferResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreatePrimitiveTransferResponse
     */
    'orderUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreatePublicTokenRequest
 */
export interface V1CreatePublicTokenRequest {
    /**
     * RelationshipOwner is uid of the plaid relationship to link the account with.
     * @type {string}
     * @memberof V1CreatePublicTokenRequest
     */
    'relationshipOwnerUid'?: string;
    /**
     * InstitutionId is the id of the institution to create public token for.
     * @type {string}
     * @memberof V1CreatePublicTokenRequest
     */
    'institutionId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreatePublicTokenResponse
 */
export interface V1CreatePublicTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreatePublicTokenResponse
     */
    'publicToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreatePublicTokenResponse
     */
    'requestId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateReconOrderRequest
 */
export interface V1CreateReconOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateReconOrderRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<CreateReconOrderRequestAssets>}
     * @memberof V1CreateReconOrderRequest
     */
    'assets'?: Array<CreateReconOrderRequestAssets>;
    /**
     * 
     * @type {string}
     * @memberof V1CreateReconOrderRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateReconOrderRequest
     */
    'eventTime'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateReconOrderResponse
 */
export interface V1CreateReconOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateReconOrderResponse
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateRepeatTradeRequest
 */
export interface V1CreateRepeatTradeRequest {
    /**
     * 
     * @type {V1RecurringRuleInterval}
     * @memberof V1CreateRepeatTradeRequest
     */
    'interval'?: V1RecurringRuleInterval;
    /**
     * Amount is the amount in USD to buy the asset.
     * @type {string}
     * @memberof V1CreateRepeatTradeRequest
     */
    'amount'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateRepeatTradeRequest
     */
    'start'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateRepeatTradeRequest
     */
    'end'?: Commonpbv1Date;
    /**
     * AssetUid is the asset to buy.
     * @type {string}
     * @memberof V1CreateRepeatTradeRequest
     */
    'assetUid'?: string;
    /**
     * SectorUid can be optionally set and will select invest in the sector with the given uid.
     * @type {string}
     * @memberof V1CreateRepeatTradeRequest
     */
    'sectorUid'?: string;
    /**
     * PortfolioUid is the uid of the portfolio that the trade is being executed in.
     * @type {string}
     * @memberof V1CreateRepeatTradeRequest
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateRepeatTradeRequest
     */
    'fundingAccountUid'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateRepeatTradeResponse
 */
export interface V1CreateRepeatTradeResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateRepeatTradeResponse
     */
    'ruleUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateRepeatTransferRequest
 */
export interface V1CreateRepeatTransferRequest {
    /**
     * Amount is the amount to deposit on a schemedulte.
     * @type {string}
     * @memberof V1CreateRepeatTransferRequest
     */
    'amount'?: string;
    /**
     * 
     * @type {V1RecurringRuleInterval}
     * @memberof V1CreateRepeatTransferRequest
     */
    'interval'?: V1RecurringRuleInterval;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateRepeatTransferRequest
     */
    'start'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateRepeatTransferRequest
     */
    'end'?: Commonpbv1Date;
    /**
     * PortfolioUid is the uid of the portfolio that the transfer is being executed in.
     * @type {string}
     * @memberof V1CreateRepeatTransferRequest
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateRepeatTransferRequest
     */
    'fundingAccountUid'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateRepeatTransferResponse
 */
export interface V1CreateRepeatTransferResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateRepeatTransferResponse
     */
    'ruleUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateResponse
 */
export interface V1CreateResponse {
    /**
     * RecurringRuleUid is the uid of the recurring rule that was created.
     * @type {string}
     * @memberof V1CreateResponse
     */
    'recurringRuleUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateRoboGeneralInvestmentRequest
 */
export interface V1CreateRoboGeneralInvestmentRequest {
    /**
     * 
     * @type {V1RoboGeneralInvestment}
     * @memberof V1CreateRoboGeneralInvestmentRequest
     */
    'investmentDetails'?: V1RoboGeneralInvestment;
    /**
     * enable_auto_infusion grants us flexibility to allow a client to create a robo general investment without having regular infusions set up off the bat. When this is set to false, the funding account uid is not required, and the goal will be created without recurring rules. If no value is provided, the default value (set in tenant configs) will be assumed.
     * @type {boolean}
     * @memberof V1CreateRoboGeneralInvestmentRequest
     */
    'enableAutoInfusion'?: boolean;
}
/**
 * 
 * @export
 * @interface V1CreateRoboGeneralInvestmentResponse
 */
export interface V1CreateRoboGeneralInvestmentResponse {
    /**
     * InvestUid is the uid of the general investment.
     * @type {string}
     * @memberof V1CreateRoboGeneralInvestmentResponse
     */
    'investUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateSubmissionRequest
 */
export interface V1CreateSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateSubmissionRequest
     */
    'questionnaireId'?: string;
    /**
     * List of responses for a given questionnaire.
     * @type {Array<V1QuestionResponse>}
     * @memberof V1CreateSubmissionRequest
     */
    'responses'?: Array<V1QuestionResponse>;
}
/**
 * 
 * @export
 * @interface V1CreateSubmissionResponse
 */
export interface V1CreateSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateSubmissionResponse
     */
    'submissionId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateTradeRequest
 */
export interface V1CreateTradeRequest {
    /**
     * PortfolioUid is the uid of the portfolio that the trade should being executed in.
     * @type {string}
     * @memberof V1CreateTradeRequest
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {V1TradeOrder}
     * @memberof V1CreateTradeRequest
     */
    'tradeOrder'?: V1TradeOrder;
    /**
     * ClientRequestId is the id of the request that is being made by the client to ensure that requests are not duplicated. The request id should be unique for the user. It is recommended that the client use a time based id format like a ulid or uuid-v4.
     * @type {string}
     * @memberof V1CreateTradeRequest
     */
    'clientRequestId'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateTradeResponse
 */
export interface V1CreateTradeResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateTradeResponse
     */
    'orderUid'?: string;
    /**
     * 
     * @type {V1TradeOrder}
     * @memberof V1CreateTradeResponse
     */
    'tradeOrder'?: V1TradeOrder;
}
/**
 * 
 * @export
 * @interface V1CreateTradeSummaryRequest
 */
export interface V1CreateTradeSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateTradeSummaryRequest
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {V1TradeOrder}
     * @memberof V1CreateTradeSummaryRequest
     */
    'tradeOrder'?: V1TradeOrder;
}
/**
 * 
 * @export
 * @interface V1CreateTradeSummaryResponse
 */
export interface V1CreateTradeSummaryResponse {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateTradeSummaryResponse
     */
    'expectedSettlementDate'?: Commonpbv1Date;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateTradeSummaryResponse
     */
    'expectedUnsettledDate'?: Commonpbv1Date;
}
/**
 * 
 * @export
 * @interface V1CreateTransferRequest
 */
export interface V1CreateTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateTransferRequest
     */
    'externalAccountUid'?: string;
    /**
     * 
     * @type {V1TransferType}
     * @memberof V1CreateTransferRequest
     */
    'type'?: V1TransferType;
    /**
     * 
     * @type {string}
     * @memberof V1CreateTransferRequest
     */
    'amount'?: string;
    /**
     * PortfolioUid is the uid of the portfolio that the transfer is being executed in.
     * @type {string}
     * @memberof V1CreateTransferRequest
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {V1TransferRetirementInfo}
     * @memberof V1CreateTransferRequest
     */
    'retirementInfo'?: V1TransferRetirementInfo;
    /**
     * ClientRequestId is the id of the request that is being made by the client to ensure that requests are not duplicated. The request id should be unique for the user. It is recommended that the client use a time based id format like a ulid or uuid-v4.
     * @type {string}
     * @memberof V1CreateTransferRequest
     */
    'clientRequestId'?: string;
}


/**
 * 
 * @export
 * @interface V1CreateTransferResponse
 */
export interface V1CreateTransferResponse {
    /**
     * 
     * @type {string}
     * @memberof V1CreateTransferResponse
     */
    'orderUid'?: string;
}
/**
 * 
 * @export
 * @interface V1CreateTrustedContactResponse
 */
export interface V1CreateTrustedContactResponse {
    /**
     * 
     * @type {Accountpbv1TrustedContactStatus}
     * @memberof V1CreateTrustedContactResponse
     */
    'status'?: Accountpbv1TrustedContactStatus;
}


/**
 * 
 * @export
 * @interface V1CreateUserFromExternalIdpRequest
 */
export interface V1CreateUserFromExternalIdpRequest {
    /**
     * 
     * @type {string}
     * @memberof V1CreateUserFromExternalIdpRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateUserFromExternalIdpRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1CreateUserFromExternalIdpRequest
     */
    'dateOfBirth'?: Commonpbv1Date;
    /**
     * 
     * @type {string}
     * @memberof V1CreateUserFromExternalIdpRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateUserFromExternalIdpRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1CreditType = {
    Unspecified: 'CREDIT_TYPE_UNSPECIFIED',
    FeeReversal: 'CREDIT_TYPE_FEE_REVERSAL',
    Promotional: 'CREDIT_TYPE_PROMOTIONAL',
    Zeroing: 'CREDIT_TYPE_ZEROING',
    Rebate: 'CREDIT_TYPE_REBATE',
    Courtesy: 'CREDIT_TYPE_COURTESY'
} as const;

export type V1CreditType = typeof V1CreditType[keyof typeof V1CreditType];


/**
 * CryptoAsset represents a cryptocurrency asset.
 * @export
 * @interface V1CryptoAsset
 */
export interface V1CryptoAsset {
    /**
     * Uid is a unique identifier for the asset.
     * @type {string}
     * @memberof V1CryptoAsset
     */
    'uid'?: string;
    /**
     * Name is the file length name of the asset.
     * @type {string}
     * @memberof V1CryptoAsset
     */
    'name'?: string;
    /**
     * Symbol is the short name of the asset.
     * @type {string}
     * @memberof V1CryptoAsset
     */
    'symbol'?: string;
}
/**
 * 
 * @export
 * @interface V1DeleteFileResponse
 */
export interface V1DeleteFileResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1DeleteFileResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface V1FeeAndCreditDistribution
 */
export interface V1FeeAndCreditDistribution {
    /**
     * PortfolioId is the id of the portfolio that should receive the fee or credit.
     * @type {string}
     * @memberof V1FeeAndCreditDistribution
     */
    'portfolioId'?: string;
    /**
     * Amount is the amount to transfer with this order request.
     * @type {string}
     * @memberof V1FeeAndCreditDistribution
     */
    'amount'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1FeeType = {
    Unspecified: 'FEE_TYPE_UNSPECIFIED',
    Management: 'FEE_TYPE_MANAGEMENT',
    Advisory: 'FEE_TYPE_ADVISORY',
    Administrative: 'FEE_TYPE_ADMINISTRATIVE',
    Exchange: 'FEE_TYPE_EXCHANGE',
    Tech: 'FEE_TYPE_TECH',
    Platform: 'FEE_TYPE_PLATFORM',
    MarginInterest: 'FEE_TYPE_MARGIN_INTEREST',
    Inactivity: 'FEE_TYPE_INACTIVITY'
} as const;

export type V1FeeType = typeof V1FeeType[keyof typeof V1FeeType];


/**
 * FiatAsset represents a fiat asset.
 * @export
 * @interface V1FiatAsset
 */
export interface V1FiatAsset {
    /**
     * Uid is a unique identifier for the asset.
     * @type {string}
     * @memberof V1FiatAsset
     */
    'uid'?: string;
    /**
     * Name is the file length name of the asset.
     * @type {string}
     * @memberof V1FiatAsset
     */
    'name'?: string;
    /**
     * Symbol is the short name of the asset.
     * @type {string}
     * @memberof V1FiatAsset
     */
    'symbol'?: string;
}
/**
 * 
 * @export
 * @interface V1FileData
 */
export interface V1FileData {
    /**
     * 
     * @type {string}
     * @memberof V1FileData
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1FileData
     */
    'fileContentBase64'?: string;
}
/**
 * 
 * @export
 * @interface V1FileExistsResponse
 */
export interface V1FileExistsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1FileExistsResponse
     */
    'exists'?: boolean;
}
/**
 * 
 * @export
 * @interface V1ForgotPasswordRequest
 */
export interface V1ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof V1ForgotPasswordRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface V1ForgotPasswordResponse
 */
export interface V1ForgotPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof V1ForgotPasswordResponse
     */
    'attributeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ForgotPasswordResponse
     */
    'deliveryMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1ForgotPasswordResponse
     */
    'destination'?: string;
}
/**
 * FundingMethod indicates how a recurring rule should be funded.
 * @export
 * @enum {string}
 */

export const V1FundingMethod = {
    Unspecified: 'FUNDING_METHOD_UNSPECIFIED',
    AlwaysDeposit: 'FUNDING_METHOD_ALWAYS_DEPOSIT',
    NeverDeposit: 'FUNDING_METHOD_NEVER_DEPOSIT',
    DepositIfNeeded: 'FUNDING_METHOD_DEPOSIT_IF_NEEDED'
} as const;

export type V1FundingMethod = typeof V1FundingMethod[keyof typeof V1FundingMethod];


/**
 * 
 * @export
 * @interface V1GetAccountTagsResponse
 */
export interface V1GetAccountTagsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof V1GetAccountTagsResponse
     */
    'tags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1GetAllMarketsStatusResponse
 */
export interface V1GetAllMarketsStatusResponse {
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetAllMarketsStatusResponse
     */
    'securitiesMarket'?: V1BusinessDayStatus;
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetAllMarketsStatusResponse
     */
    'cryptoMarket'?: V1BusinessDayStatus;
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetAllMarketsStatusResponse
     */
    'banking'?: V1BusinessDayStatus;
}
/**
 * GetBalanceHistoryResponse is the response to get historical balance.
 * @export
 * @interface V1GetBalanceChangeHistoryResponse
 */
export interface V1GetBalanceChangeHistoryResponse {
    /**
     * PortfolioUid is the id of the asset.
     * @type {string}
     * @memberof V1GetBalanceChangeHistoryResponse
     */
    'portfolioUid'?: string;
    /**
     * 
     * @type {Array<V1UserAccountPortfolioAssetBalanceChangeHistory>}
     * @memberof V1GetBalanceChangeHistoryResponse
     */
    'assetAccountChangeHistory'?: Array<V1UserAccountPortfolioAssetBalanceChangeHistory>;
    /**
     * 
     * @type {V1TimeSeriesRange}
     * @memberof V1GetBalanceChangeHistoryResponse
     */
    'timeSeriesRange'?: V1TimeSeriesRange;
}
/**
 * GetCostBasisResponse is the response to calculate cost basis.
 * @export
 * @interface V1GetCostBasisResponse
 */
export interface V1GetCostBasisResponse {
    /**
     * CostBasis is the cost basis for the asset.
     * @type {Array<V1CostBasisValue>}
     * @memberof V1GetCostBasisResponse
     */
    'costBasis'?: Array<V1CostBasisValue>;
}
/**
 * 
 * @export
 * @interface V1GetFileResponse
 */
export interface V1GetFileResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetFileResponse
     */
    'fileContentBase64'?: string;
}
/**
 * 
 * @export
 * @interface V1GetListOfSODFilesResponse
 */
export interface V1GetListOfSODFilesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof V1GetListOfSODFilesResponse
     */
    'filePaths'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1GetMarketStatusResponse
 */
export interface V1GetMarketStatusResponse {
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetMarketStatusResponse
     */
    'status'?: V1BusinessDayStatus;
}
/**
 * 
 * @export
 * @interface V1GetNextBusinessDaysResponse
 */
export interface V1GetNextBusinessDaysResponse {
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetNextBusinessDaysResponse
     */
    'status'?: V1BusinessDayStatus;
}
/**
 * 
 * @export
 * @interface V1GetPreviousBusinessDaysResponse
 */
export interface V1GetPreviousBusinessDaysResponse {
    /**
     * 
     * @type {V1BusinessDayStatus}
     * @memberof V1GetPreviousBusinessDaysResponse
     */
    'status'?: V1BusinessDayStatus;
}
/**
 * 
 * @export
 * @interface V1GetSODFileResponse
 */
export interface V1GetSODFileResponse {
    /**
     * 
     * @type {Array<V1FileData>}
     * @memberof V1GetSODFileResponse
     */
    'fileData'?: Array<V1FileData>;
}
/**
 * 
 * @export
 * @interface V1GetSignedLinkResponse
 */
export interface V1GetSignedLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof V1GetSignedLinkResponse
     */
    'signedLink'?: string;
}
/**
 * 
 * @export
 * @interface V1GoalParameters
 */
export interface V1GoalParameters {
    /**
     * 
     * @type {V1RoboAccountType}
     * @memberof V1GoalParameters
     */
    'accountType'?: V1RoboAccountType;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1GoalParameters
     */
    'infusionStartDate'?: Commonpbv1Date;
    /**
     * Defines the target wealth value associated with the goal at end of goal tenure. The application accepts up to 7 digits of precision, but it might make sense to cap it at 2 decimal places.
     * @type {string}
     * @memberof V1GoalParameters
     */
    'goalAmount'?: string;
    /**
     * Defines the initial investment amount to the goal.
     * @type {string}
     * @memberof V1GoalParameters
     */
    'initialInvestment'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1GoalParameters
     */
    'endDate'?: Commonpbv1Date;
    /**
     * 
     * @type {V1GoalPriority}
     * @memberof V1GoalParameters
     */
    'goalPriority'?: V1GoalPriority;
    /**
     * InfusionAmount is the regular infusion amoun from the user, recurring payments yearly. The length for this parameter is dynamic depending on the goal tenure, start date and end date. The reference will always be on the created date. So, the first infusion will be on the first day of the goal followed by infusions every year/month followed by the last infusion/withdrawal on the last day of the goal.
     * @type {string}
     * @memberof V1GoalParameters
     */
    'infusionAmount'?: string;
    /**
     * 
     * @type {V1RoboInfusionFreq}
     * @memberof V1GoalParameters
     */
    'infusionFreq'?: V1RoboInfusionFreq;
    /**
     * 
     * @type {V1GoalScenarioType}
     * @memberof V1GoalParameters
     */
    'scenarioType'?: V1GoalScenarioType;
    /**
     * Captures the retirement age of the investor.
     * @type {number}
     * @memberof V1GoalParameters
     */
    'retirementAge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof V1GoalParameters
     */
    'considerMortality'?: boolean;
    /**
     * This is an optional parameter to disable GOE’s default de-risking logic. Default de-risking logic: For retail capital accumulation goals, GOE would consider portfolios up to 50% Equity exposure in case the goal tenure is 3 years or shorter. For retirement goals (starting at one year left in accumulation and for goals in retirement), GOE would consider portfolios with up to 65% Equity exposure. The default value is set to False. When set to False, GOE considers the default de-risking logic. When set to True, GOE will not consider the default de-risking logic and will consider the risk profile of the participant for portfolio access.
     * @type {boolean}
     * @memberof V1GoalParameters
     */
    'riskOverride'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1GoalParameters
     */
    'calibrateRecommendations'?: boolean;
    /**
     * This is an Optional parameter that applies only to retirement use cases which specifies whether a participant is engaged or unengaged with a default value of true. If the “currentAge” and the “retirementAge” are passed, they will be used to determine the de-risking criteria; If set to true GOE will de-risk 5 years before retirement and if set to false GOE will de-risk 1 year before retirement as per the default admin configuration settings.
     * @type {boolean}
     * @memberof V1GoalParameters
     */
    'engagedParticipant'?: boolean;
    /**
     * MaxDrift is the maximium amount of drift the portfolio is allowed to make before an automatic rebalance is performed. This option may not be available in the environment.
     * @type {number}
     * @memberof V1GoalParameters
     */
    'maxDrift'?: number;
    /**
     * Substitutions is a list of substitutions to apply to the recommended portfolio.
     * @type {Array<V1RoboAssetSubstitution>}
     * @memberof V1GoalParameters
     */
    'substitutions'?: Array<V1RoboAssetSubstitution>;
}


/**
 * GoalPriorityEnum defines the importance a goal holds for a specific user. Order of priority is Need > Want > Wish > Dream.
 * @export
 * @enum {string}
 */

export const V1GoalPriority = {
    Unspecified: 'GOAL_PRIORITY_UNSPECIFIED',
    Need: 'GOAL_PRIORITY_NEED',
    Want: 'GOAL_PRIORITY_WANT',
    Wish: 'GOAL_PRIORITY_WISH',
    Dream: 'GOAL_PRIORITY_DREAM'
} as const;

export type V1GoalPriority = typeof V1GoalPriority[keyof typeof V1GoalPriority];


/**
 * GoalProjection contains projections and statistics on the achieving the goal.
 * @export
 * @interface V1GoalProjection
 */
export interface V1GoalProjection {
    /**
     * GOE’s estimated probability to achieve the goal target wealth.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'goalProbability'?: number;
    /**
     * GOE\'s target probability given the goal priority.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'goalTargetProbability'?: number;
    /**
     * GOE’s estimated probability to remain above the loss threshold amount by the end of the goal tenure.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'lossThresholdProbabability'?: number;
    /**
     * RecommendedPortfolio is the uid of the recommended portfolio.
     * @type {string}
     * @memberof V1GoalProjection
     */
    'recommendedPortfolioUid'?: string;
    /**
     * Checks if goal probability is more than the target probability corresponding to the goal priority – Target probabilities for all goal priorities (Need, Want, Wish and Dream) are set in the GOE config.
     * @type {boolean}
     * @memberof V1GoalProjection
     */
    'meetGoalPriority'?: boolean;
    /**
     * To understand if the goal can be met with a reasonable probability (set by the ‘unrealistic’ goal probability value in the GOE config). If current goal probability is less than the desired target goal probability (defined by the goal priority), the goal is termed unrealistic.
     * @type {boolean}
     * @memberof V1GoalProjection
     */
    'isRealistic'?: boolean;
    /**
     * Checks if loss probability is more than the target loss probability (target set in the GOE config).
     * @type {boolean}
     * @memberof V1GoalProjection
     */
    'meetLossPriority'?: boolean;
    /**
     * Suggested one-time top-up amount that aims to improve the goal probability to meet the target goal probability.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'oneTimeTopUp'?: number;
    /**
     * Suggested recurring yearly top-up amount that aims to improve the goal probability to meet the target goal probability.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'yearlyTopUpAccumulation'?: number;
    /**
     * Suggested recurring monthly top-up amount that aims to improve the goal probability to meet the target goal probability.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'monthlyTopUpAccumulation'?: number;
    /**
     * Suggested recurring yearly decumulation amount that aims to improve the goal probability to meet the target goal probability.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'yearlyTopUpDecumulation'?: number;
    /**
     * Suggested recurring monthly decumulation amount that aims to improve the goal probability to meet the target goal probability, this value would be populated only in cases of decumulation of withdrawal scenario.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'monthlyTopUpDecumulation'?: number;
    /**
     * For scenarios with goal probability less than 50%:    • If original tenure between 1 - 8 years – extended/reduced tenure 2 years to 4 years    • If original tenure between 9 – 14 years – extended/reduced tenure 4 years to 8 years    • If original tenure greater than equal to 15 years – extended/reduced tenure 5 years to 10 years. For scenarios with goal probability greater than or equal to 50%, extended/reduced tenure = 2 years to 4 years for all cases. The algorithm recommends standard tenure increments/decrements based on the tenure input and the goal probability (calculated using current and end date). Cases where tenure recommendation isn’t valid/required will show the recommendation as NA. For retirement cases, where there is accumulation followed by decumulation, the extension is based on years to retirement and not on original tenure. For regular and pure decumulation cases, the recommendations are based on original tenure.
     * @type {string}
     * @memberof V1GoalProjection
     */
    'recommendedTenure'?: string;
    /**
     * Message flagging an expected bankruptcy (goal running out of money) in any year.
     * @type {string}
     * @memberof V1GoalProjection
     */
    'bankruptcyMsg'?: string;
    /**
     * 
     * @type {number}
     * @memberof V1GoalProjection
     */
    'recommendedFinalWealthAt75Pct'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1GoalProjection
     */
    'recommendedProbAt75Pct'?: number;
    /**
     * If target wealth were to be reduced by 50% of the difference between the target and the current wealth. Applicable for non-retirement scenarios with tenures less than or equal to 30 years.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'recommendedFinalWealthAt50Pct'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1GoalProjection
     */
    'recommendedProbAt50Pct'?: number;
    /**
     * Recommended Portfolio and corresponding probability. In case where current portfolio  is not null, it provides the following:    1. Probability of attaining goal (using the current portfolio sent as an input and a        constant portfolio path) – Monte Carlo simulations.    2. Current Goal Probability (dynamic asset allocation by GOE) and the recommended portfolio. In case the current portfolio is null, the current goal probability is displayed  (using dynamic asset allocation by GOE and not assuming a constant portfolio path)  along with the recommended portfolio.
     * @type {{ [key: string]: number; }}
     * @memberof V1GoalProjection
     */
    'advisorDiscretionReport'?: { [key: string]: number; };
    /**
     * Loss threshold value – the wealth amount that the investor does not want to end up below at the end of the goal tenure. If the input parameter ‘lossThreshold’ is not passed or value is ‘null’, this parameter is calculated by GOE. If the input parameter ‘lossThreshold’ is a number value, GOE will consider this as the loss threshold.
     * @type {number}
     * @memberof V1GoalProjection
     */
    'lossThreshold'?: number;
    /**
     * GOE’s expected portfolio path across the goal tenure (corresponding to the beginning of each reallocation date).
     * @type {Array<string>}
     * @memberof V1GoalProjection
     */
    'portfolioPath'?: Array<string>;
    /**
     * 
     * @type {V1GoalValueProjections}
     * @memberof V1GoalProjection
     */
    'wealthPath'?: V1GoalValueProjections;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1GoalScenarioType = {
    Unspecified: 'GOAL_SCENARIO_TYPE_UNSPECIFIED',
    Regular: 'GOAL_SCENARIO_TYPE_REGULAR',
    Retirement: 'GOAL_SCENARIO_TYPE_RETIREMENT'
} as const;

export type V1GoalScenarioType = typeof V1GoalScenarioType[keyof typeof V1GoalScenarioType];


/**
 * 
 * @export
 * @interface V1GoalValueProjection
 */
export interface V1GoalValueProjection {
    /**
     * Probability is the estimated probability of the goal investment following the wealth path.
     * @type {number}
     * @memberof V1GoalValueProjection
     */
    'probability'?: number;
    /**
     * WealthPath is the wealth path of the goal investment per year.
     * @type {Array<number>}
     * @memberof V1GoalValueProjection
     */
    'wealthPath'?: Array<number>;
}
/**
 * 
 * @export
 * @interface V1GoalValueProjections
 */
export interface V1GoalValueProjections {
    /**
     * DEPRECATED: use Dates instead. Years of the estimate.
     * @type {Array<number>}
     * @memberof V1GoalValueProjections
     */
    'years'?: Array<number>;
    /**
     * 
     * @type {Array<Commonpbv1Date>}
     * @memberof V1GoalValueProjections
     */
    'dates'?: Array<Commonpbv1Date>;
    /**
     * 
     * @type {V1GoalValueProjection}
     * @memberof V1GoalValueProjections
     */
    'default'?: V1GoalValueProjection;
    /**
     * 
     * @type {V1GoalValueProjection}
     * @memberof V1GoalValueProjections
     */
    'pessimistic'?: V1GoalValueProjection;
    /**
     * 
     * @type {V1GoalValueProjection}
     * @memberof V1GoalValueProjections
     */
    'optimistic'?: V1GoalValueProjection;
}
/**
 * 
 * @export
 * @interface V1IRAAccountParameters
 */
export interface V1IRAAccountParameters {
    /**
     * 
     * @type {V1AccountBeneficiaryElection}
     * @memberof V1IRAAccountParameters
     */
    'accountBeneficiaryElection'?: V1AccountBeneficiaryElection;
}
/**
 * 
 * @export
 * @interface V1InfuseRequest
 */
export interface V1InfuseRequest {
    /**
     * 
     * @type {V1RoboUid}
     * @memberof V1InfuseRequest
     */
    'uid'?: V1RoboUid;
    /**
     * Amount to infuse into the goal.
     * @type {string}
     * @memberof V1InfuseRequest
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1InfuseRequest
     */
    'fundingAccountUid'?: string;
    /**
     * ContributionYear is the year to attribute the goal infusion to. Only required for retirement account type goals.
     * @type {number}
     * @memberof V1InfuseRequest
     */
    'contributionYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1InfuseRequest
     */
    'fundingAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1InfuseRequest
     */
    'portfolioId'?: string;
}
/**
 * 
 * @export
 * @interface V1InfuseResponse
 */
export interface V1InfuseResponse {
    /**
     * 
     * @type {string}
     * @memberof V1InfuseResponse
     */
    'actionUid'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1InvestigationDocumentTag = {
    TagUnspecified: 'INVESTIGATION_DOCUMENT_TAG_TAG_UNSPECIFIED',
    IdDocument: 'INVESTIGATION_DOCUMENT_TAG_ID_DOCUMENT',
    SignatureImage: 'INVESTIGATION_DOCUMENT_TAG_SIGNATURE_IMAGE',
    AccountTransferForm: 'INVESTIGATION_DOCUMENT_TAG_ACCOUNT_TRANSFER_FORM',
    AffiliatedApproval: 'INVESTIGATION_DOCUMENT_TAG_AFFILIATED_APPROVAL',
    Other: 'INVESTIGATION_DOCUMENT_TAG_OTHER'
} as const;

export type V1InvestigationDocumentTag = typeof V1InvestigationDocumentTag[keyof typeof V1InvestigationDocumentTag];


/**
 * 
 * @export
 * @interface V1LimitOrder
 */
export interface V1LimitOrder {
    /**
     * limit is the price to trigger the trade.
     * @type {string}
     * @memberof V1LimitOrder
     */
    'limit'?: string;
}
/**
 * 
 * @export
 * @interface V1LinkAccountRequest
 */
export interface V1LinkAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof V1LinkAccountRequest
     */
    'publicToken'?: string;
    /**
     * AccountId is the external Plaid account that user is going to link.
     * @type {string}
     * @memberof V1LinkAccountRequest
     */
    'accountId'?: string;
    /**
     * RelationshipOwner is uid of the plaid relationship to link the account with.
     * @type {string}
     * @memberof V1LinkAccountRequest
     */
    'relationshipOwnerUid'?: string;
}
/**
 * 
 * @export
 * @interface V1LinkAccountResponse
 */
export interface V1LinkAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof V1LinkAccountResponse
     */
    'externalAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1LiquidateOrder
 */
export interface V1LiquidateOrder {
    /**
     * 
     * @type {V1PortfolioLiquidations}
     * @memberof V1LiquidateOrder
     */
    'assets'?: V1PortfolioLiquidations;
    /**
     * 
     * @type {LiquidateOrderSellAllPortfolio}
     * @memberof V1LiquidateOrder
     */
    'sellAllPortfolio'?: LiquidateOrderSellAllPortfolio;
    /**
     * 
     * @type {LiquidateOrderSellAllAccount}
     * @memberof V1LiquidateOrder
     */
    'sellAllAccount'?: LiquidateOrderSellAllAccount;
    /**
     * TargetAmount is the desired final cash value to gain from the liquidation. This may or may not be possible depending on the price of assets when sold.
     * @type {string}
     * @memberof V1LiquidateOrder
     */
    'targetAmount'?: string;
    /**
     * TransferTargets indicates where to transfer the proceeds of the liquidation. If not specified, the proceeds will be transfered to the remainder target.
     * @type {Array<LiquidateOrderQuantifiedTransferTarget>}
     * @memberof V1LiquidateOrder
     */
    'transferTargets'?: Array<LiquidateOrderQuantifiedTransferTarget>;
    /**
     * 
     * @type {LiquidateOrderRemainderTransferTarget}
     * @memberof V1LiquidateOrder
     */
    'remainderTarget'?: LiquidateOrderRemainderTransferTarget;
}
/**
 * 
 * @export
 * @interface V1LiquidateRequest
 */
export interface V1LiquidateRequest {
    /**
     * 
     * @type {V1LiquidateOrder}
     * @memberof V1LiquidateRequest
     */
    'liquidation'?: V1LiquidateOrder;
    /**
     * 
     * @type {V1LiquidationPurpose}
     * @memberof V1LiquidateRequest
     */
    'purpose'?: V1LiquidationPurpose;
    /**
     * Reason is a required reason for the liquidation. Will be visible to the user.
     * @type {string}
     * @memberof V1LiquidateRequest
     */
    'reason'?: string;
    /**
     * Note is an optional text of details to attach to the liquidation.
     * @type {string}
     * @memberof V1LiquidateRequest
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface V1LiquidateResponse
 */
export interface V1LiquidateResponse {
    /**
     * 
     * @type {string}
     * @memberof V1LiquidateResponse
     */
    'liquidationId'?: string;
}
/**
 * 
 * @export
 * @interface V1LiquidationFeeTransfer
 */
export interface V1LiquidationFeeTransfer {
    /**
     * 
     * @type {V1FeeType}
     * @memberof V1LiquidationFeeTransfer
     */
    'type'?: V1FeeType;
    /**
     * Title is the title of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1LiquidationFeeTransfer
     */
    'title'?: string;
    /**
     * Description is the description of the fee that is displayed to the user.
     * @type {string}
     * @memberof V1LiquidationFeeTransfer
     */
    'description'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1LiquidationPurpose = {
    Unspecified: 'LIQUIDATION_PURPOSE_UNSPECIFIED',
    Other: 'LIQUIDATION_PURPOSE_OTHER',
    MarginCall: 'LIQUIDATION_PURPOSE_MARGIN_CALL',
    Violation: 'LIQUIDATION_PURPOSE_VIOLATION',
    RoboWithdraw: 'LIQUIDATION_PURPOSE_ROBO_WITHDRAW'
} as const;

export type V1LiquidationPurpose = typeof V1LiquidationPurpose[keyof typeof V1LiquidationPurpose];


/**
 * 
 * @export
 * @interface V1MFALoginRequest
 */
export interface V1MFALoginRequest {
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginRequest
     */
    'session'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginRequest
     */
    'code'?: string;
    /**
     * 
     * @type {V1MfaPreferenceType}
     * @memberof V1MFALoginRequest
     */
    'preferenceType'?: V1MfaPreferenceType;
}


/**
 * 
 * @export
 * @interface V1MFALoginResponse
 */
export interface V1MFALoginResponse {
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1MFALoginResponse
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface V1MITOrder
 */
export interface V1MITOrder {
    /**
     * limit is the price to trigger the market trade.
     * @type {string}
     * @memberof V1MITOrder
     */
    'limit'?: string;
}
/**
 * 
 * @export
 * @interface V1MarketDataQuestionsAnswersRequest
 */
export interface V1MarketDataQuestionsAnswersRequest {
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'isForPersonalUse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'receivesDataFromExternalSource'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'isRegisteredWithSecOrCftc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'requiresSecOrCftcRegistration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'investForOther'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'investForTheBenefitOfOther'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'isAdvisorOrConsultant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'sharesProfit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1MarketDataQuestionsAnswersRequest
     */
    'isRegisteredWithEntity'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1MarketSide = {
    Unspecified: 'MARKET_SIDE_UNSPECIFIED',
    Buy: 'MARKET_SIDE_BUY',
    Sell: 'MARKET_SIDE_SELL'
} as const;

export type V1MarketSide = typeof V1MarketSide[keyof typeof V1MarketSide];


/**
 *  - MARKET_STATUS_OPEN: MARKET_STATUS_OPEN indicates the market is open during the typical hours for that market.  - MARKET_STATUS_CLOSED: MARKET_STATUS_CLOSED indicates the market is closed for any reason.  - MARKET_STATUS_MODIFIED: MARKET_STATUS_MODIFIED indicates the market is open but operating on atypical hours.
 * @export
 * @enum {string}
 */

export const V1MarketStatus = {
    Unspecified: 'MARKET_STATUS_UNSPECIFIED',
    Open: 'MARKET_STATUS_OPEN',
    Closed: 'MARKET_STATUS_CLOSED',
    Modified: 'MARKET_STATUS_MODIFIED'
} as const;

export type V1MarketStatus = typeof V1MarketStatus[keyof typeof V1MarketStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1MarketType = {
    Unspecified: 'MARKET_TYPE_UNSPECIFIED',
    Securities: 'MARKET_TYPE_SECURITIES',
    Crypto: 'MARKET_TYPE_CRYPTO',
    Banking: 'MARKET_TYPE_BANKING'
} as const;

export type V1MarketType = typeof V1MarketType[keyof typeof V1MarketType];


/**
 * MfaIdentifierType is the type of MFA identifier.
 * @export
 * @enum {string}
 */

export const V1MfaIdentifierType = {
    Unspecified: 'MFA_IDENTIFIER_TYPE_UNSPECIFIED',
    Email: 'MFA_IDENTIFIER_TYPE_EMAIL',
    PhoneNumber: 'MFA_IDENTIFIER_TYPE_PHONE_NUMBER'
} as const;

export type V1MfaIdentifierType = typeof V1MfaIdentifierType[keyof typeof V1MfaIdentifierType];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1MfaPreferenceType = {
    Unspecified: 'MFA_PREFERENCE_TYPE_UNSPECIFIED',
    Sms: 'MFA_PREFERENCE_TYPE_SMS',
    SoftwareToken: 'MFA_PREFERENCE_TYPE_SOFTWARE_TOKEN'
} as const;

export type V1MfaPreferenceType = typeof V1MfaPreferenceType[keyof typeof V1MfaPreferenceType];


/**
 * 
 * @export
 * @interface V1MigrateUsersRequest
 */
export interface V1MigrateUsersRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof V1MigrateUsersRequest
     */
    'userIds'?: Array<number>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1MimeType = {
    Unspecified: 'MIME_TYPE_UNSPECIFIED',
    ImageJpeg: 'MIME_TYPE_IMAGE_JPEG',
    ImagePng: 'MIME_TYPE_IMAGE_PNG',
    ApplicationPdf: 'MIME_TYPE_APPLICATION_PDF',
    TextPlain: 'MIME_TYPE_TEXT_PLAIN',
    TextCsv: 'MIME_TYPE_TEXT_CSV',
    ApplicationJson: 'MIME_TYPE_APPLICATION_JSON'
} as const;

export type V1MimeType = typeof V1MimeType[keyof typeof V1MimeType];


/**
 * 
 * @export
 * @interface V1ModifyExistingOrderRequest
 */
export interface V1ModifyExistingOrderRequest {
    /**
     * OrderId is the order to be modified.
     * @type {string}
     * @memberof V1ModifyExistingOrderRequest
     */
    'orderId'?: string;
    /**
     * 
     * @type {Array<ModifyExistingOrderRequestTransaction>}
     * @memberof V1ModifyExistingOrderRequest
     */
    'transactions'?: Array<ModifyExistingOrderRequestTransaction>;
    /**
     * 
     * @type {string}
     * @memberof V1ModifyExistingOrderRequest
     */
    'description'?: string;
    /**
     * EventTime is the time the transcation should be applied.
     * @type {string}
     * @memberof V1ModifyExistingOrderRequest
     */
    'eventTime'?: string;
}
/**
 * NewTicketRequest has the required information to file a support ticket.
 * @export
 * @interface V1NewTicketRequest
 */
export interface V1NewTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'ticketType'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketRequest
     */
    'gRecaptchaToken'?: string;
}
/**
 * 
 * @export
 * @interface V1NewTicketResponse
 */
export interface V1NewTicketResponse {
    /**
     * 
     * @type {string}
     * @memberof V1NewTicketResponse
     */
    'uid'?: string;
}
/**
 * 
 * @export
 * @interface V1PauseInfusionsRequest
 */
export interface V1PauseInfusionsRequest {
    /**
     * 
     * @type {V1RoboUid}
     * @memberof V1PauseInfusionsRequest
     */
    'uid'?: V1RoboUid;
    /**
     * Count is the number of infusions to skip before resuming normal activity. If zero, the goal will be paused indefinitely.
     * @type {number}
     * @memberof V1PauseInfusionsRequest
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface V1PingResponse
 */
export interface V1PingResponse {
    /**
     * 
     * @type {string}
     * @memberof V1PingResponse
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PingResponse
     */
    'version'?: string;
    /**
     * 
     * @type {Array<PingResponseExtra>}
     * @memberof V1PingResponse
     */
    'extras'?: Array<PingResponseExtra>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1Platform = {
    Unspecified: 'PLATFORM_UNSPECIFIED',
    Ios: 'PLATFORM_IOS',
    Android: 'PLATFORM_ANDROID'
} as const;

export type V1Platform = typeof V1Platform[keyof typeof V1Platform];


/**
 * 
 * @export
 * @interface V1PoliticallyExposedDetails
 */
export interface V1PoliticallyExposedDetails {
    /**
     * The political organization name.
     * @type {string}
     * @memberof V1PoliticallyExposedDetails
     */
    'organizationName'?: string;
    /**
     * Full name of family members belonging to the political organization.
     * @type {Array<string>}
     * @memberof V1PoliticallyExposedDetails
     */
    'familyMembers'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof V1PoliticallyExposedDetails
     */
    'isPoliticallyExposed'?: boolean;
}
/**
 * 
 * @export
 * @interface V1PortfolioLevelScore
 */
export interface V1PortfolioLevelScore {
    /**
     * 
     * @type {V1Range}
     * @memberof V1PortfolioLevelScore
     */
    'riskTolerance'?: V1Range;
    /**
     * 
     * @type {V1Range}
     * @memberof V1PortfolioLevelScore
     */
    'riskCapacity'?: V1Range;
    /**
     * 
     * @type {string}
     * @memberof V1PortfolioLevelScore
     */
    'portfolioLevelId'?: string;
}
/**
 * 
 * @export
 * @interface V1PortfolioLiquidation
 */
export interface V1PortfolioLiquidation {
    /**
     * PortfolioId is the portfolio to use as the source of the assets.
     * @type {string}
     * @memberof V1PortfolioLiquidation
     */
    'portfolioId'?: string;
    /**
     * AssetId is the asset to sell.
     * @type {string}
     * @memberof V1PortfolioLiquidation
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PortfolioLiquidation
     */
    'notional'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PortfolioLiquidation
     */
    'shareQuantity'?: string;
    /**
     * 
     * @type {object}
     * @memberof V1PortfolioLiquidation
     */
    'all'?: object;
}
/**
 * 
 * @export
 * @interface V1PortfolioLiquidations
 */
export interface V1PortfolioLiquidations {
    /**
     * 
     * @type {Array<V1PortfolioLiquidation>}
     * @memberof V1PortfolioLiquidations
     */
    'assets'?: Array<V1PortfolioLiquidation>;
}
/**
 * 
 * @export
 * @interface V1PrimitiveTransferDetails
 */
export interface V1PrimitiveTransferDetails {
    /**
     * From is the primitive account uid to transfer from.
     * @type {string}
     * @memberof V1PrimitiveTransferDetails
     */
    'from'?: string;
    /**
     * To is the primitive account uid to transfer to.
     * @type {string}
     * @memberof V1PrimitiveTransferDetails
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PrimitiveTransferDetails
     */
    'amount'?: string;
}
/**
 * ProgramApprovalStatus represents the status of the program approval. PROGRAM_APPROVAL_STATUS_PENDING indicates that the user\'s election preference for the program is waiting for Admin approval. PROGRAM_APPROVAL_STATUS_APPROVED indicates that the user\'s election preference for the program has been approved by the Admin. PROGRAM_APPROVAL_STATUS_REJECTED indicates that the user\'s election preference for the program has been rejected by the Admin. PROGRAM_APPROVAL_STATUS_NOT_REQUIRED indicates that the program does not require Admin approval.
 * @export
 * @enum {string}
 */

export const V1ProgramApprovalStatus = {
    Unspecified: 'PROGRAM_APPROVAL_STATUS_UNSPECIFIED',
    Pending: 'PROGRAM_APPROVAL_STATUS_PENDING',
    Approved: 'PROGRAM_APPROVAL_STATUS_APPROVED',
    Rejected: 'PROGRAM_APPROVAL_STATUS_REJECTED',
    NotRequired: 'PROGRAM_APPROVAL_STATUS_NOT_REQUIRED'
} as const;

export type V1ProgramApprovalStatus = typeof V1ProgramApprovalStatus[keyof typeof V1ProgramApprovalStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1ProgramElectionPreference = {
    Unspecified: 'PROGRAM_ELECTION_PREFERENCE_UNSPECIFIED',
    OptIn: 'PROGRAM_ELECTION_PREFERENCE_OPT_IN',
    OptOut: 'PROGRAM_ELECTION_PREFERENCE_OPT_OUT'
} as const;

export type V1ProgramElectionPreference = typeof V1ProgramElectionPreference[keyof typeof V1ProgramElectionPreference];


/**
 * 
 * @export
 * @interface V1ProgramEnrollmentOptions
 */
export interface V1ProgramEnrollmentOptions {
    /**
     * 
     * @type {V1ProgramType}
     * @memberof V1ProgramEnrollmentOptions
     */
    'programType'?: V1ProgramType;
    /**
     * 
     * @type {V1ProgramElectionPreference}
     * @memberof V1ProgramEnrollmentOptions
     */
    'programElectionPreference'?: V1ProgramElectionPreference;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1ProgramEnrollmentOptions
     */
    'positiveConsentGivenOn'?: Commonpbv1Date;
    /**
     * Reason is required if the Admin is updating the program enrollment on behalf of the user.
     * @type {string}
     * @memberof V1ProgramEnrollmentOptions
     */
    'reason'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1ProgramType = {
    Unspecified: 'PROGRAM_TYPE_UNSPECIFIED',
    Fpsl: 'PROGRAM_TYPE_FPSL',
    CashSweep: 'PROGRAM_TYPE_CASH_SWEEP'
} as const;

export type V1ProgramType = typeof V1ProgramType[keyof typeof V1ProgramType];


/**
 * 
 * @export
 * @interface V1PutFileResponse
 */
export interface V1PutFileResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1PutFileResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface V1QuestionResponse
 */
export interface V1QuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof V1QuestionResponse
     */
    'questionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1QuestionResponse
     */
    'optionId'?: string;
}
/**
 * 
 * @export
 * @interface V1RTQPortfolioLevel
 */
export interface V1RTQPortfolioLevel {
    /**
     * 
     * @type {number}
     * @memberof V1RTQPortfolioLevel
     */
    'index'?: number;
    /**
     * 
     * @type {string}
     * @memberof V1RTQPortfolioLevel
     */
    'modelPortfolioId'?: string;
}
/**
 * 
 * @export
 * @interface V1RTQQuestion
 */
export interface V1RTQQuestion {
    /**
     * Display text of the RTQ question.
     * @type {string}
     * @memberof V1RTQQuestion
     */
    'label'?: string;
    /**
     * 
     * @type {V1RTQQuestionType}
     * @memberof V1RTQQuestion
     */
    'type'?: V1RTQQuestionType;
    /**
     * 
     * @type {V1RTQRiskCategory}
     * @memberof V1RTQQuestion
     */
    'category'?: V1RTQRiskCategory;
    /**
     * List of possible responses for a given RTQ question.
     * @type {Array<V1RTQResponseOption>}
     * @memberof V1RTQQuestion
     */
    'options'?: Array<V1RTQResponseOption>;
}


/**
 * RTQQuestionType defines how answers for the questions are displayed and accepted.   - RTQ_QUESTION_TYPE_SINGLE_SELECTION: RTQ_QUESTION_TYPE_SINGLE_SELECTION means there is only one accepted answer.
 * @export
 * @enum {string}
 */

export const V1RTQQuestionType = {
    Unspecified: 'RTQ_QUESTION_TYPE_UNSPECIFIED',
    SingleSelection: 'RTQ_QUESTION_TYPE_SINGLE_SELECTION'
} as const;

export type V1RTQQuestionType = typeof V1RTQQuestionType[keyof typeof V1RTQQuestionType];


/**
 * 
 * @export
 * @interface V1RTQResponseOption
 */
export interface V1RTQResponseOption {
    /**
     * Display text of the RTQ response option.
     * @type {string}
     * @memberof V1RTQResponseOption
     */
    'label'?: string;
    /**
     * Score given to RTQ response used against RTQ portfolio mapping.
     * @type {number}
     * @memberof V1RTQResponseOption
     */
    'score'?: number;
}
/**
 * RTQRiskCategory defines which category an question is measured against for RTQ portoflio level mapping.   - RTQ_RISK_CATEGORY_RISK_TOLERANCE: RTQ_ANSWER_CATEGORY_RISK_TOLERANCE means answer\'s score is measured against risk tolerance of a RTQ portfolio mapping.  - RTQ_RISK_CATEGORY_RISK_CAPACITY: RTQ_ANSWER_CATEGORY_RISK_CAPACITY means answer\'s score is measured against risk capacity of a RTQ portfolio mapping.
 * @export
 * @enum {string}
 */

export const V1RTQRiskCategory = {
    Unspecified: 'RTQ_RISK_CATEGORY_UNSPECIFIED',
    RiskTolerance: 'RTQ_RISK_CATEGORY_RISK_TOLERANCE',
    RiskCapacity: 'RTQ_RISK_CATEGORY_RISK_CAPACITY'
} as const;

export type V1RTQRiskCategory = typeof V1RTQRiskCategory[keyof typeof V1RTQRiskCategory];


/**
 * 
 * @export
 * @interface V1Range
 */
export interface V1Range {
    /**
     * 
     * @type {number}
     * @memberof V1Range
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof V1Range
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface V1RateBracket
 */
export interface V1RateBracket {
    /**
     * 
     * @type {string}
     * @memberof V1RateBracket
     */
    'rate'?: string;
    /**
     * The minimum value where the bracket applies. If not provided, the bracket is assumed to be the final bracket and go to infinity.
     * @type {string}
     * @memberof V1RateBracket
     */
    'cutoff'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1RecurringRuleInterval = {
    Unspecified: 'RECURRING_RULE_INTERVAL_UNSPECIFIED',
    Once: 'RECURRING_RULE_INTERVAL_ONCE',
    EveryWeek: 'RECURRING_RULE_INTERVAL_EVERY_WEEK',
    EveryTwoWeeks: 'RECURRING_RULE_INTERVAL_EVERY_TWO_WEEKS',
    EveryFourWeeks: 'RECURRING_RULE_INTERVAL_EVERY_FOUR_WEEKS',
    EveryMonth: 'RECURRING_RULE_INTERVAL_EVERY_MONTH',
    TwiceEveryMonth: 'RECURRING_RULE_INTERVAL_TWICE_EVERY_MONTH',
    EveryTwoMonths: 'RECURRING_RULE_INTERVAL_EVERY_TWO_MONTHS',
    EveryThreeMonths: 'RECURRING_RULE_INTERVAL_EVERY_THREE_MONTHS',
    SixMonths: 'RECURRING_RULE_INTERVAL_SIX_MONTHS',
    EveryYear: 'RECURRING_RULE_INTERVAL_EVERY_YEAR'
} as const;

export type V1RecurringRuleInterval = typeof V1RecurringRuleInterval[keyof typeof V1RecurringRuleInterval];


/**
 * 
 * @export
 * @interface V1RefreshItemRequest
 */
export interface V1RefreshItemRequest {
    /**
     * ExternalAccountUid is the external account that is connected with the Plaid account whose item to be refreshed.
     * @type {string}
     * @memberof V1RefreshItemRequest
     */
    'externalAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1RegisterDeviceRequest
 */
export interface V1RegisterDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof V1RegisterDeviceRequest
     */
    'uid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RegisterDeviceRequest
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RegisterDeviceRequest
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RegisterDeviceRequest
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RegisterDeviceRequest
     */
    'fcmToken'?: string;
}
/**
 * 
 * @export
 * @interface V1RegisterSSOResponse
 */
export interface V1RegisterSSOResponse {
    /**
     * 
     * @type {string}
     * @memberof V1RegisterSSOResponse
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1RemoveAccountStatus = {
    Unspecified: 'REMOVE_ACCOUNT_STATUS_UNSPECIFIED',
    Rejected: 'REMOVE_ACCOUNT_STATUS_REJECTED',
    Canceled: 'REMOVE_ACCOUNT_STATUS_CANCELED'
} as const;

export type V1RemoveAccountStatus = typeof V1RemoveAccountStatus[keyof typeof V1RemoveAccountStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1RemoveBy = {
    Unspecified: 'REMOVE_BY_UNSPECIFIED',
    User: 'REMOVE_BY_USER',
    Fintron: 'REMOVE_BY_FINTRON',
    Apex: 'REMOVE_BY_APEX'
} as const;

export type V1RemoveBy = typeof V1RemoveBy[keyof typeof V1RemoveBy];


/**
 * 
 * @export
 * @interface V1RemoveTrustedContactResponse
 */
export interface V1RemoveTrustedContactResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1RemoveTrustedContactResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1RemoveUserTrustedContactResponse
 */
export interface V1RemoveUserTrustedContactResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1RemoveUserTrustedContactResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * Requestor enum codified the types of entities that may make a request.   - REQUESTOR_ADMIN: Requestor_REQUESTOR_ADMIN requested originate from a back office command.  - REQUESTOR_SYSTEM: Requestor_REQUESTOR_SYSTEM order originates from the system.  - REQUESTOR_USER: Requestor_REQUESTOR_USER requested orders originate from a manual action by the user.  - REQUESTOR_SCHEDULER: Requestor_REQUESTOR_SCHEDULER requested originate from services that trigger order request based on certain rule criteria, such as \"Recurring Transfers\".  - REQUESTOR_ROBO: Requestor_REQUESTOR_ROBO requested originate algorithmically from the robo trading service.  - REQUESTOR_PRINCIPAL: Requestor_REQUESTOR_PRINCIPAL requested originate from a back office command.
 * @export
 * @enum {string}
 */

export const V1Requestor = {
    Unspecified: 'REQUESTOR_UNSPECIFIED',
    Admin: 'REQUESTOR_ADMIN',
    System: 'REQUESTOR_SYSTEM',
    User: 'REQUESTOR_USER',
    Scheduler: 'REQUESTOR_SCHEDULER',
    Robo: 'REQUESTOR_ROBO',
    Principal: 'REQUESTOR_PRINCIPAL'
} as const;

export type V1Requestor = typeof V1Requestor[keyof typeof V1Requestor];


/**
 * 
 * @export
 * @interface V1ResubmitAccountApplicationRequest
 */
export interface V1ResubmitAccountApplicationRequest {
    /**
     * The UUID of the user account for which the account request is being resubmitted.
     * @type {string}
     * @memberof V1ResubmitAccountApplicationRequest
     */
    'accountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1ResubmitAccountApplicationResponse
 */
export interface V1ResubmitAccountApplicationResponse {
    /**
     * external_account_id is the unique identifier assigned by Apex to the newly created account.
     * @type {string}
     * @memberof V1ResubmitAccountApplicationResponse
     */
    'externalAccountId'?: string;
    /**
     * 
     * @type {Accountpbv1AccountStatus}
     * @memberof V1ResubmitAccountApplicationResponse
     */
    'accountStatus'?: Accountpbv1AccountStatus;
}


/**
 * 
 * @export
 * @interface V1ResumeInfusionsRequest
 */
export interface V1ResumeInfusionsRequest {
    /**
     * 
     * @type {V1RoboUid}
     * @memberof V1ResumeInfusionsRequest
     */
    'uid'?: V1RoboUid;
}
/**
 * 
 * @export
 * @interface V1RetirementContribution
 */
export interface V1RetirementContribution {
    /**
     * 
     * @type {V1RetirementContributionType}
     * @memberof V1RetirementContribution
     */
    'type'?: V1RetirementContributionType;
    /**
     * 
     * @type {number}
     * @memberof V1RetirementContribution
     */
    'taxYear'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1RetirementContributionType = {
    Unspecified: 'RETIREMENT_CONTRIBUTION_TYPE_UNSPECIFIED',
    Regular: 'RETIREMENT_CONTRIBUTION_TYPE_REGULAR',
    Employee: 'RETIREMENT_CONTRIBUTION_TYPE_EMPLOYEE',
    Employer: 'RETIREMENT_CONTRIBUTION_TYPE_EMPLOYER',
    Recharacterization: 'RETIREMENT_CONTRIBUTION_TYPE_RECHARACTERIZATION',
    Rollover60Day: 'RETIREMENT_CONTRIBUTION_TYPE_ROLLOVER_60_DAY',
    RolloverDirect: 'RETIREMENT_CONTRIBUTION_TYPE_ROLLOVER_DIRECT',
    Transfer: 'RETIREMENT_CONTRIBUTION_TYPE_TRANSFER',
    TrusteeFee: 'RETIREMENT_CONTRIBUTION_TYPE_TRUSTEE_FEE',
    Conversion: 'RETIREMENT_CONTRIBUTION_TYPE_CONVERSION',
    Repayment: 'RETIREMENT_CONTRIBUTION_TYPE_REPAYMENT'
} as const;

export type V1RetirementContributionType = typeof V1RetirementContributionType[keyof typeof V1RetirementContributionType];


/**
 * 
 * @export
 * @interface V1RetirementDistribution
 */
export interface V1RetirementDistribution {
    /**
     * 
     * @type {V1RetirementDistributionType}
     * @memberof V1RetirementDistribution
     */
    'type'?: V1RetirementDistributionType;
    /**
     * 
     * @type {V1RetirementDistributionFederalTaxWithholding}
     * @memberof V1RetirementDistribution
     */
    'federalTaxWithholding'?: V1RetirementDistributionFederalTaxWithholding;
    /**
     * 
     * @type {V1RetirementDistributionStateTaxWithholding}
     * @memberof V1RetirementDistribution
     */
    'stateTaxWithholding'?: V1RetirementDistributionStateTaxWithholding;
}


/**
 * 
 * @export
 * @interface V1RetirementDistributionFederalTaxWithholding
 */
export interface V1RetirementDistributionFederalTaxWithholding {
    /**
     * 
     * @type {V1WithholdAmount}
     * @memberof V1RetirementDistributionFederalTaxWithholding
     */
    'amount'?: V1WithholdAmount;
}
/**
 * 
 * @export
 * @interface V1RetirementDistributionStateTaxWithholding
 */
export interface V1RetirementDistributionStateTaxWithholding {
    /**
     * 
     * @type {V1WithholdAmount}
     * @memberof V1RetirementDistributionStateTaxWithholding
     */
    'amount'?: V1WithholdAmount;
}
/**
 *  - RETIREMENT_DISTRIBUTION_TYPE_NORMAL: Normal distribution is a distribution that is made after the age of 59.5.  - RETIREMENT_DISTRIBUTION_TYPE_DISABILITY: Disability distribution is a distribution that is made due to a disability.  - RETIREMENT_DISTRIBUTION_TYPE_PREMATURE: Premature distribution is a distribution that is made before the age of 59.5. This can not be set as a default and must be chosen at transfer time.  - RETIREMENT_DISTRIBUTION_TYPE_EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE: Excess contribution removal before tax deadline is a distribution that is made to remove excess contributions before the tax deadline. This can not be set as a default and must be chosen at transfer time.  - RETIREMENT_DISTRIBUTION_TYPE_EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE: Excess contribution removal after tax deadline is a distribution that is made to remove excess contributions after the tax deadline. This can not be set as a default and must be chosen at transfer time.
 * @export
 * @enum {string}
 */

export const V1RetirementDistributionType = {
    Unspecified: 'RETIREMENT_DISTRIBUTION_TYPE_UNSPECIFIED',
    Normal: 'RETIREMENT_DISTRIBUTION_TYPE_NORMAL',
    Disability: 'RETIREMENT_DISTRIBUTION_TYPE_DISABILITY',
    Premature: 'RETIREMENT_DISTRIBUTION_TYPE_PREMATURE',
    ExcessContributionRemovalBeforeTaxDeadline: 'RETIREMENT_DISTRIBUTION_TYPE_EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE',
    ExcessContributionRemovalAfterTaxDeadline: 'RETIREMENT_DISTRIBUTION_TYPE_EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE',
    Death: 'RETIREMENT_DISTRIBUTION_TYPE_DEATH',
    DistConversion: 'RETIREMENT_DISTRIBUTION_TYPE_DIST_CONVERSION',
    DistTransfer: 'RETIREMENT_DISTRIBUTION_TYPE_DIST_TRANSFER',
    ManagementFee: 'RETIREMENT_DISTRIBUTION_TYPE_MANAGEMENT_FEE',
    NetIncomeAttributable: 'RETIREMENT_DISTRIBUTION_TYPE_NET_INCOME_ATTRIBUTABLE',
    NonReportable: 'RETIREMENT_DISTRIBUTION_TYPE_NON_REPORTABLE',
    NormalRothIraGreaterThan5Years: 'RETIREMENT_DISTRIBUTION_TYPE_NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS',
    PlanLoan401K: 'RETIREMENT_DISTRIBUTION_TYPE_PLAN_LOAN_401K',
    PrematureSimpleIraLessThan2Years: 'RETIREMENT_DISTRIBUTION_TYPE_PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS',
    RecharacterizationCurrentYear: 'RETIREMENT_DISTRIBUTION_TYPE_RECHARACTERIZATION_CURRENT_YEAR',
    RecharacterizationPriorYear: 'RETIREMENT_DISTRIBUTION_TYPE_RECHARACTERIZATION_PRIOR_YEAR',
    Revocation: 'RETIREMENT_DISTRIBUTION_TYPE_REVOCATION',
    RolloverToIra: 'RETIREMENT_DISTRIBUTION_TYPE_ROLLOVER_TO_IRA',
    RolloverToQualifiedPlan: 'RETIREMENT_DISTRIBUTION_TYPE_ROLLOVER_TO_QUALIFIED_PLAN',
    Sosepp: 'RETIREMENT_DISTRIBUTION_TYPE_SOSEPP'
} as const;

export type V1RetirementDistributionType = typeof V1RetirementDistributionType[keyof typeof V1RetirementDistributionType];


/**
 * RetirementUserSettings contains settings for the RETIREMENT domain.
 * @export
 * @interface V1RetirementUserSettings
 */
export interface V1RetirementUserSettings {
    /**
     * 
     * @type {V1RetirementWithholdingSettings}
     * @memberof V1RetirementUserSettings
     */
    'defaultWithholding'?: V1RetirementWithholdingSettings;
}
/**
 * 
 * @export
 * @interface V1RetirementWithholdingElection
 */
export interface V1RetirementWithholdingElection {
    /**
     * 
     * @type {boolean}
     * @memberof V1RetirementWithholdingElection
     */
    'waive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1RetirementWithholdingElection
     */
    'percentage'?: string;
}
/**
 * RetirementWithholdingSettings holds the default settings for retirement transfer withholdings. Submission of this setting is subject to the specific state and federal tax withholding rules.
 * @export
 * @interface V1RetirementWithholdingSettings
 */
export interface V1RetirementWithholdingSettings {
    /**
     * State indicates the desired default state to be used for tax withholding.
     * @type {string}
     * @memberof V1RetirementWithholdingSettings
     */
    'state'?: string;
    /**
     * 
     * @type {V1RetirementWithholdingElection}
     * @memberof V1RetirementWithholdingSettings
     */
    'federalTaxWithholding'?: V1RetirementWithholdingElection;
    /**
     * 
     * @type {V1RetirementWithholdingElection}
     * @memberof V1RetirementWithholdingSettings
     */
    'stateTaxWithholding'?: V1RetirementWithholdingElection;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1RoboAccountType = {
    Unspecified: 'ROBO_ACCOUNT_TYPE_UNSPECIFIED',
    RetirmentIra: 'ROBO_ACCOUNT_TYPE_RETIRMENT_IRA',
    RetirmentRothIra: 'ROBO_ACCOUNT_TYPE_RETIRMENT_ROTH_IRA',
    General: 'ROBO_ACCOUNT_TYPE_GENERAL'
} as const;

export type V1RoboAccountType = typeof V1RoboAccountType[keyof typeof V1RoboAccountType];


/**
 * 
 * @export
 * @interface V1RoboAssetSubstitution
 */
export interface V1RoboAssetSubstitution {
    /**
     * The asset class to substitute.
     * @type {string}
     * @memberof V1RoboAssetSubstitution
     */
    'defaultAsset'?: string;
    /**
     * The asset class to substitute with.
     * @type {string}
     * @memberof V1RoboAssetSubstitution
     */
    'replacementAsset'?: string;
}
/**
 * 
 * @export
 * @interface V1RoboGeneralInvestment
 */
export interface V1RoboGeneralInvestment {
    /**
     * ModelPortfolioUid is the uid of the managed portfolio to use for the general investment.
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'modelPortfolioUid'?: string;
    /**
     * FundingAccountUid is the account to use when creating the recurring infusions and the initital investment. If not specified, the default account is used.
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'fundingAccountUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'rtqSubmissionUid'?: string;
    /**
     * InitialInvestment is the initial amount to invest in the general investment.
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'initialInvestment'?: string;
    /**
     * RecurringInfusionAmount is the amount to invest in the general investment on a recurring basis.
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'recurringInfusionAmount'?: string;
    /**
     * 
     * @type {V1RoboInfusionFreq}
     * @memberof V1RoboGeneralInvestment
     */
    'infusionFreq'?: V1RoboInfusionFreq;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1RoboGeneralInvestment
     */
    'infusionStartDate'?: Commonpbv1Date;
    /**
     * Substitutions is a list of substitutions to apply to the recommended portfolio.
     * @type {Array<V1RoboAssetSubstitution>}
     * @memberof V1RoboGeneralInvestment
     */
    'substitutions'?: Array<V1RoboAssetSubstitution>;
    /**
     * 
     * @type {string}
     * @memberof V1RoboGeneralInvestment
     */
    'name'?: string;
}


/**
 * RoboInfusionFreq Indicates the frequency of cash flows – determines the cash flow array corresponding to the ‘infusions’ parameter. This parameter is provided to account for real-world investors who might put in monthly infusions as opposed to yearly infusions. Monthly infusions would be smaller in value (and hence easier to commit to) vs. yearly infusions.   - ROBO_INFUSION_FREQ_YEARLY: ROBO_INFUSION_FREQ_YEARLY means the infusion is done once a year.  - ROBO_INFUSION_FREQ_SEMI_ANNUALLY: ROBO_INFUSION_FREQ_SEMI_ANNUALLY means the infusion is done twice a year.  - ROBO_INFUSION_FREQ_MONTHLY: ROBO_INFUSION_FREQ_MONTHLY means the infusion is done once a month.  - ROBO_INFUSION_FREQ_SEMI_MONTHLY: ROBO_INFUSION_FREQ_SEMI_MONTHLY means the infusion is done twice a month.  - ROBO_INFUSION_FREQ_BI_WEEKLY: ROBO_INFUSION_FREQ_BI_WEEKLY means the infusion is done every two weeks.  - ROBO_INFUSION_FREQ_WEEKLY: ROBO_INFUSION_FREQ_WEEKLY means the infusion is done once a week.
 * @export
 * @enum {string}
 */

export const V1RoboInfusionFreq = {
    Unspecified: 'ROBO_INFUSION_FREQ_UNSPECIFIED',
    Yearly: 'ROBO_INFUSION_FREQ_YEARLY',
    SemiAnnually: 'ROBO_INFUSION_FREQ_SEMI_ANNUALLY',
    Monthly: 'ROBO_INFUSION_FREQ_MONTHLY',
    SemiMonthly: 'ROBO_INFUSION_FREQ_SEMI_MONTHLY',
    BiWeekly: 'ROBO_INFUSION_FREQ_BI_WEEKLY',
    Weekly: 'ROBO_INFUSION_FREQ_WEEKLY'
} as const;

export type V1RoboInfusionFreq = typeof V1RoboInfusionFreq[keyof typeof V1RoboInfusionFreq];


/**
 * 
 * @export
 * @interface V1RoboUid
 */
export interface V1RoboUid {
    /**
     * 
     * @type {string}
     * @memberof V1RoboUid
     */
    'goalUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RoboUid
     */
    'investUid'?: string;
}
/**
 * 
 * @export
 * @interface V1RothIRAAccountParameters
 */
export interface V1RothIRAAccountParameters {
    /**
     * 
     * @type {V1AccountBeneficiaryElection}
     * @memberof V1RothIRAAccountParameters
     */
    'accountBeneficiaryElection'?: V1AccountBeneficiaryElection;
}
/**
 * 
 * @export
 * @interface V1RunPennyForTheLotRequest
 */
export interface V1RunPennyForTheLotRequest {
    /**
     * 
     * @type {string}
     * @memberof V1RunPennyForTheLotRequest
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1RunPennyForTheLotRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface V1RunSODReconciliationEtlRequest
 */
export interface V1RunSODReconciliationEtlRequest {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1RunSODReconciliationEtlRequest
     */
    'dateToReconcile'?: Commonpbv1Date;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1S3ContentType = {
    Unspecified: 'S3_CONTENT_TYPE_UNSPECIFIED',
    SvgXml: 'S3_CONTENT_TYPE_SVG_XML',
    Binary: 'S3_CONTENT_TYPE_BINARY',
    Png: 'S3_CONTENT_TYPE_PNG'
} as const;

export type V1S3ContentType = typeof V1S3ContentType[keyof typeof V1S3ContentType];


/**
 * SecurityAsset represents a security asset.
 * @export
 * @interface V1SecurityAsset
 */
export interface V1SecurityAsset {
    /**
     * Uid is a unique identifier for the asset.
     * @type {string}
     * @memberof V1SecurityAsset
     */
    'uid'?: string;
    /**
     * Name is the file length name of the asset.
     * @type {string}
     * @memberof V1SecurityAsset
     */
    'name'?: string;
    /**
     * Symbol is the short name of the asset.
     * @type {string}
     * @memberof V1SecurityAsset
     */
    'symbol'?: string;
}
/**
 * SendMFAVerificationCodeRequest is the request message for SendMFAVerificationCode.
 * @export
 * @interface V1SendMFAVerificationCodeRequest
 */
export interface V1SendMFAVerificationCodeRequest {
    /**
     * 
     * @type {V1UserContactInfo}
     * @memberof V1SendMFAVerificationCodeRequest
     */
    'info'?: V1UserContactInfo;
    /**
     * 
     * @type {V1MfaIdentifierType}
     * @memberof V1SendMFAVerificationCodeRequest
     */
    'type'?: V1MfaIdentifierType;
}


/**
 * SendMFAVerificationCodeResponse is the response message for SendMFAVerificationCode.
 * @export
 * @interface V1SendMFAVerificationCodeResponse
 */
export interface V1SendMFAVerificationCodeResponse {
    /**
     * LastSendTime is the time that the codes were last sent to the user.
     * @type {string}
     * @memberof V1SendMFAVerificationCodeResponse
     */
    'lastSentTime'?: string;
    /**
     * CoolDownPeriod is the amount of time from LastTimeSent the user needs to wait before resending the codes.
     * @type {string}
     * @memberof V1SendMFAVerificationCodeResponse
     */
    'coolDownPeriod'?: string;
}
/**
 * 
 * @export
 * @interface V1SetAccountTagsResponse
 */
export interface V1SetAccountTagsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof V1SetAccountTagsResponse
     */
    'tags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface V1SetActiveQuestionnaireResponse
 */
export interface V1SetActiveQuestionnaireResponse {
    /**
     * 
     * @type {string}
     * @memberof V1SetActiveQuestionnaireResponse
     */
    'questionnaireId'?: string;
}
/**
 * 
 * @export
 * @interface V1SetCrdRequest
 */
export interface V1SetCrdRequest {
    /**
     * 
     * @type {string}
     * @memberof V1SetCrdRequest
     */
    'crd'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1SetCrdRequest
     */
    'externalId'?: string;
}
/**
 * 
 * @export
 * @interface V1ShouldRefreshRequest
 */
export interface V1ShouldRefreshRequest {
    /**
     * ExternalAccountUid is the external account that is connected with the Plaid account whose item to be checked if need refresh by user.
     * @type {string}
     * @memberof V1ShouldRefreshRequest
     */
    'externalAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1ShouldRefreshResponse
 */
export interface V1ShouldRefreshResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1ShouldRefreshResponse
     */
    'refresh'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1SpecialHoursStatus = {
    Unspecified: 'SPECIAL_HOURS_STATUS_UNSPECIFIED',
    PreMarket: 'SPECIAL_HOURS_STATUS_PRE_MARKET',
    AfterMarket: 'SPECIAL_HOURS_STATUS_AFTER_MARKET',
    Maintenance: 'SPECIAL_HOURS_STATUS_MAINTENANCE'
} as const;

export type V1SpecialHoursStatus = typeof V1SpecialHoursStatus[keyof typeof V1SpecialHoursStatus];


/**
 * 
 * @export
 * @interface V1StartBulkOrderResponse
 */
export interface V1StartBulkOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof V1StartBulkOrderResponse
     */
    'bulkOrderUid'?: string;
}
/**
 * 
 * @export
 * @interface V1StopLimitOrder
 */
export interface V1StopLimitOrder {
    /**
     * limit is the price to trigger the trade after the stop is reached.
     * @type {string}
     * @memberof V1StopLimitOrder
     */
    'limit'?: string;
    /**
     * stop is the value of the asset to issue the limit order.
     * @type {string}
     * @memberof V1StopLimitOrder
     */
    'stop'?: string;
}
/**
 * 
 * @export
 * @interface V1StopLossOrder
 */
export interface V1StopLossOrder {
    /**
     * stop is the value of the asset to issue a market order.
     * @type {string}
     * @memberof V1StopLossOrder
     */
    'stop'?: string;
}
/**
 * 
 * @export
 * @interface V1StoreGoalRequest
 */
export interface V1StoreGoalRequest {
    /**
     * 
     * @type {V1GoalParameters}
     * @memberof V1StoreGoalRequest
     */
    'parameters'?: V1GoalParameters;
    /**
     * 
     * @type {string}
     * @memberof V1StoreGoalRequest
     */
    'name'?: string;
    /**
     * enable_auto_infusion grants us flexibility to allow a client to create a goal without having regular infusions set up off the bat. When this is set to false, the funding account uid is not required, and the goal will be created without recurring rules. If no value is provided, the default value (set in tenant configs) will be assumed.
     * @type {boolean}
     * @memberof V1StoreGoalRequest
     */
    'enableAutoInfusion'?: boolean;
    /**
     * FundingAccountUid is the account to use when creating the recurring infusions and the initial investment.
     * @type {string}
     * @memberof V1StoreGoalRequest
     */
    'fundingAccountUid'?: string;
}
/**
 * 
 * @export
 * @interface V1StoreGoalResponse
 */
export interface V1StoreGoalResponse {
    /**
     * 
     * @type {string}
     * @memberof V1StoreGoalResponse
     */
    'goalUid'?: string;
}
/**
 * TaxFilingInfo contains all relevant information for a specific tax filing. It encapsulates the essential details a user must provide for accurate filing.
 * @export
 * @interface V1TaxFilingInfo
 */
export interface V1TaxFilingInfo {
    /**
     * 
     * @type {V1UserFilingStatus}
     * @memberof V1TaxFilingInfo
     */
    'filingStatus'?: V1UserFilingStatus;
    /**
     * AdjustGrossIncome indicates the user\'s annual Adjusted Gross Income (AGI) in whole dollars (without decimals).
     * @type {number}
     * @memberof V1TaxFilingInfo
     */
    'adjustGrossIncome'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1TimePeriod = {
    Unspecified: 'TIME_PERIOD_UNSPECIFIED',
    Minute: 'TIME_PERIOD_MINUTE',
    Minute5: 'TIME_PERIOD_MINUTE_5',
    Minute15: 'TIME_PERIOD_MINUTE_15',
    Hour: 'TIME_PERIOD_HOUR',
    Day: 'TIME_PERIOD_DAY',
    Week: 'TIME_PERIOD_WEEK',
    Month: 'TIME_PERIOD_MONTH',
    Quarter: 'TIME_PERIOD_QUARTER',
    Year: 'TIME_PERIOD_YEAR'
} as const;

export type V1TimePeriod = typeof V1TimePeriod[keyof typeof V1TimePeriod];


/**
 * TimeSeriesRange describes how to query a time series datapoints.
 * @export
 * @interface V1TimeSeriesRange
 */
export interface V1TimeSeriesRange {
    /**
     * Start timestamp of the range.
     * @type {string}
     * @memberof V1TimeSeriesRange
     */
    'start'?: string;
    /**
     * End timestamp of the range.
     * @type {string}
     * @memberof V1TimeSeriesRange
     */
    'end'?: string;
    /**
     * 
     * @type {V1TimePeriod}
     * @memberof V1TimeSeriesRange
     */
    'period'?: V1TimePeriod;
    /**
     * Limit is the maximum number of data points to return.
     * @type {number}
     * @memberof V1TimeSeriesRange
     */
    'limit'?: number;
}


/**
 * 
 * @export
 * @interface V1ToggleMFAPreferenceRequest
 */
export interface V1ToggleMFAPreferenceRequest {
    /**
     * 
     * @type {boolean}
     * @memberof V1ToggleMFAPreferenceRequest
     */
    'isOn'?: boolean;
    /**
     * 
     * @type {V1MfaPreferenceType}
     * @memberof V1ToggleMFAPreferenceRequest
     */
    'preferenceType'?: V1MfaPreferenceType;
}


/**
 * 
 * @export
 * @interface V1ToggleMFAPreferenceResponse
 */
export interface V1ToggleMFAPreferenceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1ToggleMFAPreferenceResponse
     */
    'isOn'?: boolean;
    /**
     * 
     * @type {V1MfaPreferenceType}
     * @memberof V1ToggleMFAPreferenceResponse
     */
    'preferenceType'?: V1MfaPreferenceType;
}


/**
 *  - TRADE_EXPIRATION_TYPE_GOOD_TIL_CANCEL: TRADE_EXPIRATION_TYPE_GOOD_TIL_CANCEL indicates that the order should remain active until it is filled or canceled by the user.  - TRADE_EXPIRATION_TYPE_DAY: TRADE_EXPIRATION_TYPE_DAY indicates that the order should remain active until the next market close.
 * @export
 * @enum {string}
 */

export const V1TradeExpirationType = {
    Unspecified: 'TRADE_EXPIRATION_TYPE_UNSPECIFIED',
    GoodTilCancel: 'TRADE_EXPIRATION_TYPE_GOOD_TIL_CANCEL',
    Day: 'TRADE_EXPIRATION_TYPE_DAY'
} as const;

export type V1TradeExpirationType = typeof V1TradeExpirationType[keyof typeof V1TradeExpirationType];


/**
 * TradeOrder represents a requested trade between two assets.
 * @export
 * @interface V1TradeOrder
 */
export interface V1TradeOrder {
    /**
     * 
     * @type {V1MarketSide}
     * @memberof V1TradeOrder
     */
    'side'?: V1MarketSide;
    /**
     * 
     * @type {Accountpbv1Instrument}
     * @memberof V1TradeOrder
     */
    'instrument'?: Accountpbv1Instrument;
    /**
     * Quote is the total amount to transact in the quote asset, e.g. $100 USD.
     * @type {string}
     * @memberof V1TradeOrder
     */
    'quote'?: string;
    /**
     * Base is the total amount to transact in the base asset, e.g. 2 AAPL.
     * @type {string}
     * @memberof V1TradeOrder
     */
    'base'?: string;
    /**
     * 
     * @type {TradeOrderSendAll}
     * @memberof V1TradeOrder
     */
    'all'?: TradeOrderSendAll;
    /**
     * 
     * @type {V1LimitOrder}
     * @memberof V1TradeOrder
     */
    'limit'?: V1LimitOrder;
    /**
     * 
     * @type {V1MITOrder}
     * @memberof V1TradeOrder
     */
    'mit'?: V1MITOrder;
    /**
     * 
     * @type {V1StopLossOrder}
     * @memberof V1TradeOrder
     */
    'stopLoss'?: V1StopLossOrder;
    /**
     * 
     * @type {V1StopLimitOrder}
     * @memberof V1TradeOrder
     */
    'stopLimit'?: V1StopLimitOrder;
    /**
     * 
     * @type {V1TradeExpirationType}
     * @memberof V1TradeOrder
     */
    'expirationType'?: V1TradeExpirationType;
}


/**
 * 
 * @export
 * @interface V1TransferRetirementInfo
 */
export interface V1TransferRetirementInfo {
    /**
     * 
     * @type {V1RetirementContribution}
     * @memberof V1TransferRetirementInfo
     */
    'contribution'?: V1RetirementContribution;
    /**
     * 
     * @type {V1RetirementDistribution}
     * @memberof V1TransferRetirementInfo
     */
    'distribution'?: V1RetirementDistribution;
}
/**
 *  - TRANSFER_TYPE_DEPOSIT: TRANSFER_TYPE_DEPOSIT are transfers from an external account into a FinTron contolled account.  - TRANSFER_TYPE_WITHDRAW: TRANSFER_TYPE_WITHDRAW are transfers from a FinTron controlled account into an external account.
 * @export
 * @enum {string}
 */

export const V1TransferType = {
    Unspecified: 'TRANSFER_TYPE_UNSPECIFIED',
    Deposit: 'TRANSFER_TYPE_DEPOSIT',
    Withdraw: 'TRANSFER_TYPE_WITHDRAW'
} as const;

export type V1TransferType = typeof V1TransferType[keyof typeof V1TransferType];


/**
 * 
 * @export
 * @interface V1UpdateAccountRequest
 */
export interface V1UpdateAccountRequest {
    /**
     * 
     * @type {Pbv1AccountType}
     * @memberof V1UpdateAccountRequest
     */
    'accountType'?: Pbv1AccountType;
    /**
     * 
     * @type {V1BrokerageAccountParameters}
     * @memberof V1UpdateAccountRequest
     */
    'brokerage'?: V1BrokerageAccountParameters;
    /**
     * 
     * @type {V1BrokerageDiscretionaryAccountParameters}
     * @memberof V1UpdateAccountRequest
     */
    'discretionary'?: V1BrokerageDiscretionaryAccountParameters;
    /**
     * 
     * @type {V1IRAAccountParameters}
     * @memberof V1UpdateAccountRequest
     */
    'ira'?: V1IRAAccountParameters;
    /**
     * 
     * @type {V1RothIRAAccountParameters}
     * @memberof V1UpdateAccountRequest
     */
    'rothIra'?: V1RothIRAAccountParameters;
    /**
     * 
     * @type {Accountpbv1TrustedContact}
     * @memberof V1UpdateAccountRequest
     */
    'trustedContact'?: Accountpbv1TrustedContact;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UpdateAccountRequestStatus = {
    Unspecified: 'UPDATE_ACCOUNT_REQUEST_STATUS_UNSPECIFIED',
    Pending: 'UPDATE_ACCOUNT_REQUEST_STATUS_PENDING',
    Approved: 'UPDATE_ACCOUNT_REQUEST_STATUS_APPROVED',
    Rejected: 'UPDATE_ACCOUNT_REQUEST_STATUS_REJECTED',
    Contacted: 'UPDATE_ACCOUNT_REQUEST_STATUS_CONTACTED'
} as const;

export type V1UpdateAccountRequestStatus = typeof V1UpdateAccountRequestStatus[keyof typeof V1UpdateAccountRequestStatus];


/**
 * 
 * @export
 * @interface V1UpdateAccountResponse
 */
export interface V1UpdateAccountResponse {
    /**
     * 
     * @type {V1UpdateAccountRequestStatus}
     * @memberof V1UpdateAccountResponse
     */
    'status'?: V1UpdateAccountRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateAssetResponse
 */
export interface V1UpdateAssetResponse {
    /**
     * 
     * @type {Pbv1Asset}
     * @memberof V1UpdateAssetResponse
     */
    'asset'?: Pbv1Asset;
}
/**
 * 
 * @export
 * @interface V1UpdateBeneficiaryResponse
 */
export interface V1UpdateBeneficiaryResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateBeneficiaryResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateGoalParameters
 */
export interface V1UpdateGoalParameters {
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1UpdateGoalParameters
     */
    'infusionStartDate'?: Commonpbv1Date;
    /**
     * Loss threshold value – the wealth amount that the investor does not want to end up below at the end of the goal tenure.
     * @type {number}
     * @memberof V1UpdateGoalParameters
     */
    'lossThreshold'?: number;
    /**
     * Defines the target wealth value associated with the goal at end of goal tenure.
     * @type {string}
     * @memberof V1UpdateGoalParameters
     */
    'goalAmount'?: string;
    /**
     * 
     * @type {Commonpbv1Date}
     * @memberof V1UpdateGoalParameters
     */
    'endDate'?: Commonpbv1Date;
    /**
     * 
     * @type {V1GoalPriority}
     * @memberof V1UpdateGoalParameters
     */
    'goalPriority'?: V1GoalPriority;
    /**
     * InfusionAmount is the regular infusion amount from the user, recurring payments yearly. The length for this parameter is dynamic depending on the goal tenure, start date and end date. The reference will always be on the created date. So, the first infusion will be on the first day of the goal followed by infusions every year/month followed by the last infusion/withdrawal on the last day of the goal.
     * @type {string}
     * @memberof V1UpdateGoalParameters
     */
    'infusionAmount'?: string;
    /**
     * 
     * @type {V1RoboInfusionFreq}
     * @memberof V1UpdateGoalParameters
     */
    'infusionFreq'?: V1RoboInfusionFreq;
    /**
     * Captures the retirement age of the investor.
     * @type {number}
     * @memberof V1UpdateGoalParameters
     */
    'retirementAge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof V1UpdateGoalParameters
     */
    'considerMortality'?: boolean;
    /**
     * This is an optional parameter to disable GOE’s default de-risking logic. Default de-risking logic: For retail capital accumulation goals, GOE would consider portfolios up to 50% Equity exposure in case the goal tenure is 3 years or shorter. For retirement goals (starting at one year left in accumulation and for goals in retirement), GOE would consider portfolios with up to 65% Equity exposure. The default value is set to False. When set to False, GOE considers the default de-risking logic. When set to True, GOE will not consider the default de-risking logic and will consider the risk profile of the participant for portfolio access.
     * @type {boolean}
     * @memberof V1UpdateGoalParameters
     */
    'riskOverride'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V1UpdateGoalParameters
     */
    'calibrateRecommendations'?: boolean;
    /**
     * This is an Optional parameter that applies only to retirement use cases which specifies whether a participant is engaged or unengaged with a default value of true. If the “currentAge” and the “retirementAge” are passed, they will be used to determine the de-risking criteria; If set to true GOE will de-risk 5 years before retirement and if set to false GOE will de-risk 1 year before retirement as per the default admin configuration settings.
     * @type {boolean}
     * @memberof V1UpdateGoalParameters
     */
    'engagedParticipant'?: boolean;
    /**
     * MaxDrift is the maximium amount of drift the portfolio is allowed to make before an automatic rebalance is performed.
     * @type {number}
     * @memberof V1UpdateGoalParameters
     */
    'maxDrift'?: number;
    /**
     * Substitutions is a list of substitutions to apply to the recommended portfolio.
     * @type {Array<V1RoboAssetSubstitution>}
     * @memberof V1UpdateGoalParameters
     */
    'substitutions'?: Array<V1RoboAssetSubstitution>;
}


/**
 * 
 * @export
 * @interface V1UpdateKYCRequest
 */
export interface V1UpdateKYCRequest {
    /**
     * 
     * @type {V1BrokerageKYCParameters}
     * @memberof V1UpdateKYCRequest
     */
    'brokerage'?: V1BrokerageKYCParameters;
    /**
     * 
     * @type {V1AdvisoryKYCParameters}
     * @memberof V1UpdateKYCRequest
     */
    'advisory'?: V1AdvisoryKYCParameters;
}
/**
 * 
 * @export
 * @interface V1UpdateKYCResponse
 */
export interface V1UpdateKYCResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateKYCResponse
     */
    'status'?: V1UpdateRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateKYCResponse
     */
    'reason'?: string;
}


/**
 * UpdateProfileRequest is used to create a user profile.
 * @export
 * @interface V1UpdateProfileRequest
 */
export interface V1UpdateProfileRequest {
    /**
     * 
     * @type {V1UserProfileParameters}
     * @memberof V1UpdateProfileRequest
     */
    'profileParameters'?: V1UserProfileParameters;
}
/**
 * 
 * @export
 * @interface V1UpdateProfileResponse
 */
export interface V1UpdateProfileResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateProfileResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateRepeatTradeResponse
 */
export interface V1UpdateRepeatTradeResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateRepeatTradeResponse
     */
    'ruleUid'?: string;
}
/**
 * 
 * @export
 * @interface V1UpdateRepeatTransferResponse
 */
export interface V1UpdateRepeatTransferResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateRepeatTransferResponse
     */
    'ruleUid'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1UpdateRequestStatus = {
    Unspecified: 'UPDATE_REQUEST_STATUS_UNSPECIFIED',
    Pending: 'UPDATE_REQUEST_STATUS_PENDING',
    Submitted: 'UPDATE_REQUEST_STATUS_SUBMITTED',
    Approved: 'UPDATE_REQUEST_STATUS_APPROVED',
    Rejected: 'UPDATE_REQUEST_STATUS_REJECTED',
    Contacated: 'UPDATE_REQUEST_STATUS_CONTACATED'
} as const;

export type V1UpdateRequestStatus = typeof V1UpdateRequestStatus[keyof typeof V1UpdateRequestStatus];


/**
 * 
 * @export
 * @interface V1UpdateRequestStatusRequest
 */
export interface V1UpdateRequestStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateRequestStatusRequest
     */
    'trustedContactUpdateRequestId'?: string;
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateRequestStatusRequest
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateResponse
 */
export interface V1UpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateResponse
     */
    'recurringRuleUid'?: string;
}
/**
 * 
 * @export
 * @interface V1UpdateTradeResponse
 */
export interface V1UpdateTradeResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateTradeResponse
     */
    'orderUid'?: string;
    /**
     * 
     * @type {V1TradeOrder}
     * @memberof V1UpdateTradeResponse
     */
    'tradeOrder'?: V1TradeOrder;
}
/**
 * 
 * @export
 * @interface V1UpdateUserAccountRequest
 */
export interface V1UpdateUserAccountRequest {
    /**
     * 
     * @type {Pbv1AccountType}
     * @memberof V1UpdateUserAccountRequest
     */
    'accountType'?: Pbv1AccountType;
    /**
     * 
     * @type {V1BrokerageAccountParameters}
     * @memberof V1UpdateUserAccountRequest
     */
    'brokerage'?: V1BrokerageAccountParameters;
    /**
     * 
     * @type {V1BrokerageDiscretionaryAccountParameters}
     * @memberof V1UpdateUserAccountRequest
     */
    'discretionary'?: V1BrokerageDiscretionaryAccountParameters;
    /**
     * 
     * @type {V1IRAAccountParameters}
     * @memberof V1UpdateUserAccountRequest
     */
    'ira'?: V1IRAAccountParameters;
    /**
     * 
     * @type {V1RothIRAAccountParameters}
     * @memberof V1UpdateUserAccountRequest
     */
    'rothIra'?: V1RothIRAAccountParameters;
    /**
     * 
     * @type {Accountpbv1TrustedContact}
     * @memberof V1UpdateUserAccountRequest
     */
    'trustedContact'?: Accountpbv1TrustedContact;
}


/**
 * 
 * @export
 * @interface V1UpdateUserAccountResponse
 */
export interface V1UpdateUserAccountResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateUserAccountResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateUserProfileRequest
 */
export interface V1UpdateUserProfileRequest {
    /**
     * 
     * @type {V1UserProfileParameters}
     * @memberof V1UpdateUserProfileRequest
     */
    'profileParameters'?: V1UserProfileParameters;
}
/**
 * 
 * @export
 * @interface V1UpdateUserProfileResponse
 */
export interface V1UpdateUserProfileResponse {
    /**
     * 
     * @type {V1UpdateRequestStatus}
     * @memberof V1UpdateUserProfileResponse
     */
    'status'?: V1UpdateRequestStatus;
}


/**
 * 
 * @export
 * @interface V1UpdateUserRestrictionRequest
 */
export interface V1UpdateUserRestrictionRequest {
    /**
     * 
     * @type {string}
     * @memberof V1UpdateUserRestrictionRequest
     */
    'userUid'?: string;
    /**
     * 
     * @type {V1UserRestrictionStatus}
     * @memberof V1UpdateUserRestrictionRequest
     */
    'status'?: V1UserRestrictionStatus;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateUserRestrictionRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UpdateUserRestrictionRequest
     */
    'notes'?: string;
}


/**
 * 
 * @export
 * @interface V1UpdateUserRestrictionResponse
 */
export interface V1UpdateUserRestrictionResponse {
    /**
     * 
     * @type {V1UserRestrictionStatus}
     * @memberof V1UpdateUserRestrictionResponse
     */
    'status'?: V1UserRestrictionStatus;
}


/**
 * UpdateUserSettingsRequest is the request object for the UpdateUserSettings endpoint.
 * @export
 * @interface V1UpdateUserSettingsRequest
 */
export interface V1UpdateUserSettingsRequest {
    /**
     * 
     * @type {V1RetirementUserSettings}
     * @memberof V1UpdateUserSettingsRequest
     */
    'retirement'?: V1RetirementUserSettings;
}
/**
 * 
 * @export
 * @interface V1UploadDocumentRequest
 */
export interface V1UploadDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof V1UploadDocumentRequest
     */
    'takeOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UploadDocumentRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UploadDocumentRequest
     */
    'fileContentBase64'?: string;
}
/**
 * 
 * @export
 * @interface V1UploadDocumentResponse
 */
export interface V1UploadDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UploadDocumentResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UploadDocumentResponse
     */
    'uid'?: string;
}
/**
 * 
 * @export
 * @interface V1UploadPortfolioLevelMappingRequest
 */
export interface V1UploadPortfolioLevelMappingRequest {
    /**
     * LevelSetId is the grouping id to the levels.
     * @type {string}
     * @memberof V1UploadPortfolioLevelMappingRequest
     */
    'levelSetId'?: string;
    /**
     * 
     * @type {Array<V1RTQPortfolioLevel>}
     * @memberof V1UploadPortfolioLevelMappingRequest
     */
    'levels'?: Array<V1RTQPortfolioLevel>;
}
/**
 * 
 * @export
 * @interface V1UploadQuestionnaireRequest
 */
export interface V1UploadQuestionnaireRequest {
    /**
     * List of questions and possible answers.
     * @type {Array<V1RTQQuestion>}
     * @memberof V1UploadQuestionnaireRequest
     */
    'questions'?: Array<V1RTQQuestion>;
    /**
     * 
     * @type {boolean}
     * @memberof V1UploadQuestionnaireRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {Array<V1PortfolioLevelScore>}
     * @memberof V1UploadQuestionnaireRequest
     */
    'portfolioLevelScores'?: Array<V1PortfolioLevelScore>;
}
/**
 * 
 * @export
 * @interface V1UploadQuestionnaireResponse
 */
export interface V1UploadQuestionnaireResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UploadQuestionnaireResponse
     */
    'questionnaireId'?: string;
}
/**
 * 
 * @export
 * @interface V1UploadRequest
 */
export interface V1UploadRequest {
    /**
     * 
     * @type {string}
     * @memberof V1UploadRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UploadRequest
     */
    'content'?: string;
    /**
     * 
     * @type {V1UserDocumentType}
     * @memberof V1UploadRequest
     */
    'documentType'?: V1UserDocumentType;
    /**
     * 
     * @type {string}
     * @memberof V1UploadRequest
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface V1UploadResponse
 */
export interface V1UploadResponse {
    /**
     * 
     * @type {string}
     * @memberof V1UploadResponse
     */
    'uid'?: string;
    /**
     * 
     * @type {V1MimeType}
     * @memberof V1UploadResponse
     */
    'mimeType'?: V1MimeType;
}


/**
 * 
 * @export
 * @interface V1UserAccountPortfolioAssetBalanceChangeHistory
 */
export interface V1UserAccountPortfolioAssetBalanceChangeHistory {
    /**
     * AssetAccountUid is the id of the UserAccountPortfolioAsset.
     * @type {string}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'assetAccountUid'?: string;
    /**
     * AssetUid is the id of the asset.
     * @type {string}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'assetUid'?: string;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'settled'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'unsettled'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'pending'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'frozen'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'encumbrance'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'liability'?: V1BalanceChangeHistory;
    /**
     * 
     * @type {V1BalanceChangeHistory}
     * @memberof V1UserAccountPortfolioAssetBalanceChangeHistory
     */
    'pendingLiability'?: V1BalanceChangeHistory;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserAnnualIncome = {
    Unspecified: 'USER_ANNUAL_INCOME_UNSPECIFIED',
    _025000: 'USER_ANNUAL_INCOME_0_25000',
    _2500150000: 'USER_ANNUAL_INCOME_25001_50000',
    _50001100000: 'USER_ANNUAL_INCOME_50001_100000',
    _100001200000: 'USER_ANNUAL_INCOME_100001_200000',
    _200001300000: 'USER_ANNUAL_INCOME_200001_300000',
    _300001500000: 'USER_ANNUAL_INCOME_300001_500000',
    _5000011200000: 'USER_ANNUAL_INCOME_500001_1200000',
    _12000019999999: 'USER_ANNUAL_INCOME_1200001_9999999',
    _5000011000000: 'USER_ANNUAL_INCOME_500001_1000000',
    _10000015000000: 'USER_ANNUAL_INCOME_1000001_5000000',
    _50000019999999: 'USER_ANNUAL_INCOME_5000001_9999999'
} as const;

export type V1UserAnnualIncome = typeof V1UserAnnualIncome[keyof typeof V1UserAnnualIncome];


/**
 * UserContactInfo contains user\'s contact information.
 * @export
 * @interface V1UserContactInfo
 */
export interface V1UserContactInfo {
    /**
     * Email is the user\'s email address.
     * @type {string}
     * @memberof V1UserContactInfo
     */
    'email'?: string;
    /**
     * PhoneNumber is the user\'s phone number.
     * @type {string}
     * @memberof V1UserContactInfo
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserDocumentType = {
    Unspecified: 'USER_DOCUMENT_TYPE_UNSPECIFIED',
    DriversLicense: 'USER_DOCUMENT_TYPE_DRIVERS_LICENSE',
    StateIdCard: 'USER_DOCUMENT_TYPE_STATE_ID_CARD',
    Passport: 'USER_DOCUMENT_TYPE_PASSPORT',
    MilitaryId: 'USER_DOCUMENT_TYPE_MILITARY_ID',
    SsnCard: 'USER_DOCUMENT_TYPE_SSN_CARD',
    SsaLetter: 'USER_DOCUMENT_TYPE_SSA_LETTER',
    IrsItinLetter: 'USER_DOCUMENT_TYPE_IRS_ITIN_LETTER',
    OtherGovernmentId: 'USER_DOCUMENT_TYPE_OTHER_GOVERNMENT_ID',
    CddDocument: 'USER_DOCUMENT_TYPE_CDD_DOCUMENT',
    AllPassingCipResults: 'USER_DOCUMENT_TYPE_ALL_PASSING_CIP_RESULTS',
    SignatureImage: 'USER_DOCUMENT_TYPE_SIGNATURE_IMAGE',
    IdDocument: 'USER_DOCUMENT_TYPE_ID_DOCUMENT',
    AccountTransferForm: 'USER_DOCUMENT_TYPE_ACCOUNT_TRANSFER_FORM',
    AffiliatedApproval: 'USER_DOCUMENT_TYPE_AFFILIATED_APPROVAL',
    DepositExplanation: 'USER_DOCUMENT_TYPE_DEPOSIT_EXPLANATION',
    IdentificationCard: 'USER_DOCUMENT_TYPE_IDENTIFICATION_CARD',
    IraDepositSlip: 'USER_DOCUMENT_TYPE_IRA_DEPOSIT_SLIP',
    LimitedMarginAgreement: 'USER_DOCUMENT_TYPE_LIMITED_MARGIN_AGREEMENT',
    NationalIdCard: 'USER_DOCUMENT_TYPE_NATIONAL_ID_CARD',
    Other: 'USER_DOCUMENT_TYPE_OTHER',
    TransferOnDeathAgreement: 'USER_DOCUMENT_TYPE_TRANSFER_ON_DEATH_AGREEMENT'
} as const;

export type V1UserDocumentType = typeof V1UserDocumentType[keyof typeof V1UserDocumentType];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserEmploymentStatus = {
    Unspecified: 'USER_EMPLOYMENT_STATUS_UNSPECIFIED',
    Employed: 'USER_EMPLOYMENT_STATUS_EMPLOYED',
    Retired: 'USER_EMPLOYMENT_STATUS_RETIRED',
    Student: 'USER_EMPLOYMENT_STATUS_STUDENT',
    Unemployed: 'USER_EMPLOYMENT_STATUS_UNEMPLOYED',
    SelfEmployed: 'USER_EMPLOYMENT_STATUS_SELF_EMPLOYED'
} as const;

export type V1UserEmploymentStatus = typeof V1UserEmploymentStatus[keyof typeof V1UserEmploymentStatus];


/**
 * FilingStatus defines the various tax filing statuses available in the system.
 * @export
 * @enum {string}
 */

export const V1UserFilingStatus = {
    Unspecified: 'USER_FILING_STATUS_UNSPECIFIED',
    Single: 'USER_FILING_STATUS_SINGLE',
    Joint: 'USER_FILING_STATUS_JOINT',
    JointFilingSeparately: 'USER_FILING_STATUS_JOINT_FILING_SEPARATELY'
} as const;

export type V1UserFilingStatus = typeof V1UserFilingStatus[keyof typeof V1UserFilingStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserInvestmentExperience = {
    Unspecified: 'USER_INVESTMENT_EXPERIENCE_UNSPECIFIED',
    None: 'USER_INVESTMENT_EXPERIENCE_NONE',
    Limited: 'USER_INVESTMENT_EXPERIENCE_LIMITED',
    Good: 'USER_INVESTMENT_EXPERIENCE_GOOD',
    Extensive: 'USER_INVESTMENT_EXPERIENCE_EXTENSIVE'
} as const;

export type V1UserInvestmentExperience = typeof V1UserInvestmentExperience[keyof typeof V1UserInvestmentExperience];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserInvestmentObjective = {
    Unspecified: 'USER_INVESTMENT_OBJECTIVE_UNSPECIFIED',
    Growth: 'USER_INVESTMENT_OBJECTIVE_GROWTH',
    Income: 'USER_INVESTMENT_OBJECTIVE_INCOME',
    CapitalPreservation: 'USER_INVESTMENT_OBJECTIVE_CAPITAL_PRESERVATION',
    Speculation: 'USER_INVESTMENT_OBJECTIVE_SPECULATION',
    Balanced: 'USER_INVESTMENT_OBJECTIVE_BALANCED',
    Other: 'USER_INVESTMENT_OBJECTIVE_OTHER',
    CapitalAppreciation: 'USER_INVESTMENT_OBJECTIVE_CAPITAL_APPRECIATION',
    GrowthAndIncome: 'USER_INVESTMENT_OBJECTIVE_GROWTH_AND_INCOME',
    GrowthIncome: 'USER_INVESTMENT_OBJECTIVE_GROWTH_INCOME',
    LongTermGrowthWithGreaterRisk: 'USER_INVESTMENT_OBJECTIVE_LONG_TERM_GROWTH_WITH_GREATER_RISK',
    LongTermGrowthWithSafety: 'USER_INVESTMENT_OBJECTIVE_LONG_TERM_GROWTH_WITH_SAFETY',
    MaximumGrowth: 'USER_INVESTMENT_OBJECTIVE_MAXIMUM_GROWTH',
    ShortTermGrowthWithRisk: 'USER_INVESTMENT_OBJECTIVE_SHORT_TERM_GROWTH_WITH_RISK'
} as const;

export type V1UserInvestmentObjective = typeof V1UserInvestmentObjective[keyof typeof V1UserInvestmentObjective];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserLiquidityNeeds = {
    Unspecified: 'USER_LIQUIDITY_NEEDS_UNSPECIFIED',
    VeryImportant: 'USER_LIQUIDITY_NEEDS_VERY_IMPORTANT',
    SomewhatImportant: 'USER_LIQUIDITY_NEEDS_SOMEWHAT_IMPORTANT',
    NotImportant: 'USER_LIQUIDITY_NEEDS_NOT_IMPORTANT'
} as const;

export type V1UserLiquidityNeeds = typeof V1UserLiquidityNeeds[keyof typeof V1UserLiquidityNeeds];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserMaritalStatus = {
    Unspecified: 'USER_MARITAL_STATUS_UNSPECIFIED',
    Single: 'USER_MARITAL_STATUS_SINGLE',
    Married: 'USER_MARITAL_STATUS_MARRIED',
    Divorced: 'USER_MARITAL_STATUS_DIVORCED',
    Widowed: 'USER_MARITAL_STATUS_WIDOWED'
} as const;

export type V1UserMaritalStatus = typeof V1UserMaritalStatus[keyof typeof V1UserMaritalStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserNetWorth = {
    Unspecified: 'USER_NET_WORTH_UNSPECIFIED',
    _050000: 'USER_NET_WORTH_0_50000',
    _50001100000: 'USER_NET_WORTH_50001_100000',
    _100001200000: 'USER_NET_WORTH_100001_200000',
    _200001500000: 'USER_NET_WORTH_200001_500000',
    _5000011000000: 'USER_NET_WORTH_500001_1000000',
    _10000015000000: 'USER_NET_WORTH_1000001_5000000',
    _50000019999999: 'USER_NET_WORTH_5000001_9999999',
    _025000: 'USER_NET_WORTH_0_25000',
    _2500150000: 'USER_NET_WORTH_25001_50000',
    _200001300000: 'USER_NET_WORTH_200001_300000',
    _300001500000: 'USER_NET_WORTH_300001_500000'
} as const;

export type V1UserNetWorth = typeof V1UserNetWorth[keyof typeof V1UserNetWorth];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserPhoneNumberType = {
    Unspecified: 'USER_PHONE_NUMBER_TYPE_UNSPECIFIED',
    Home: 'USER_PHONE_NUMBER_TYPE_HOME',
    Work: 'USER_PHONE_NUMBER_TYPE_WORK',
    Mobile: 'USER_PHONE_NUMBER_TYPE_MOBILE',
    Fax: 'USER_PHONE_NUMBER_TYPE_FAX',
    Other: 'USER_PHONE_NUMBER_TYPE_OTHER'
} as const;

export type V1UserPhoneNumberType = typeof V1UserPhoneNumberType[keyof typeof V1UserPhoneNumberType];


/**
 * UserProfileParameters contain the parameters used to create a user profile.
 * @export
 * @interface V1UserProfileParameters
 */
export interface V1UserProfileParameters {
    /**
     * User\'s first name.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'firstName'?: string;
    /**
     * User\'s last name.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'lastName'?: string;
    /**
     * User\'s email address.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'email'?: string;
    /**
     * User\'s date of birth.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'dateOfBirth'?: string;
    /**
     * User\'s social security number.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'ssn'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'taxId'?: string;
    /**
     * User\'s phone number.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {V1UserPhoneNumberType}
     * @memberof V1UserProfileParameters
     */
    'phoneNumberType'?: V1UserPhoneNumberType;
    /**
     * User\'s street address line.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'streetAddress'?: string;
    /**
     * User\'s additional street address information.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'additionalStreetAddress'?: string;
    /**
     * User\'s city.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'city'?: string;
    /**
     * User\'s state.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'state'?: string;
    /**
     * User\'s zip code.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'zipCode'?: string;
    /**
     * User\'s country.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'country'?: string;
    /**
     * User\'s citizenship country name (e.g. United States).
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'citizenshipCountryName'?: string;
    /**
     * User\'s birth country name (e.g. United States). Required if the user is not a US citizen or a permanent resident.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'birthCountryName'?: string;
    /**
     * User\'s permanent resident status. Required if the user is not a US citizen.
     * @type {boolean}
     * @memberof V1UserProfileParameters
     */
    'permanentResident'?: boolean;
    /**
     * 
     * @type {V1UserVisaType}
     * @memberof V1UserProfileParameters
     */
    'visaType'?: V1UserVisaType;
    /**
     * User\'s visa expiration date. Required when the user is not a US citizen or permanent resident.
     * @type {string}
     * @memberof V1UserProfileParameters
     */
    'visaExpirationDate'?: string;
    /**
     * 
     * @type {V1AffiliatedExchangeOrFINRADetails}
     * @memberof V1UserProfileParameters
     */
    'affiliatedExchangeOrFinraDetails'?: V1AffiliatedExchangeOrFINRADetails;
    /**
     * 
     * @type {V1ControlPersonDetails}
     * @memberof V1UserProfileParameters
     */
    'controlPersonDetails'?: V1ControlPersonDetails;
    /**
     * 
     * @type {V1PoliticallyExposedDetails}
     * @memberof V1UserProfileParameters
     */
    'politicallyExposedDetails'?: V1PoliticallyExposedDetails;
    /**
     * 
     * @type {V1MarketDataQuestionsAnswersRequest}
     * @memberof V1UserProfileParameters
     */
    'marketDataQuestionsAnswers'?: V1MarketDataQuestionsAnswersRequest;
    /**
     * 
     * @type {V1TaxFilingInfo}
     * @memberof V1UserProfileParameters
     */
    'taxFilingInfo'?: V1TaxFilingInfo;
    /**
     * 
     * @type {Userpbv1OtherSourcesOfWealth}
     * @memberof V1UserProfileParameters
     */
    'otherSourcesOfWealth'?: Userpbv1OtherSourcesOfWealth;
    /**
     * is_foreign being set to true indicates that the user is not a US citizen or otherwise operating as related to the US such as a permanent resident or visa holder.
     * @type {boolean}
     * @memberof V1UserProfileParameters
     */
    'isForeign'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserRestrictionStatus = {
    Unspecified: 'USER_RESTRICTION_STATUS_UNSPECIFIED',
    Unrestricted: 'USER_RESTRICTION_STATUS_UNRESTRICTED',
    ReadOnlyAccess: 'USER_RESTRICTION_STATUS_READ_ONLY_ACCESS',
    NoAccess: 'USER_RESTRICTION_STATUS_NO_ACCESS'
} as const;

export type V1UserRestrictionStatus = typeof V1UserRestrictionStatus[keyof typeof V1UserRestrictionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserRiskTolerance = {
    Unspecified: 'USER_RISK_TOLERANCE_UNSPECIFIED',
    Low: 'USER_RISK_TOLERANCE_LOW',
    Medium: 'USER_RISK_TOLERANCE_MEDIUM',
    High: 'USER_RISK_TOLERANCE_HIGH'
} as const;

export type V1UserRiskTolerance = typeof V1UserRiskTolerance[keyof typeof V1UserRiskTolerance];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserTimeHorizon = {
    Unspecified: 'USER_TIME_HORIZON_UNSPECIFIED',
    Short: 'USER_TIME_HORIZON_SHORT',
    Average: 'USER_TIME_HORIZON_AVERAGE',
    Longest: 'USER_TIME_HORIZON_LONGEST'
} as const;

export type V1UserTimeHorizon = typeof V1UserTimeHorizon[keyof typeof V1UserTimeHorizon];


/**
 * 
 * @export
 * @enum {string}
 */

export const V1UserVisaType = {
    Unspecified: 'USER_VISA_TYPE_UNSPECIFIED',
    E1: 'USER_VISA_TYPE_E1',
    E2: 'USER_VISA_TYPE_E2',
    E3: 'USER_VISA_TYPE_E3',
    F1: 'USER_VISA_TYPE_F1',
    G4: 'USER_VISA_TYPE_G4',
    H1B: 'USER_VISA_TYPE_H1B',
    L1: 'USER_VISA_TYPE_L1',
    O1: 'USER_VISA_TYPE_O1',
    Tn1: 'USER_VISA_TYPE_TN1',
    Other: 'USER_VISA_TYPE_OTHER'
} as const;

export type V1UserVisaType = typeof V1UserVisaType[keyof typeof V1UserVisaType];


/**
 * 
 * @export
 * @interface V1VerifyEmailRequest
 */
export interface V1VerifyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof V1VerifyEmailRequest
     */
    'code'?: string;
}
/**
 * VerifyMFARequest is the request message for VerifyMFA.
 * @export
 * @interface V1VerifyMFARequest
 */
export interface V1VerifyMFARequest {
    /**
     * 
     * @type {V1MfaIdentifierType}
     * @memberof V1VerifyMFARequest
     */
    'type'?: V1MfaIdentifierType;
    /**
     * Code is the secret code sent to the user\'s MFA identifier.
     * @type {string}
     * @memberof V1VerifyMFARequest
     */
    'code'?: string;
    /**
     * Identifier is the user\'s contact information (email or phone number) that received the MFA code.
     * @type {string}
     * @memberof V1VerifyMFARequest
     */
    'identifier'?: string;
}


/**
 * VerifyMFAResponse is the response message for VerifyMFA.
 * @export
 * @interface V1VerifyMFAResponse
 */
export interface V1VerifyMFAResponse {
    /**
     * VerificationToken is the token that can be used to prove the user has validated via MFA. It is in the form of a JWT token and contains the verification method.
     * @type {string}
     * @memberof V1VerifyMFAResponse
     */
    'verificationToken'?: string;
}
/**
 * 
 * @export
 * @interface V1VerifyPhoneRequest
 */
export interface V1VerifyPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof V1VerifyPhoneRequest
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface V1VerifySoftwareTokenRequest
 */
export interface V1VerifySoftwareTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof V1VerifySoftwareTokenRequest
     */
    'userCode'?: string;
}
/**
 * 
 * @export
 * @interface V1WithdrawResponse
 */
export interface V1WithdrawResponse {
    /**
     * 
     * @type {string}
     * @memberof V1WithdrawResponse
     */
    'actionUid'?: string;
}
/**
 * WithholdAmount represents the amount to withhold from a distribution. The amount can be indicated as a fixed, provided amount or as a percentage of the distribution amount.
 * @export
 * @interface V1WithholdAmount
 */
export interface V1WithholdAmount {
    /**
     * 
     * @type {string}
     * @memberof V1WithholdAmount
     */
    'fixed'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1WithholdAmount
     */
    'percentage'?: string;
}
/**
 * WatchlistServiceSetRequest tells the WatchlistService.Set function to set a watchlist to an exact set of values.
 * @export
 * @interface WatchlistServiceSetRequest
 */
export interface WatchlistServiceSetRequest {
    /**
     * 
     * @type {Array<V1AssetID>}
     * @memberof WatchlistServiceSetRequest
     */
    'assetUids'?: Array<V1AssetID>;
}

/**
 * AccountAdminServiceApi - axios parameter creator
 * @export
 */
export const AccountAdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AddDocumentToInvestigation upload a document set to an investigation
         * @param {V1AddDocumentToInvestigationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAddDocumentToInvestigation: async (body: V1AddDocumentToInvestigationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceAddDocumentToInvestigation', 'body', body)
            const localVarPath = `/v1/account/investigation/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AccountAdminServiceAdminCloseAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAdminCloseAccount: async (accountUid: string, body: AccountAdminServiceAdminCloseAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountAdminServiceAdminCloseAccount', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceAdminCloseAccount', 'body', body)
            const localVarPath = `/v1/account/{accountUid}/delete`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1AppealApexApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAppealApexApplication: async (body: V1AppealApexApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceAppealApexApplication', 'body', body)
            const localVarPath = `/v1/admin/user/apexaccount/appeal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CancelPendingApplication handles the cancellation of a user account application that is currently pending with Apex.
         * @param {V1CancelPendingApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceCancelPendingApplication: async (body: V1CancelPendingApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceCancelPendingApplication', 'body', body)
            const localVarPath = `/v1/admin/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateApexAccount
         * @param {V1CreateApexAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceCreateApexAccount: async (body: V1CreateApexAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceCreateApexAccount', 'body', body)
            const localVarPath = `/v1/admin/user/apexaccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RemoveUserTrustedContact removes the active trusted contact for the provided user account.
         * @param {string} accountUid The UUID of the user account for which the trusted contact is being removed.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceRemoveUserTrustedContact: async (accountUid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountAdminServiceRemoveUserTrustedContact', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceRemoveUserTrustedContact', 'body', body)
            const localVarPath = `/v1/admin/account/trusted_contact/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ResubmitAccountApplication handles the resubmission of a user account application that was previously rejected by Apex.
         * @param {V1ResubmitAccountApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceResubmitAccountApplication: async (body: V1ResubmitAccountApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceResubmitAccountApplication', 'body', body)
            const localVarPath = `/v1/admin/account/resubmit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ReviewProgramEnrollment ReviewProgramEnrollment allows an admin to approve or deny a user\'s program enrollment request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceReviewProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceReviewProgramEnrollment: async (accountUid: string, body: AccountAdminServiceReviewProgramEnrollmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountAdminServiceReviewProgramEnrollment', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceReviewProgramEnrollment', 'body', body)
            const localVarPath = `/v1/admin/account/program_enrollment/review/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SetProgramEnrollment SetAdminProgramEnrollment allows an admin to set the program enrollment for a user\'s account. Automatically rejects any existing pending request for the user and program type in favor of the new Admin\'s request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceSetAdminProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceSetAdminProgramEnrollment: async (accountUid: string, body: AccountAdminServiceSetAdminProgramEnrollmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountAdminServiceSetAdminProgramEnrollment', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceSetAdminProgramEnrollment', 'body', body)
            const localVarPath = `/v1/admin/account/program_enrollment/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {V1UpdateRequestStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceUpdateRequestStatus: async (body: V1UpdateRequestStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceUpdateRequestStatus', 'body', body)
            const localVarPath = `/v1/admin/account/update_request/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateUserAccount updates the details of an existing user account based on the provided parameters.
         * @param {V1UpdateUserAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceUpdateUserAccount: async (body: V1UpdateUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountAdminServiceUpdateUserAccount', 'body', body)
            const localVarPath = `/v1/admin/account/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountAdminServiceApi - functional programming interface
 * @export
 */
export const AccountAdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountAdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AddDocumentToInvestigation upload a document set to an investigation
         * @param {V1AddDocumentToInvestigationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceAddDocumentToInvestigation(body: V1AddDocumentToInvestigationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceAddDocumentToInvestigation(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AccountAdminServiceAdminCloseAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceAdminCloseAccount(accountUid: string, body: AccountAdminServiceAdminCloseAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceAdminCloseAccount(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {V1AppealApexApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceAppealApexApplication(body: V1AppealApexApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceAppealApexApplication(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CancelPendingApplication handles the cancellation of a user account application that is currently pending with Apex.
         * @param {V1CancelPendingApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceCancelPendingApplication(body: V1CancelPendingApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CancelPendingApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceCancelPendingApplication(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateApexAccount
         * @param {V1CreateApexAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceCreateApexAccount(body: V1CreateApexAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateApexAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceCreateApexAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary RemoveUserTrustedContact removes the active trusted contact for the provided user account.
         * @param {string} accountUid The UUID of the user account for which the trusted contact is being removed.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceRemoveUserTrustedContact(accountUid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RemoveUserTrustedContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceRemoveUserTrustedContact(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ResubmitAccountApplication handles the resubmission of a user account application that was previously rejected by Apex.
         * @param {V1ResubmitAccountApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceResubmitAccountApplication(body: V1ResubmitAccountApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ResubmitAccountApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceResubmitAccountApplication(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ReviewProgramEnrollment ReviewProgramEnrollment allows an admin to approve or deny a user\'s program enrollment request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceReviewProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceReviewProgramEnrollment(accountUid: string, body: AccountAdminServiceReviewProgramEnrollmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceReviewProgramEnrollment(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SetProgramEnrollment SetAdminProgramEnrollment allows an admin to set the program enrollment for a user\'s account. Automatically rejects any existing pending request for the user and program type in favor of the new Admin\'s request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceSetAdminProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceSetAdminProgramEnrollment(accountUid: string, body: AccountAdminServiceSetAdminProgramEnrollmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceSetAdminProgramEnrollment(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {V1UpdateRequestStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceUpdateRequestStatus(body: V1UpdateRequestStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceUpdateRequestStatus(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateUserAccount updates the details of an existing user account based on the provided parameters.
         * @param {V1UpdateUserAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAdminServiceUpdateUserAccount(body: V1UpdateUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateUserAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAdminServiceUpdateUserAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountAdminServiceApi - factory interface
 * @export
 */
export const AccountAdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountAdminServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary AddDocumentToInvestigation upload a document set to an investigation
         * @param {V1AddDocumentToInvestigationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAddDocumentToInvestigation(body: V1AddDocumentToInvestigationRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceAddDocumentToInvestigation(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AccountAdminServiceAdminCloseAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAdminCloseAccount(accountUid: string, body: AccountAdminServiceAdminCloseAccountRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceAdminCloseAccount(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1AppealApexApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceAppealApexApplication(body: V1AppealApexApplicationRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceAppealApexApplication(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CancelPendingApplication handles the cancellation of a user account application that is currently pending with Apex.
         * @param {V1CancelPendingApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceCancelPendingApplication(body: V1CancelPendingApplicationRequest, options?: any): AxiosPromise<V1CancelPendingApplicationResponse> {
            return localVarFp.accountAdminServiceCancelPendingApplication(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateApexAccount
         * @param {V1CreateApexAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceCreateApexAccount(body: V1CreateApexAccountRequest, options?: any): AxiosPromise<V1CreateApexAccountResponse> {
            return localVarFp.accountAdminServiceCreateApexAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RemoveUserTrustedContact removes the active trusted contact for the provided user account.
         * @param {string} accountUid The UUID of the user account for which the trusted contact is being removed.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceRemoveUserTrustedContact(accountUid: string, body: object, options?: any): AxiosPromise<V1RemoveUserTrustedContactResponse> {
            return localVarFp.accountAdminServiceRemoveUserTrustedContact(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ResubmitAccountApplication handles the resubmission of a user account application that was previously rejected by Apex.
         * @param {V1ResubmitAccountApplicationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceResubmitAccountApplication(body: V1ResubmitAccountApplicationRequest, options?: any): AxiosPromise<V1ResubmitAccountApplicationResponse> {
            return localVarFp.accountAdminServiceResubmitAccountApplication(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ReviewProgramEnrollment ReviewProgramEnrollment allows an admin to approve or deny a user\'s program enrollment request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceReviewProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceReviewProgramEnrollment(accountUid: string, body: AccountAdminServiceReviewProgramEnrollmentRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceReviewProgramEnrollment(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SetProgramEnrollment SetAdminProgramEnrollment allows an admin to set the program enrollment for a user\'s account. Automatically rejects any existing pending request for the user and program type in favor of the new Admin\'s request.
         * @param {string} accountUid 
         * @param {AccountAdminServiceSetAdminProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceSetAdminProgramEnrollment(accountUid: string, body: AccountAdminServiceSetAdminProgramEnrollmentRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceSetAdminProgramEnrollment(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {V1UpdateRequestStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceUpdateRequestStatus(body: V1UpdateRequestStatusRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountAdminServiceUpdateRequestStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateUserAccount updates the details of an existing user account based on the provided parameters.
         * @param {V1UpdateUserAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAdminServiceUpdateUserAccount(body: V1UpdateUserAccountRequest, options?: any): AxiosPromise<V1UpdateUserAccountResponse> {
            return localVarFp.accountAdminServiceUpdateUserAccount(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountAdminServiceApi - object-oriented interface
 * @export
 * @class AccountAdminServiceApi
 * @extends {BaseAPI}
 */
export class AccountAdminServiceApi extends BaseAPI {
    /**
     * 
     * @summary AddDocumentToInvestigation upload a document set to an investigation
     * @param {V1AddDocumentToInvestigationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceAddDocumentToInvestigation(body: V1AddDocumentToInvestigationRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceAddDocumentToInvestigation(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountUid 
     * @param {AccountAdminServiceAdminCloseAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceAdminCloseAccount(accountUid: string, body: AccountAdminServiceAdminCloseAccountRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceAdminCloseAccount(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1AppealApexApplicationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceAppealApexApplication(body: V1AppealApexApplicationRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceAppealApexApplication(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CancelPendingApplication handles the cancellation of a user account application that is currently pending with Apex.
     * @param {V1CancelPendingApplicationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceCancelPendingApplication(body: V1CancelPendingApplicationRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceCancelPendingApplication(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateApexAccount
     * @param {V1CreateApexAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceCreateApexAccount(body: V1CreateApexAccountRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceCreateApexAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RemoveUserTrustedContact removes the active trusted contact for the provided user account.
     * @param {string} accountUid The UUID of the user account for which the trusted contact is being removed.
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceRemoveUserTrustedContact(accountUid: string, body: object, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceRemoveUserTrustedContact(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ResubmitAccountApplication handles the resubmission of a user account application that was previously rejected by Apex.
     * @param {V1ResubmitAccountApplicationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceResubmitAccountApplication(body: V1ResubmitAccountApplicationRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceResubmitAccountApplication(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ReviewProgramEnrollment ReviewProgramEnrollment allows an admin to approve or deny a user\'s program enrollment request.
     * @param {string} accountUid 
     * @param {AccountAdminServiceReviewProgramEnrollmentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceReviewProgramEnrollment(accountUid: string, body: AccountAdminServiceReviewProgramEnrollmentRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceReviewProgramEnrollment(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SetProgramEnrollment SetAdminProgramEnrollment allows an admin to set the program enrollment for a user\'s account. Automatically rejects any existing pending request for the user and program type in favor of the new Admin\'s request.
     * @param {string} accountUid 
     * @param {AccountAdminServiceSetAdminProgramEnrollmentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceSetAdminProgramEnrollment(accountUid: string, body: AccountAdminServiceSetAdminProgramEnrollmentRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceSetAdminProgramEnrollment(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {V1UpdateRequestStatusRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceUpdateRequestStatus(body: V1UpdateRequestStatusRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceUpdateRequestStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateUserAccount updates the details of an existing user account based on the provided parameters.
     * @param {V1UpdateUserAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminServiceApi
     */
    public accountAdminServiceUpdateUserAccount(body: V1UpdateUserAccountRequest, options?: AxiosRequestConfig) {
        return AccountAdminServiceApiFp(this.configuration).accountAdminServiceUpdateUserAccount(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountServiceApi - axios parameter creator
 * @export
 */
export const AccountServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ClearBeneficiary ClearBeneficiary is used to clear the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceClearBeneficiarySetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceClearBeneficiarySet: async (accountUid: string, body: AccountServiceClearBeneficiarySetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceClearBeneficiarySet', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountServiceClearBeneficiarySet', 'body', body)
            const localVarPath = `/v1/account/clear_beneficiaries/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CloseAccount
         * @param {string} accountUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCloseAccount: async (accountUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceCloseAccount', 'accountUid', accountUid)
            const localVarPath = `/v1/account/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateAccount
         * @param {V1CreateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCreateAccount: async (body: V1CreateAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountServiceCreateAccount', 'body', body)
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {string} [trustedContactFirstName] 
         * @param {string} [trustedContactLastName] 
         * @param {number} [trustedContactDateOfBirthYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [trustedContactDateOfBirthMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [trustedContactDateOfBirthDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {string} [trustedContactPhoneNumber] 
         * @param {string} [trustedContactEmail] 
         * @param {string} [trustedContactMiddleName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCreateTrustedContact: async (accountUid: string, trustedContactFirstName?: string, trustedContactLastName?: string, trustedContactDateOfBirthYear?: number, trustedContactDateOfBirthMonth?: number, trustedContactDateOfBirthDay?: number, trustedContactPhoneNumber?: string, trustedContactEmail?: string, trustedContactMiddleName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceCreateTrustedContact', 'accountUid', accountUid)
            const localVarPath = `/v1/account/trusted_contact/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (trustedContactFirstName !== undefined) {
                localVarQueryParameter['trustedContact.firstName'] = trustedContactFirstName;
            }

            if (trustedContactLastName !== undefined) {
                localVarQueryParameter['trustedContact.lastName'] = trustedContactLastName;
            }

            if (trustedContactDateOfBirthYear !== undefined) {
                localVarQueryParameter['trustedContact.dateOfBirth.year'] = trustedContactDateOfBirthYear;
            }

            if (trustedContactDateOfBirthMonth !== undefined) {
                localVarQueryParameter['trustedContact.dateOfBirth.month'] = trustedContactDateOfBirthMonth;
            }

            if (trustedContactDateOfBirthDay !== undefined) {
                localVarQueryParameter['trustedContact.dateOfBirth.day'] = trustedContactDateOfBirthDay;
            }

            if (trustedContactPhoneNumber !== undefined) {
                localVarQueryParameter['trustedContact.phoneNumber'] = trustedContactPhoneNumber;
            }

            if (trustedContactEmail !== undefined) {
                localVarQueryParameter['trustedContact.email'] = trustedContactEmail;
            }

            if (trustedContactMiddleName !== undefined) {
                localVarQueryParameter['trustedContact.middleName'] = trustedContactMiddleName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RemoveTrustedContact
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceRemoveTrustedContact: async (accountUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceRemoveTrustedContact', 'accountUid', accountUid)
            const localVarPath = `/v1/account/trusted_contact/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SetProgramEnrollment SetProgramEnrollment is used to set the program enrollment for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceSetProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceSetProgramEnrollment: async (accountUid: string, body: AccountServiceSetProgramEnrollmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceSetProgramEnrollment', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountServiceSetProgramEnrollment', 'body', body)
            const localVarPath = `/v1/account/program_enrollment/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateAccount
         * @param {V1UpdateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceUpdateAccount: async (body: V1UpdateAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountServiceUpdateAccount', 'body', body)
            const localVarPath = `/v1/account/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateBeneficiary UpdateBeneficiary is used to update the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceUpdateBeneficiaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceUpdateBeneficiary: async (accountUid: string, body: AccountServiceUpdateBeneficiaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('accountServiceUpdateBeneficiary', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accountServiceUpdateBeneficiary', 'body', body)
            const localVarPath = `/v1/account/beneficiaries/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountServiceApi - functional programming interface
 * @export
 */
export const AccountServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ClearBeneficiary ClearBeneficiary is used to clear the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceClearBeneficiarySetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceClearBeneficiarySet(accountUid: string, body: AccountServiceClearBeneficiarySetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClearBeneficiarySetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceClearBeneficiarySet(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CloseAccount
         * @param {string} accountUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceCloseAccount(accountUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceCloseAccount(accountUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateAccount
         * @param {V1CreateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceCreateAccount(body: V1CreateAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceCreateAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {string} [trustedContactFirstName] 
         * @param {string} [trustedContactLastName] 
         * @param {number} [trustedContactDateOfBirthYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [trustedContactDateOfBirthMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [trustedContactDateOfBirthDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {string} [trustedContactPhoneNumber] 
         * @param {string} [trustedContactEmail] 
         * @param {string} [trustedContactMiddleName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceCreateTrustedContact(accountUid: string, trustedContactFirstName?: string, trustedContactLastName?: string, trustedContactDateOfBirthYear?: number, trustedContactDateOfBirthMonth?: number, trustedContactDateOfBirthDay?: number, trustedContactPhoneNumber?: string, trustedContactEmail?: string, trustedContactMiddleName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateTrustedContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceCreateTrustedContact(accountUid, trustedContactFirstName, trustedContactLastName, trustedContactDateOfBirthYear, trustedContactDateOfBirthMonth, trustedContactDateOfBirthDay, trustedContactPhoneNumber, trustedContactEmail, trustedContactMiddleName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary RemoveTrustedContact
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceRemoveTrustedContact(accountUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RemoveTrustedContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceRemoveTrustedContact(accountUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SetProgramEnrollment SetProgramEnrollment is used to set the program enrollment for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceSetProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceSetProgramEnrollment(accountUid: string, body: AccountServiceSetProgramEnrollmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceSetProgramEnrollment(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateAccount
         * @param {V1UpdateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceUpdateAccount(body: V1UpdateAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceUpdateAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateBeneficiary UpdateBeneficiary is used to update the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceUpdateBeneficiaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountServiceUpdateBeneficiary(accountUid: string, body: AccountServiceUpdateBeneficiaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateBeneficiaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountServiceUpdateBeneficiary(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountServiceApi - factory interface
 * @export
 */
export const AccountServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary ClearBeneficiary ClearBeneficiary is used to clear the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceClearBeneficiarySetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceClearBeneficiarySet(accountUid: string, body: AccountServiceClearBeneficiarySetRequest, options?: any): AxiosPromise<V1ClearBeneficiarySetResponse> {
            return localVarFp.accountServiceClearBeneficiarySet(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CloseAccount
         * @param {string} accountUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCloseAccount(accountUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.accountServiceCloseAccount(accountUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateAccount
         * @param {V1CreateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCreateAccount(body: V1CreateAccountRequest, options?: any): AxiosPromise<V1CreateAccountResponse> {
            return localVarFp.accountServiceCreateAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {string} [trustedContactFirstName] 
         * @param {string} [trustedContactLastName] 
         * @param {number} [trustedContactDateOfBirthYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [trustedContactDateOfBirthMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [trustedContactDateOfBirthDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {string} [trustedContactPhoneNumber] 
         * @param {string} [trustedContactEmail] 
         * @param {string} [trustedContactMiddleName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceCreateTrustedContact(accountUid: string, trustedContactFirstName?: string, trustedContactLastName?: string, trustedContactDateOfBirthYear?: number, trustedContactDateOfBirthMonth?: number, trustedContactDateOfBirthDay?: number, trustedContactPhoneNumber?: string, trustedContactEmail?: string, trustedContactMiddleName?: string, options?: any): AxiosPromise<V1CreateTrustedContactResponse> {
            return localVarFp.accountServiceCreateTrustedContact(accountUid, trustedContactFirstName, trustedContactLastName, trustedContactDateOfBirthYear, trustedContactDateOfBirthMonth, trustedContactDateOfBirthDay, trustedContactPhoneNumber, trustedContactEmail, trustedContactMiddleName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RemoveTrustedContact
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceRemoveTrustedContact(accountUid: string, options?: any): AxiosPromise<V1RemoveTrustedContactResponse> {
            return localVarFp.accountServiceRemoveTrustedContact(accountUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SetProgramEnrollment SetProgramEnrollment is used to set the program enrollment for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceSetProgramEnrollmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceSetProgramEnrollment(accountUid: string, body: AccountServiceSetProgramEnrollmentRequest, options?: any): AxiosPromise<object> {
            return localVarFp.accountServiceSetProgramEnrollment(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateAccount
         * @param {V1UpdateAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceUpdateAccount(body: V1UpdateAccountRequest, options?: any): AxiosPromise<V1UpdateAccountResponse> {
            return localVarFp.accountServiceUpdateAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateBeneficiary UpdateBeneficiary is used to update the beneficiaries for a user account.
         * @param {string} accountUid 
         * @param {AccountServiceUpdateBeneficiaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountServiceUpdateBeneficiary(accountUid: string, body: AccountServiceUpdateBeneficiaryRequest, options?: any): AxiosPromise<V1UpdateBeneficiaryResponse> {
            return localVarFp.accountServiceUpdateBeneficiary(accountUid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountServiceApi - object-oriented interface
 * @export
 * @class AccountServiceApi
 * @extends {BaseAPI}
 */
export class AccountServiceApi extends BaseAPI {
    /**
     * 
     * @summary ClearBeneficiary ClearBeneficiary is used to clear the beneficiaries for a user account.
     * @param {string} accountUid 
     * @param {AccountServiceClearBeneficiarySetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceClearBeneficiarySet(accountUid: string, body: AccountServiceClearBeneficiarySetRequest, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceClearBeneficiarySet(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CloseAccount
     * @param {string} accountUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceCloseAccount(accountUid: string, reason?: string, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceCloseAccount(accountUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateAccount
     * @param {V1CreateAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceCreateAccount(body: V1CreateAccountRequest, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceCreateAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountUid 
     * @param {string} [trustedContactFirstName] 
     * @param {string} [trustedContactLastName] 
     * @param {number} [trustedContactDateOfBirthYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @param {number} [trustedContactDateOfBirthMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @param {number} [trustedContactDateOfBirthDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @param {string} [trustedContactPhoneNumber] 
     * @param {string} [trustedContactEmail] 
     * @param {string} [trustedContactMiddleName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceCreateTrustedContact(accountUid: string, trustedContactFirstName?: string, trustedContactLastName?: string, trustedContactDateOfBirthYear?: number, trustedContactDateOfBirthMonth?: number, trustedContactDateOfBirthDay?: number, trustedContactPhoneNumber?: string, trustedContactEmail?: string, trustedContactMiddleName?: string, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceCreateTrustedContact(accountUid, trustedContactFirstName, trustedContactLastName, trustedContactDateOfBirthYear, trustedContactDateOfBirthMonth, trustedContactDateOfBirthDay, trustedContactPhoneNumber, trustedContactEmail, trustedContactMiddleName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RemoveTrustedContact
     * @param {string} accountUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceRemoveTrustedContact(accountUid: string, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceRemoveTrustedContact(accountUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SetProgramEnrollment SetProgramEnrollment is used to set the program enrollment for a user account.
     * @param {string} accountUid 
     * @param {AccountServiceSetProgramEnrollmentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceSetProgramEnrollment(accountUid: string, body: AccountServiceSetProgramEnrollmentRequest, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceSetProgramEnrollment(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateAccount
     * @param {V1UpdateAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceUpdateAccount(body: V1UpdateAccountRequest, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceUpdateAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateBeneficiary UpdateBeneficiary is used to update the beneficiaries for a user account.
     * @param {string} accountUid 
     * @param {AccountServiceUpdateBeneficiaryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountServiceApi
     */
    public accountServiceUpdateBeneficiary(accountUid: string, body: AccountServiceUpdateBeneficiaryRequest, options?: AxiosRequestConfig) {
        return AccountServiceApiFp(this.configuration).accountServiceUpdateBeneficiary(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminAssetServiceApi - axios parameter creator
 * @export
 */
export const AdminAssetServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CreateAsset
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetServiceCreateAsset: async (assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetFiatUid !== undefined) {
                localVarQueryParameter['asset.fiat.uid'] = assetFiatUid;
            }

            if (assetFiatName !== undefined) {
                localVarQueryParameter['asset.fiat.name'] = assetFiatName;
            }

            if (assetFiatSymbol !== undefined) {
                localVarQueryParameter['asset.fiat.symbol'] = assetFiatSymbol;
            }

            if (assetSecurityUid !== undefined) {
                localVarQueryParameter['asset.security.uid'] = assetSecurityUid;
            }

            if (assetSecurityName !== undefined) {
                localVarQueryParameter['asset.security.name'] = assetSecurityName;
            }

            if (assetSecuritySymbol !== undefined) {
                localVarQueryParameter['asset.security.symbol'] = assetSecuritySymbol;
            }

            if (assetCryptoUid !== undefined) {
                localVarQueryParameter['asset.crypto.uid'] = assetCryptoUid;
            }

            if (assetCryptoName !== undefined) {
                localVarQueryParameter['asset.crypto.name'] = assetCryptoName;
            }

            if (assetCryptoSymbol !== undefined) {
                localVarQueryParameter['asset.crypto.symbol'] = assetCryptoSymbol;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateAsset
         * @param {string} uuid 
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetServiceUpdateAsset: async (uuid: string, assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('adminAssetServiceUpdateAsset', 'uuid', uuid)
            const localVarPath = `/api/v1/asset/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetFiatUid !== undefined) {
                localVarQueryParameter['asset.fiat.uid'] = assetFiatUid;
            }

            if (assetFiatName !== undefined) {
                localVarQueryParameter['asset.fiat.name'] = assetFiatName;
            }

            if (assetFiatSymbol !== undefined) {
                localVarQueryParameter['asset.fiat.symbol'] = assetFiatSymbol;
            }

            if (assetSecurityUid !== undefined) {
                localVarQueryParameter['asset.security.uid'] = assetSecurityUid;
            }

            if (assetSecurityName !== undefined) {
                localVarQueryParameter['asset.security.name'] = assetSecurityName;
            }

            if (assetSecuritySymbol !== undefined) {
                localVarQueryParameter['asset.security.symbol'] = assetSecuritySymbol;
            }

            if (assetCryptoUid !== undefined) {
                localVarQueryParameter['asset.crypto.uid'] = assetCryptoUid;
            }

            if (assetCryptoName !== undefined) {
                localVarQueryParameter['asset.crypto.name'] = assetCryptoName;
            }

            if (assetCryptoSymbol !== undefined) {
                localVarQueryParameter['asset.crypto.symbol'] = assetCryptoSymbol;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAssetServiceApi - functional programming interface
 * @export
 */
export const AdminAssetServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAssetServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CreateAsset
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssetServiceCreateAsset(assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssetServiceCreateAsset(assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateAsset
         * @param {string} uuid 
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssetServiceUpdateAsset(uuid: string, assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssetServiceUpdateAsset(uuid, assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAssetServiceApi - factory interface
 * @export
 */
export const AdminAssetServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAssetServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary CreateAsset
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetServiceCreateAsset(assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: any): AxiosPromise<V1CreateAssetResponse> {
            return localVarFp.adminAssetServiceCreateAsset(assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateAsset
         * @param {string} uuid 
         * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
         * @param {string} [assetFiatName] Name is the file length name of the asset.
         * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
         * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
         * @param {string} [assetSecurityName] Name is the file length name of the asset.
         * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
         * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
         * @param {string} [assetCryptoName] Name is the file length name of the asset.
         * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssetServiceUpdateAsset(uuid: string, assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: any): AxiosPromise<V1UpdateAssetResponse> {
            return localVarFp.adminAssetServiceUpdateAsset(uuid, assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAssetServiceApi - object-oriented interface
 * @export
 * @class AdminAssetServiceApi
 * @extends {BaseAPI}
 */
export class AdminAssetServiceApi extends BaseAPI {
    /**
     * 
     * @summary CreateAsset
     * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
     * @param {string} [assetFiatName] Name is the file length name of the asset.
     * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
     * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
     * @param {string} [assetSecurityName] Name is the file length name of the asset.
     * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
     * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
     * @param {string} [assetCryptoName] Name is the file length name of the asset.
     * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAssetServiceApi
     */
    public adminAssetServiceCreateAsset(assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: AxiosRequestConfig) {
        return AdminAssetServiceApiFp(this.configuration).adminAssetServiceCreateAsset(assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateAsset
     * @param {string} uuid 
     * @param {string} [assetFiatUid] Uid is a unique identifier for the asset.
     * @param {string} [assetFiatName] Name is the file length name of the asset.
     * @param {string} [assetFiatSymbol] Symbol is the short name of the asset.
     * @param {string} [assetSecurityUid] Uid is a unique identifier for the asset.
     * @param {string} [assetSecurityName] Name is the file length name of the asset.
     * @param {string} [assetSecuritySymbol] Symbol is the short name of the asset.
     * @param {string} [assetCryptoUid] Uid is a unique identifier for the asset.
     * @param {string} [assetCryptoName] Name is the file length name of the asset.
     * @param {string} [assetCryptoSymbol] Symbol is the short name of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAssetServiceApi
     */
    public adminAssetServiceUpdateAsset(uuid: string, assetFiatUid?: string, assetFiatName?: string, assetFiatSymbol?: string, assetSecurityUid?: string, assetSecurityName?: string, assetSecuritySymbol?: string, assetCryptoUid?: string, assetCryptoName?: string, assetCryptoSymbol?: string, options?: AxiosRequestConfig) {
        return AdminAssetServiceApiFp(this.configuration).adminAssetServiceUpdateAsset(uuid, assetFiatUid, assetFiatName, assetFiatSymbol, assetSecurityUid, assetSecurityName, assetSecuritySymbol, assetCryptoUid, assetCryptoName, assetCryptoSymbol, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminServiceApi - axios parameter creator
 * @export
 */
export const AdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {V1CreateNoteRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceCreateNote: async (body: V1CreateNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceCreateNote', 'body', body)
            const localVarPath = `/v1/admin/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetAccountTags: async (accountUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('adminServiceGetAccountTags', 'accountUid', accountUid)
            const localVarPath = `/v1/admin/tags/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAuthorizeUrl - returns an authorization URL for admin SSO
         * @param {V1AdminServiceGetAuthorizeUrlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetAuthorizeUrl: async (body: V1AdminServiceGetAuthorizeUrlRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceGetAuthorizeUrl', 'body', body)
            const localVarPath = `/v1/admin/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Adminpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetTokens: async (body: Adminpbv1GetTokensRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceGetTokens', 'body', body)
            const localVarPath = `/v1/admin/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Adminpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceLogout: async (body: Adminpbv1LogoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceLogout', 'body', body)
            const localVarPath = `/v1/admin/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Adminpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceRefreshToken: async (body: Adminpbv1RefreshTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceRefreshToken', 'body', body)
            const localVarPath = `/v1/admin/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1AdminServiceRegisterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceRegister: async (body: V1AdminServiceRegisterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceRegister', 'body', body)
            const localVarPath = `/v1/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AdminServiceSetAccountTagsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceSetAccountTags: async (accountUid: string, body: AdminServiceSetAccountTagsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountUid' is not null or undefined
            assertParamExists('adminServiceSetAccountTags', 'accountUid', accountUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceSetAccountTags', 'body', body)
            const localVarPath = `/v1/admin/tags/{accountUid}`
                .replace(`{${"accountUid"}}`, encodeURIComponent(String(accountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1SetCrdRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceSetCrd: async (body: V1SetCrdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminServiceSetCrd', 'body', body)
            const localVarPath = `/v1/admin/crd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminServiceApi - functional programming interface
 * @export
 */
export const AdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {V1CreateNoteRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceCreateNote(body: V1CreateNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceCreateNote(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceGetAccountTags(accountUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAccountTagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceGetAccountTags(accountUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetAuthorizeUrl - returns an authorization URL for admin SSO
         * @param {V1AdminServiceGetAuthorizeUrlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceGetAuthorizeUrl(body: V1AdminServiceGetAuthorizeUrlRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AdminServiceGetAuthorizeUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceGetAuthorizeUrl(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Adminpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceGetTokens(body: Adminpbv1GetTokensRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adminpbv1GetTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceGetTokens(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Adminpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceLogout(body: Adminpbv1LogoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceLogout(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Adminpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceRefreshToken(body: Adminpbv1RefreshTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adminpbv1RefreshTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceRefreshToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1AdminServiceRegisterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceRegister(body: V1AdminServiceRegisterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AdminServiceRegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceRegister(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AdminServiceSetAccountTagsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceSetAccountTags(accountUid: string, body: AdminServiceSetAccountTagsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SetAccountTagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceSetAccountTags(accountUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1SetCrdRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminServiceSetCrd(body: V1SetCrdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminServiceSetCrd(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminServiceApi - factory interface
 * @export
 */
export const AdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {V1CreateNoteRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceCreateNote(body: V1CreateNoteRequest, options?: any): AxiosPromise<V1CreateNoteResponse> {
            return localVarFp.adminServiceCreateNote(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetAccountTags(accountUid: string, options?: any): AxiosPromise<V1GetAccountTagsResponse> {
            return localVarFp.adminServiceGetAccountTags(accountUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAuthorizeUrl - returns an authorization URL for admin SSO
         * @param {V1AdminServiceGetAuthorizeUrlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetAuthorizeUrl(body: V1AdminServiceGetAuthorizeUrlRequest, options?: any): AxiosPromise<V1AdminServiceGetAuthorizeUrlResponse> {
            return localVarFp.adminServiceGetAuthorizeUrl(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Adminpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceGetTokens(body: Adminpbv1GetTokensRequest, options?: any): AxiosPromise<Adminpbv1GetTokensResponse> {
            return localVarFp.adminServiceGetTokens(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Adminpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceLogout(body: Adminpbv1LogoutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.adminServiceLogout(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Adminpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceRefreshToken(body: Adminpbv1RefreshTokenRequest, options?: any): AxiosPromise<Adminpbv1RefreshTokenResponse> {
            return localVarFp.adminServiceRefreshToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1AdminServiceRegisterRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceRegister(body: V1AdminServiceRegisterRequest, options?: any): AxiosPromise<V1AdminServiceRegisterResponse> {
            return localVarFp.adminServiceRegister(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountUid 
         * @param {AdminServiceSetAccountTagsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceSetAccountTags(accountUid: string, body: AdminServiceSetAccountTagsRequest, options?: any): AxiosPromise<V1SetAccountTagsResponse> {
            return localVarFp.adminServiceSetAccountTags(accountUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
         * @param {V1SetCrdRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminServiceSetCrd(body: V1SetCrdRequest, options?: any): AxiosPromise<object> {
            return localVarFp.adminServiceSetCrd(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminServiceApi - object-oriented interface
 * @export
 * @class AdminServiceApi
 * @extends {BaseAPI}
 */
export class AdminServiceApi extends BaseAPI {
    /**
     * 
     * @param {V1CreateNoteRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceCreateNote(body: V1CreateNoteRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceCreateNote(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceGetAccountTags(accountUid: string, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceGetAccountTags(accountUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAuthorizeUrl - returns an authorization URL for admin SSO
     * @param {V1AdminServiceGetAuthorizeUrlRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceGetAuthorizeUrl(body: V1AdminServiceGetAuthorizeUrlRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceGetAuthorizeUrl(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Adminpbv1GetTokensRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceGetTokens(body: Adminpbv1GetTokensRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceGetTokens(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Adminpbv1LogoutRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceLogout(body: Adminpbv1LogoutRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceLogout(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Adminpbv1RefreshTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceRefreshToken(body: Adminpbv1RefreshTokenRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceRefreshToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
     * @param {V1AdminServiceRegisterRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceRegister(body: V1AdminServiceRegisterRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceRegister(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountUid 
     * @param {AdminServiceSetAccountTagsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceSetAccountTags(accountUid: string, body: AdminServiceSetAccountTagsRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceSetAccountTags(accountUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register - registers an authenticated admin user to the tenant\'s admin registry
     * @param {V1SetCrdRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public adminServiceSetCrd(body: V1SetCrdRequest, options?: AxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).adminServiceSetCrd(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthServiceApi - axios parameter creator
 * @export
 */
export const AuthServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AssociateSoftwareToken - Starts the process of associating a TOTP device with user account
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceAssociateSoftwareToken: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceAssociateSoftwareToken', 'body', body)
            const localVarPath = `/v1/auth/totp/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CheckUniqueness - Check if a username, email, or phone number is unique.
         * @param {V1CheckUniquenessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCheckUniqueness: async (body: V1CheckUniquenessRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceCheckUniqueness', 'body', body)
            const localVarPath = `/v1/auth/check-uniqueness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ConfirmForgotPassword - Completes the forget password flow
         * @param {V1ConfirmForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceConfirmForgotPassword: async (body: V1ConfirmForgotPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceConfirmForgotPassword', 'body', body)
            const localVarPath = `/v1/auth/confirm-forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateUser - Registers a user with the identity provider
         * @param {Authpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCreateUser: async (body: Authpbv1CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceCreateUser', 'body', body)
            const localVarPath = `/v1/auth/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateUserFromExternalIdp - Registers a user with the identity provider from an external idp
         * @param {V1CreateUserFromExternalIdpRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCreateUserFromExternalIdp: async (body: V1CreateUserFromExternalIdpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceCreateUserFromExternalIdp', 'body', body)
            const localVarPath = `/v1/auth/external-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ForgotPassword - Sends a message to user with a confirmation code that is required to change the user\'s password
         * @param {V1ForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceForgotPassword: async (body: V1ForgotPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceForgotPassword', 'body', body)
            const localVarPath = `/v1/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetTokens
         * @param {Authpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGetTokens: async (body: Authpbv1GetTokensRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceGetTokens', 'body', body)
            const localVarPath = `/v1/auth/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogin: async (body: Authpbv1LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceLogin', 'body', body)
            const localVarPath = `/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout - Invalidates a given JWT refresh token
         * @param {Authpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogout: async (body: Authpbv1LogoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceLogout', 'body', body)
            const localVarPath = `/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary MFALogin - Responds to MFA challenge and receive tokens if successful
         * @param {V1MFALoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceMFALogin: async (body: V1MFALoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceMFALogin', 'body', body)
            const localVarPath = `/v1/auth/login/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RefreshTokens - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRefreshToken: async (body: Authpbv1RefreshTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceRefreshToken', 'body', body)
            const localVarPath = `/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRegisterSSO: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceRegisterSSO', 'body', body)
            const localVarPath = `/v1/auth/sso/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SendVerifyEmail - Starts verification process for email
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceSendVerifyEmail: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceSendVerifyEmail', 'body', body)
            const localVarPath = `/v1/auth/send_code/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SendVerifyPhone - Starts verification process for phone number
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceSendVerifyPhone: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceSendVerifyPhone', 'body', body)
            const localVarPath = `/v1/auth/send_code/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ToggleMFAPreference - Toggles a user\'s SMS / Software Token MFA preference on / off
         * @param {V1ToggleMFAPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceToggleMFAPreference: async (body: V1ToggleMFAPreferenceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceToggleMFAPreference', 'body', body)
            const localVarPath = `/v1/auth/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary VerifyEmail - Completes verification process for email
         * @param {V1VerifyEmailRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifyEmail: async (body: V1VerifyEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceVerifyEmail', 'body', body)
            const localVarPath = `/v1/auth/verify/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary VerifyPhone - Completes verification process for phone number
         * @param {V1VerifyPhoneRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifyPhone: async (body: V1VerifyPhoneRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceVerifyPhone', 'body', body)
            const localVarPath = `/v1/auth/verify/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary VerifySoftwareToken - Completes the process of associating a TOTP device with user account
         * @param {V1VerifySoftwareTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifySoftwareToken: async (body: V1VerifySoftwareTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authServiceVerifySoftwareToken', 'body', body)
            const localVarPath = `/v1/auth/totp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthServiceApi - functional programming interface
 * @export
 */
export const AuthServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AssociateSoftwareToken - Starts the process of associating a TOTP device with user account
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceAssociateSoftwareToken(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AssociateSoftwareTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceAssociateSoftwareToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CheckUniqueness - Check if a username, email, or phone number is unique.
         * @param {V1CheckUniquenessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceCheckUniqueness(body: V1CheckUniquenessRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CheckUniquenessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceCheckUniqueness(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ConfirmForgotPassword - Completes the forget password flow
         * @param {V1ConfirmForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceConfirmForgotPassword(body: V1ConfirmForgotPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceConfirmForgotPassword(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateUser - Registers a user with the identity provider
         * @param {Authpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceCreateUser(body: Authpbv1CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Authpbv1CreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceCreateUser(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateUserFromExternalIdp - Registers a user with the identity provider from an external idp
         * @param {V1CreateUserFromExternalIdpRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceCreateUserFromExternalIdp(body: V1CreateUserFromExternalIdpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceCreateUserFromExternalIdp(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ForgotPassword - Sends a message to user with a confirmation code that is required to change the user\'s password
         * @param {V1ForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceForgotPassword(body: V1ForgotPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ForgotPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceForgotPassword(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetTokens
         * @param {Authpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceGetTokens(body: Authpbv1GetTokensRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Authpbv1GetTokensResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceGetTokens(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceLogin(body: Authpbv1LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Authpbv1LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceLogin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout - Invalidates a given JWT refresh token
         * @param {Authpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceLogout(body: Authpbv1LogoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceLogout(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary MFALogin - Responds to MFA challenge and receive tokens if successful
         * @param {V1MFALoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceMFALogin(body: V1MFALoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1MFALoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceMFALogin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary RefreshTokens - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceRefreshToken(body: Authpbv1RefreshTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Authpbv1RefreshTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRefreshToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceRegisterSSO(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RegisterSSOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRegisterSSO(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SendVerifyEmail - Starts verification process for email
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceSendVerifyEmail(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceSendVerifyEmail(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SendVerifyPhone - Starts verification process for phone number
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceSendVerifyPhone(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceSendVerifyPhone(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ToggleMFAPreference - Toggles a user\'s SMS / Software Token MFA preference on / off
         * @param {V1ToggleMFAPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceToggleMFAPreference(body: V1ToggleMFAPreferenceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ToggleMFAPreferenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceToggleMFAPreference(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary VerifyEmail - Completes verification process for email
         * @param {V1VerifyEmailRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceVerifyEmail(body: V1VerifyEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceVerifyEmail(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary VerifyPhone - Completes verification process for phone number
         * @param {V1VerifyPhoneRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceVerifyPhone(body: V1VerifyPhoneRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceVerifyPhone(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary VerifySoftwareToken - Completes the process of associating a TOTP device with user account
         * @param {V1VerifySoftwareTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceVerifySoftwareToken(body: V1VerifySoftwareTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceVerifySoftwareToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthServiceApi - factory interface
 * @export
 */
export const AuthServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary AssociateSoftwareToken - Starts the process of associating a TOTP device with user account
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceAssociateSoftwareToken(body: object, options?: any): AxiosPromise<V1AssociateSoftwareTokenResponse> {
            return localVarFp.authServiceAssociateSoftwareToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CheckUniqueness - Check if a username, email, or phone number is unique.
         * @param {V1CheckUniquenessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCheckUniqueness(body: V1CheckUniquenessRequest, options?: any): AxiosPromise<V1CheckUniquenessResponse> {
            return localVarFp.authServiceCheckUniqueness(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ConfirmForgotPassword - Completes the forget password flow
         * @param {V1ConfirmForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceConfirmForgotPassword(body: V1ConfirmForgotPasswordRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceConfirmForgotPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateUser - Registers a user with the identity provider
         * @param {Authpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCreateUser(body: Authpbv1CreateUserRequest, options?: any): AxiosPromise<Authpbv1CreateUserResponse> {
            return localVarFp.authServiceCreateUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateUserFromExternalIdp - Registers a user with the identity provider from an external idp
         * @param {V1CreateUserFromExternalIdpRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceCreateUserFromExternalIdp(body: V1CreateUserFromExternalIdpRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceCreateUserFromExternalIdp(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ForgotPassword - Sends a message to user with a confirmation code that is required to change the user\'s password
         * @param {V1ForgotPasswordRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceForgotPassword(body: V1ForgotPasswordRequest, options?: any): AxiosPromise<V1ForgotPasswordResponse> {
            return localVarFp.authServiceForgotPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetTokens
         * @param {Authpbv1GetTokensRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGetTokens(body: Authpbv1GetTokensRequest, options?: any): AxiosPromise<Authpbv1GetTokensResponse> {
            return localVarFp.authServiceGetTokens(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogin(body: Authpbv1LoginRequest, options?: any): AxiosPromise<Authpbv1LoginResponse> {
            return localVarFp.authServiceLogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout - Invalidates a given JWT refresh token
         * @param {Authpbv1LogoutRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogout(body: Authpbv1LogoutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceLogout(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary MFALogin - Responds to MFA challenge and receive tokens if successful
         * @param {V1MFALoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceMFALogin(body: V1MFALoginRequest, options?: any): AxiosPromise<V1MFALoginResponse> {
            return localVarFp.authServiceMFALogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RefreshTokens - Logs in user with Username / Password and returns JWT authentication tokens
         * @param {Authpbv1RefreshTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRefreshToken(body: Authpbv1RefreshTokenRequest, options?: any): AxiosPromise<Authpbv1RefreshTokenResponse> {
            return localVarFp.authServiceRefreshToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRegisterSSO(body: object, options?: any): AxiosPromise<V1RegisterSSOResponse> {
            return localVarFp.authServiceRegisterSSO(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SendVerifyEmail - Starts verification process for email
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceSendVerifyEmail(body: object, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceSendVerifyEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SendVerifyPhone - Starts verification process for phone number
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceSendVerifyPhone(body: object, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceSendVerifyPhone(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ToggleMFAPreference - Toggles a user\'s SMS / Software Token MFA preference on / off
         * @param {V1ToggleMFAPreferenceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceToggleMFAPreference(body: V1ToggleMFAPreferenceRequest, options?: any): AxiosPromise<V1ToggleMFAPreferenceResponse> {
            return localVarFp.authServiceToggleMFAPreference(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary VerifyEmail - Completes verification process for email
         * @param {V1VerifyEmailRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifyEmail(body: V1VerifyEmailRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceVerifyEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary VerifyPhone - Completes verification process for phone number
         * @param {V1VerifyPhoneRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifyPhone(body: V1VerifyPhoneRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceVerifyPhone(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary VerifySoftwareToken - Completes the process of associating a TOTP device with user account
         * @param {V1VerifySoftwareTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceVerifySoftwareToken(body: V1VerifySoftwareTokenRequest, options?: any): AxiosPromise<object> {
            return localVarFp.authServiceVerifySoftwareToken(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthServiceApi - object-oriented interface
 * @export
 * @class AuthServiceApi
 * @extends {BaseAPI}
 */
export class AuthServiceApi extends BaseAPI {
    /**
     * 
     * @summary AssociateSoftwareToken - Starts the process of associating a TOTP device with user account
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceAssociateSoftwareToken(body: object, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceAssociateSoftwareToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CheckUniqueness - Check if a username, email, or phone number is unique.
     * @param {V1CheckUniquenessRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceCheckUniqueness(body: V1CheckUniquenessRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceCheckUniqueness(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ConfirmForgotPassword - Completes the forget password flow
     * @param {V1ConfirmForgotPasswordRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceConfirmForgotPassword(body: V1ConfirmForgotPasswordRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceConfirmForgotPassword(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateUser - Registers a user with the identity provider
     * @param {Authpbv1CreateUserRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceCreateUser(body: Authpbv1CreateUserRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceCreateUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateUserFromExternalIdp - Registers a user with the identity provider from an external idp
     * @param {V1CreateUserFromExternalIdpRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceCreateUserFromExternalIdp(body: V1CreateUserFromExternalIdpRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceCreateUserFromExternalIdp(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ForgotPassword - Sends a message to user with a confirmation code that is required to change the user\'s password
     * @param {V1ForgotPasswordRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceForgotPassword(body: V1ForgotPasswordRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceForgotPassword(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetTokens
     * @param {Authpbv1GetTokensRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceGetTokens(body: Authpbv1GetTokensRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceGetTokens(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login - Logs in user with Username / Password and returns JWT authentication tokens
     * @param {Authpbv1LoginRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceLogin(body: Authpbv1LoginRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceLogin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout - Invalidates a given JWT refresh token
     * @param {Authpbv1LogoutRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceLogout(body: Authpbv1LogoutRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceLogout(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary MFALogin - Responds to MFA challenge and receive tokens if successful
     * @param {V1MFALoginRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceMFALogin(body: V1MFALoginRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceMFALogin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RefreshTokens - Logs in user with Username / Password and returns JWT authentication tokens
     * @param {Authpbv1RefreshTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceRefreshToken(body: Authpbv1RefreshTokenRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceRefreshToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceRegisterSSO(body: object, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceRegisterSSO(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SendVerifyEmail - Starts verification process for email
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceSendVerifyEmail(body: object, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceSendVerifyEmail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SendVerifyPhone - Starts verification process for phone number
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceSendVerifyPhone(body: object, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceSendVerifyPhone(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ToggleMFAPreference - Toggles a user\'s SMS / Software Token MFA preference on / off
     * @param {V1ToggleMFAPreferenceRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceToggleMFAPreference(body: V1ToggleMFAPreferenceRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceToggleMFAPreference(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary VerifyEmail - Completes verification process for email
     * @param {V1VerifyEmailRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceVerifyEmail(body: V1VerifyEmailRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceVerifyEmail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary VerifyPhone - Completes verification process for phone number
     * @param {V1VerifyPhoneRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceVerifyPhone(body: V1VerifyPhoneRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceVerifyPhone(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary VerifySoftwareToken - Completes the process of associating a TOTP device with user account
     * @param {V1VerifySoftwareTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    public authServiceVerifySoftwareToken(body: V1VerifySoftwareTokenRequest, options?: AxiosRequestConfig) {
        return AuthServiceApiFp(this.configuration).authServiceVerifySoftwareToken(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BlobServiceApi - axios parameter creator
 * @export
 */
export const BlobServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetLink get a signed url for the file
         * @param {Blobpbv1GetLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blobServiceGetLink: async (body: Blobpbv1GetLinkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('blobServiceGetLink', 'body', body)
            const localVarPath = `/v1/blob/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file into the storage
         * @param {V1UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blobServiceUpload: async (body: V1UploadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('blobServiceUpload', 'body', body)
            const localVarPath = `/v1/blob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlobServiceApi - functional programming interface
 * @export
 */
export const BlobServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlobServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetLink get a signed url for the file
         * @param {Blobpbv1GetLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blobServiceGetLink(body: Blobpbv1GetLinkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blobpbv1GetLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blobServiceGetLink(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file into the storage
         * @param {V1UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blobServiceUpload(body: V1UploadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blobServiceUpload(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BlobServiceApi - factory interface
 * @export
 */
export const BlobServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlobServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary GetLink get a signed url for the file
         * @param {Blobpbv1GetLinkRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blobServiceGetLink(body: Blobpbv1GetLinkRequest, options?: any): AxiosPromise<Blobpbv1GetLinkResponse> {
            return localVarFp.blobServiceGetLink(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file into the storage
         * @param {V1UploadRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blobServiceUpload(body: V1UploadRequest, options?: any): AxiosPromise<V1UploadResponse> {
            return localVarFp.blobServiceUpload(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlobServiceApi - object-oriented interface
 * @export
 * @class BlobServiceApi
 * @extends {BaseAPI}
 */
export class BlobServiceApi extends BaseAPI {
    /**
     * 
     * @summary GetLink get a signed url for the file
     * @param {Blobpbv1GetLinkRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobServiceApi
     */
    public blobServiceGetLink(body: Blobpbv1GetLinkRequest, options?: AxiosRequestConfig) {
        return BlobServiceApiFp(this.configuration).blobServiceGetLink(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file into the storage
     * @param {V1UploadRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobServiceApi
     */
    public blobServiceUpload(body: V1UploadRequest, options?: AxiosRequestConfig) {
        return BlobServiceApiFp(this.configuration).blobServiceUpload(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CognitoSamlAdapterServiceApi - axios parameter creator
 * @export
 */
export const CognitoSamlAdapterServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ConvertSamlToHtmlForm - Takes an incoming SAML response and returns and HTML form for client to auto submit
         * @param {V1ConvertSamlToHtmlFormRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoSamlAdapterServiceConvertSamlToHtmlForm: async (body: V1ConvertSamlToHtmlFormRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cognitoSamlAdapterServiceConvertSamlToHtmlForm', 'body', body)
            const localVarPath = `/v1/auth/saml/ashtmlform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CognitoSamlAdapterServiceApi - functional programming interface
 * @export
 */
export const CognitoSamlAdapterServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CognitoSamlAdapterServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ConvertSamlToHtmlForm - Takes an incoming SAML response and returns and HTML form for client to auto submit
         * @param {V1ConvertSamlToHtmlFormRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cognitoSamlAdapterServiceConvertSamlToHtmlForm(body: V1ConvertSamlToHtmlFormRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ConvertSamlToHtmlFormResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cognitoSamlAdapterServiceConvertSamlToHtmlForm(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CognitoSamlAdapterServiceApi - factory interface
 * @export
 */
export const CognitoSamlAdapterServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CognitoSamlAdapterServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary ConvertSamlToHtmlForm - Takes an incoming SAML response and returns and HTML form for client to auto submit
         * @param {V1ConvertSamlToHtmlFormRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoSamlAdapterServiceConvertSamlToHtmlForm(body: V1ConvertSamlToHtmlFormRequest, options?: any): AxiosPromise<V1ConvertSamlToHtmlFormResponse> {
            return localVarFp.cognitoSamlAdapterServiceConvertSamlToHtmlForm(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CognitoSamlAdapterServiceApi - object-oriented interface
 * @export
 * @class CognitoSamlAdapterServiceApi
 * @extends {BaseAPI}
 */
export class CognitoSamlAdapterServiceApi extends BaseAPI {
    /**
     * 
     * @summary ConvertSamlToHtmlForm - Takes an incoming SAML response and returns and HTML form for client to auto submit
     * @param {V1ConvertSamlToHtmlFormRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoSamlAdapterServiceApi
     */
    public cognitoSamlAdapterServiceConvertSamlToHtmlForm(body: V1ConvertSamlToHtmlFormRequest, options?: AxiosRequestConfig) {
        return CognitoSamlAdapterServiceApiFp(this.configuration).cognitoSamlAdapterServiceConvertSamlToHtmlForm(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeeAndCreditAdminServiceApi - axios parameter creator
 * @export
 */
export const FeeAndCreditAdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AddAdvisoryFeeSchedule adds a new advisory fee schedule to the account. The schedule is set with an \"effective date\". Once the effective date is reached, the schedule will start to apply.
         * @param {V1AddAdvisoryFeeScheduleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceAddAdvisoryFeeSchedule: async (body: V1AddAdvisoryFeeScheduleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('feeAndCreditAdminServiceAddAdvisoryFeeSchedule', 'body', body)
            const localVarPath = `/v1/feeandcredit/advisory_fee_schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateCredit executes a manual credit on the account.
         * @param {V1CreateCreditRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceCreateCredit: async (body: V1CreateCreditRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('feeAndCreditAdminServiceCreateCredit', 'body', body)
            const localVarPath = `/v1/feeandcredit/credit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateFee executes a manual fee charge on the account.
         * @param {V1CreateFeeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceCreateFee: async (body: V1CreateFeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('feeAndCreditAdminServiceCreateFee', 'body', body)
            const localVarPath = `/v1/feeandcredit/fee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeeAndCreditAdminServiceApi - functional programming interface
 * @export
 */
export const FeeAndCreditAdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeeAndCreditAdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AddAdvisoryFeeSchedule adds a new advisory fee schedule to the account. The schedule is set with an \"effective date\". Once the effective date is reached, the schedule will start to apply.
         * @param {V1AddAdvisoryFeeScheduleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body: V1AddAdvisoryFeeScheduleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddAdvisoryFeeScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateCredit executes a manual credit on the account.
         * @param {V1CreateCreditRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feeAndCreditAdminServiceCreateCredit(body: V1CreateCreditRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateCreditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feeAndCreditAdminServiceCreateCredit(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateFee executes a manual fee charge on the account.
         * @param {V1CreateFeeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feeAndCreditAdminServiceCreateFee(body: V1CreateFeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateFeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feeAndCreditAdminServiceCreateFee(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeeAndCreditAdminServiceApi - factory interface
 * @export
 */
export const FeeAndCreditAdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeeAndCreditAdminServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary AddAdvisoryFeeSchedule adds a new advisory fee schedule to the account. The schedule is set with an \"effective date\". Once the effective date is reached, the schedule will start to apply.
         * @param {V1AddAdvisoryFeeScheduleRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body: V1AddAdvisoryFeeScheduleRequest, options?: any): AxiosPromise<V1AddAdvisoryFeeScheduleResponse> {
            return localVarFp.feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateCredit executes a manual credit on the account.
         * @param {V1CreateCreditRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceCreateCredit(body: V1CreateCreditRequest, options?: any): AxiosPromise<V1CreateCreditResponse> {
            return localVarFp.feeAndCreditAdminServiceCreateCredit(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateFee executes a manual fee charge on the account.
         * @param {V1CreateFeeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feeAndCreditAdminServiceCreateFee(body: V1CreateFeeRequest, options?: any): AxiosPromise<V1CreateFeeResponse> {
            return localVarFp.feeAndCreditAdminServiceCreateFee(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeeAndCreditAdminServiceApi - object-oriented interface
 * @export
 * @class FeeAndCreditAdminServiceApi
 * @extends {BaseAPI}
 */
export class FeeAndCreditAdminServiceApi extends BaseAPI {
    /**
     * 
     * @summary AddAdvisoryFeeSchedule adds a new advisory fee schedule to the account. The schedule is set with an \"effective date\". Once the effective date is reached, the schedule will start to apply.
     * @param {V1AddAdvisoryFeeScheduleRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeAndCreditAdminServiceApi
     */
    public feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body: V1AddAdvisoryFeeScheduleRequest, options?: AxiosRequestConfig) {
        return FeeAndCreditAdminServiceApiFp(this.configuration).feeAndCreditAdminServiceAddAdvisoryFeeSchedule(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateCredit executes a manual credit on the account.
     * @param {V1CreateCreditRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeAndCreditAdminServiceApi
     */
    public feeAndCreditAdminServiceCreateCredit(body: V1CreateCreditRequest, options?: AxiosRequestConfig) {
        return FeeAndCreditAdminServiceApiFp(this.configuration).feeAndCreditAdminServiceCreateCredit(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateFee executes a manual fee charge on the account.
     * @param {V1CreateFeeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeAndCreditAdminServiceApi
     */
    public feeAndCreditAdminServiceCreateFee(body: V1CreateFeeRequest, options?: AxiosRequestConfig) {
        return FeeAndCreditAdminServiceApiFp(this.configuration).feeAndCreditAdminServiceCreateFee(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ICTServiceApi - axios parameter creator
 * @export
 */
export const ICTServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ConnectAccount creates a new ICT external account in the system that can be used for depositing and withdrawing funds.
         * @param {V1ConnectAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iCTServiceConnectAccount: async (body: V1ConnectAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('iCTServiceConnectAccount', 'body', body)
            const localVarPath = `/v1/ict/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DisconnectAccount disallows the external account from being used for depositing and withdrawing funds in the system.
         * @param {string} externalAccountId ExternalAccountId is the id of the account to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iCTServiceDisconnectAccount: async (externalAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalAccountId' is not null or undefined
            assertParamExists('iCTServiceDisconnectAccount', 'externalAccountId', externalAccountId)
            const localVarPath = `/v1/ict/account/{externalAccountId}`
                .replace(`{${"externalAccountId"}}`, encodeURIComponent(String(externalAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ICTServiceApi - functional programming interface
 * @export
 */
export const ICTServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ICTServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ConnectAccount creates a new ICT external account in the system that can be used for depositing and withdrawing funds.
         * @param {V1ConnectAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iCTServiceConnectAccount(body: V1ConnectAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ConnectAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iCTServiceConnectAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary DisconnectAccount disallows the external account from being used for depositing and withdrawing funds in the system.
         * @param {string} externalAccountId ExternalAccountId is the id of the account to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iCTServiceDisconnectAccount(externalAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iCTServiceDisconnectAccount(externalAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ICTServiceApi - factory interface
 * @export
 */
export const ICTServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ICTServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary ConnectAccount creates a new ICT external account in the system that can be used for depositing and withdrawing funds.
         * @param {V1ConnectAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iCTServiceConnectAccount(body: V1ConnectAccountRequest, options?: any): AxiosPromise<V1ConnectAccountResponse> {
            return localVarFp.iCTServiceConnectAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DisconnectAccount disallows the external account from being used for depositing and withdrawing funds in the system.
         * @param {string} externalAccountId ExternalAccountId is the id of the account to be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iCTServiceDisconnectAccount(externalAccountId: string, options?: any): AxiosPromise<object> {
            return localVarFp.iCTServiceDisconnectAccount(externalAccountId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ICTServiceApi - object-oriented interface
 * @export
 * @class ICTServiceApi
 * @extends {BaseAPI}
 */
export class ICTServiceApi extends BaseAPI {
    /**
     * 
     * @summary ConnectAccount creates a new ICT external account in the system that can be used for depositing and withdrawing funds.
     * @param {V1ConnectAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ICTServiceApi
     */
    public iCTServiceConnectAccount(body: V1ConnectAccountRequest, options?: AxiosRequestConfig) {
        return ICTServiceApiFp(this.configuration).iCTServiceConnectAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DisconnectAccount disallows the external account from being used for depositing and withdrawing funds in the system.
     * @param {string} externalAccountId ExternalAccountId is the id of the account to be removed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ICTServiceApi
     */
    public iCTServiceDisconnectAccount(externalAccountId: string, options?: AxiosRequestConfig) {
        return ICTServiceApiFp(this.configuration).iCTServiceDisconnectAccount(externalAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LiquidateAdminServiceApi - axios parameter creator
 * @export
 */
export const LiquidateAdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * If the liquidation is canceled before any trades go out, the liquidation is completely canceled and trades will not be executed. The original asset distribution will be returned to the source portfolios. If the trades have already started, then the liquidation will be marked as cancelled and the liquidated funds will be returned to the source portfolios. It is up to the caller to re-invest in the assets if desired.  Once the transfer process has started, all cancel requests will fail.
         * @summary CancelLiquidate attempts to cancel a liquidation that is in progress. As a liquidation is a multi-stage process, there is a window of time where the liquidation can be canceled.
         * @param {string} liquidationUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateAdminServiceCancelLiquidate: async (liquidationUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liquidationUid' is not null or undefined
            assertParamExists('liquidateAdminServiceCancelLiquidate', 'liquidationUid', liquidationUid)
            const localVarPath = `/v1/admin/liquidation/{liquidationUid}`
                .replace(`{${"liquidationUid"}}`, encodeURIComponent(String(liquidationUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If there exists any auto-swept liabilities in the account, they will be satisfied first before any of the proceeds are transferred to any of the targets. Is it not required (or allowed) to include the auto-swept liabilities in the transfer targets.  To simply liquidation some funds to meet an auto-swept liability, include the assets to be liquidated and set the remainder target to \"redistribute\". This will satisfy the liabilities and return any funds back to the source portfolios as cash.  Note: Asset will only be pulled from the user\'s Settled or Pending accounts. If there are assets that are frozen or encumbered in any way they must be canceled before attempting to liquidate.
         * @summary Liquidate runs a liquidation against the given portfolio. The liquidation will sell the assets specified in the request and transfer the proceeds to the targets specified in the request. All remaining assets will be transferred to the remainder target.
         * @param {V1LiquidateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateAdminServiceLiquidate: async (body: V1LiquidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('liquidateAdminServiceLiquidate', 'body', body)
            const localVarPath = `/v1/admin/liquidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiquidateAdminServiceApi - functional programming interface
 * @export
 */
export const LiquidateAdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiquidateAdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * If the liquidation is canceled before any trades go out, the liquidation is completely canceled and trades will not be executed. The original asset distribution will be returned to the source portfolios. If the trades have already started, then the liquidation will be marked as cancelled and the liquidated funds will be returned to the source portfolios. It is up to the caller to re-invest in the assets if desired.  Once the transfer process has started, all cancel requests will fail.
         * @summary CancelLiquidate attempts to cancel a liquidation that is in progress. As a liquidation is a multi-stage process, there is a window of time where the liquidation can be canceled.
         * @param {string} liquidationUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liquidateAdminServiceCancelLiquidate(liquidationUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liquidateAdminServiceCancelLiquidate(liquidationUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * If there exists any auto-swept liabilities in the account, they will be satisfied first before any of the proceeds are transferred to any of the targets. Is it not required (or allowed) to include the auto-swept liabilities in the transfer targets.  To simply liquidation some funds to meet an auto-swept liability, include the assets to be liquidated and set the remainder target to \"redistribute\". This will satisfy the liabilities and return any funds back to the source portfolios as cash.  Note: Asset will only be pulled from the user\'s Settled or Pending accounts. If there are assets that are frozen or encumbered in any way they must be canceled before attempting to liquidate.
         * @summary Liquidate runs a liquidation against the given portfolio. The liquidation will sell the assets specified in the request and transfer the proceeds to the targets specified in the request. All remaining assets will be transferred to the remainder target.
         * @param {V1LiquidateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liquidateAdminServiceLiquidate(body: V1LiquidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1LiquidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liquidateAdminServiceLiquidate(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LiquidateAdminServiceApi - factory interface
 * @export
 */
export const LiquidateAdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiquidateAdminServiceApiFp(configuration)
    return {
        /**
         * If the liquidation is canceled before any trades go out, the liquidation is completely canceled and trades will not be executed. The original asset distribution will be returned to the source portfolios. If the trades have already started, then the liquidation will be marked as cancelled and the liquidated funds will be returned to the source portfolios. It is up to the caller to re-invest in the assets if desired.  Once the transfer process has started, all cancel requests will fail.
         * @summary CancelLiquidate attempts to cancel a liquidation that is in progress. As a liquidation is a multi-stage process, there is a window of time where the liquidation can be canceled.
         * @param {string} liquidationUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateAdminServiceCancelLiquidate(liquidationUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.liquidateAdminServiceCancelLiquidate(liquidationUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * If there exists any auto-swept liabilities in the account, they will be satisfied first before any of the proceeds are transferred to any of the targets. Is it not required (or allowed) to include the auto-swept liabilities in the transfer targets.  To simply liquidation some funds to meet an auto-swept liability, include the assets to be liquidated and set the remainder target to \"redistribute\". This will satisfy the liabilities and return any funds back to the source portfolios as cash.  Note: Asset will only be pulled from the user\'s Settled or Pending accounts. If there are assets that are frozen or encumbered in any way they must be canceled before attempting to liquidate.
         * @summary Liquidate runs a liquidation against the given portfolio. The liquidation will sell the assets specified in the request and transfer the proceeds to the targets specified in the request. All remaining assets will be transferred to the remainder target.
         * @param {V1LiquidateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateAdminServiceLiquidate(body: V1LiquidateRequest, options?: any): AxiosPromise<V1LiquidateResponse> {
            return localVarFp.liquidateAdminServiceLiquidate(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiquidateAdminServiceApi - object-oriented interface
 * @export
 * @class LiquidateAdminServiceApi
 * @extends {BaseAPI}
 */
export class LiquidateAdminServiceApi extends BaseAPI {
    /**
     * If the liquidation is canceled before any trades go out, the liquidation is completely canceled and trades will not be executed. The original asset distribution will be returned to the source portfolios. If the trades have already started, then the liquidation will be marked as cancelled and the liquidated funds will be returned to the source portfolios. It is up to the caller to re-invest in the assets if desired.  Once the transfer process has started, all cancel requests will fail.
     * @summary CancelLiquidate attempts to cancel a liquidation that is in progress. As a liquidation is a multi-stage process, there is a window of time where the liquidation can be canceled.
     * @param {string} liquidationUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiquidateAdminServiceApi
     */
    public liquidateAdminServiceCancelLiquidate(liquidationUid: string, reason?: string, options?: AxiosRequestConfig) {
        return LiquidateAdminServiceApiFp(this.configuration).liquidateAdminServiceCancelLiquidate(liquidationUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If there exists any auto-swept liabilities in the account, they will be satisfied first before any of the proceeds are transferred to any of the targets. Is it not required (or allowed) to include the auto-swept liabilities in the transfer targets.  To simply liquidation some funds to meet an auto-swept liability, include the assets to be liquidated and set the remainder target to \"redistribute\". This will satisfy the liabilities and return any funds back to the source portfolios as cash.  Note: Asset will only be pulled from the user\'s Settled or Pending accounts. If there are assets that are frozen or encumbered in any way they must be canceled before attempting to liquidate.
     * @summary Liquidate runs a liquidation against the given portfolio. The liquidation will sell the assets specified in the request and transfer the proceeds to the targets specified in the request. All remaining assets will be transferred to the remainder target.
     * @param {V1LiquidateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiquidateAdminServiceApi
     */
    public liquidateAdminServiceLiquidate(body: V1LiquidateRequest, options?: AxiosRequestConfig) {
        return LiquidateAdminServiceApiFp(this.configuration).liquidateAdminServiceLiquidate(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarketHoursServiceApi - axios parameter creator
 * @export
 */
export const MarketHoursServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GetAllMarketsStatus returns the status and operating hours for all offered markets for the requested date.
         * @summary GetAllMarketsStatus
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetAllMarketsStatus: async (dateYear?: number, dateMonth?: number, dateDay?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/markethours/allmarkets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateYear !== undefined) {
                localVarQueryParameter['date.year'] = dateYear;
            }

            if (dateMonth !== undefined) {
                localVarQueryParameter['date.month'] = dateMonth;
            }

            if (dateDay !== undefined) {
                localVarQueryParameter['date.day'] = dateDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetMarketStatus returns the status and operating hours for the requested market for the requested date.
         * @summary GetMarketStatus
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetMarketStatus: async (marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', dateYear?: number, dateMonth?: number, dateDay?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/markethours/marketstatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (marketType !== undefined) {
                localVarQueryParameter['marketType'] = marketType;
            }

            if (dateYear !== undefined) {
                localVarQueryParameter['date.year'] = dateYear;
            }

            if (dateMonth !== undefined) {
                localVarQueryParameter['date.month'] = dateMonth;
            }

            if (dateDay !== undefined) {
                localVarQueryParameter['date.day'] = dateDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetNextBusinessDays returns the date of the Nth next business day for the requested market.
         * @summary GetNextBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day after the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetNextBusinessDays: async (marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/markethours/get-next-business-days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (marketType !== undefined) {
                localVarQueryParameter['marketType'] = marketType;
            }

            if (startDateYear !== undefined) {
                localVarQueryParameter['startDate.year'] = startDateYear;
            }

            if (startDateMonth !== undefined) {
                localVarQueryParameter['startDate.month'] = startDateMonth;
            }

            if (startDateDay !== undefined) {
                localVarQueryParameter['startDate.day'] = startDateDay;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (inclusive !== undefined) {
                localVarQueryParameter['inclusive'] = inclusive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetPreviousBusinessDays returns the date of the Nth previous business day for the requested market.
         * @summary GetPreviousBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day before the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetPreviousBusinessDays: async (marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/markethours/get-previous-business-days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (marketType !== undefined) {
                localVarQueryParameter['marketType'] = marketType;
            }

            if (startDateYear !== undefined) {
                localVarQueryParameter['startDate.year'] = startDateYear;
            }

            if (startDateMonth !== undefined) {
                localVarQueryParameter['startDate.month'] = startDateMonth;
            }

            if (startDateDay !== undefined) {
                localVarQueryParameter['startDate.day'] = startDateDay;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (inclusive !== undefined) {
                localVarQueryParameter['inclusive'] = inclusive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketHoursServiceApi - functional programming interface
 * @export
 */
export const MarketHoursServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketHoursServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * GetAllMarketsStatus returns the status and operating hours for all offered markets for the requested date.
         * @summary GetAllMarketsStatus
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketHoursServiceGetAllMarketsStatus(dateYear?: number, dateMonth?: number, dateDay?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAllMarketsStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketHoursServiceGetAllMarketsStatus(dateYear, dateMonth, dateDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * GetMarketStatus returns the status and operating hours for the requested market for the requested date.
         * @summary GetMarketStatus
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketHoursServiceGetMarketStatus(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', dateYear?: number, dateMonth?: number, dateDay?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetMarketStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketHoursServiceGetMarketStatus(marketType, dateYear, dateMonth, dateDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * GetNextBusinessDays returns the date of the Nth next business day for the requested market.
         * @summary GetNextBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day after the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketHoursServiceGetNextBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetNextBusinessDaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketHoursServiceGetNextBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * GetPreviousBusinessDays returns the date of the Nth previous business day for the requested market.
         * @summary GetPreviousBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day before the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketHoursServiceGetPreviousBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPreviousBusinessDaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketHoursServiceGetPreviousBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketHoursServiceApi - factory interface
 * @export
 */
export const MarketHoursServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketHoursServiceApiFp(configuration)
    return {
        /**
         * GetAllMarketsStatus returns the status and operating hours for all offered markets for the requested date.
         * @summary GetAllMarketsStatus
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetAllMarketsStatus(dateYear?: number, dateMonth?: number, dateDay?: number, options?: any): AxiosPromise<V1GetAllMarketsStatusResponse> {
            return localVarFp.marketHoursServiceGetAllMarketsStatus(dateYear, dateMonth, dateDay, options).then((request) => request(axios, basePath));
        },
        /**
         * GetMarketStatus returns the status and operating hours for the requested market for the requested date.
         * @summary GetMarketStatus
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetMarketStatus(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', dateYear?: number, dateMonth?: number, dateDay?: number, options?: any): AxiosPromise<V1GetMarketStatusResponse> {
            return localVarFp.marketHoursServiceGetMarketStatus(marketType, dateYear, dateMonth, dateDay, options).then((request) => request(axios, basePath));
        },
        /**
         * GetNextBusinessDays returns the date of the Nth next business day for the requested market.
         * @summary GetNextBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day after the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetNextBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: any): AxiosPromise<V1GetNextBusinessDaysResponse> {
            return localVarFp.marketHoursServiceGetNextBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options).then((request) => request(axios, basePath));
        },
        /**
         * GetPreviousBusinessDays returns the date of the Nth previous business day for the requested market.
         * @summary GetPreviousBusinessDays
         * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
         * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
         * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
         * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
         * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day before the start_date to return.
         * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketHoursServiceGetPreviousBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: any): AxiosPromise<V1GetPreviousBusinessDaysResponse> {
            return localVarFp.marketHoursServiceGetPreviousBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketHoursServiceApi - object-oriented interface
 * @export
 * @class MarketHoursServiceApi
 * @extends {BaseAPI}
 */
export class MarketHoursServiceApi extends BaseAPI {
    /**
     * GetAllMarketsStatus returns the status and operating hours for all offered markets for the requested date.
     * @summary GetAllMarketsStatus
     * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketHoursServiceApi
     */
    public marketHoursServiceGetAllMarketsStatus(dateYear?: number, dateMonth?: number, dateDay?: number, options?: AxiosRequestConfig) {
        return MarketHoursServiceApiFp(this.configuration).marketHoursServiceGetAllMarketsStatus(dateYear, dateMonth, dateDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetMarketStatus returns the status and operating hours for the requested market for the requested date.
     * @summary GetMarketStatus
     * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
     * @param {number} [dateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @param {number} [dateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @param {number} [dateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketHoursServiceApi
     */
    public marketHoursServiceGetMarketStatus(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', dateYear?: number, dateMonth?: number, dateDay?: number, options?: AxiosRequestConfig) {
        return MarketHoursServiceApiFp(this.configuration).marketHoursServiceGetMarketStatus(marketType, dateYear, dateMonth, dateDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetNextBusinessDays returns the date of the Nth next business day for the requested market.
     * @summary GetNextBusinessDays
     * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
     * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day after the start_date to return.
     * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketHoursServiceApi
     */
    public marketHoursServiceGetNextBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: AxiosRequestConfig) {
        return MarketHoursServiceApiFp(this.configuration).marketHoursServiceGetNextBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetPreviousBusinessDays returns the date of the Nth previous business day for the requested market.
     * @summary GetPreviousBusinessDays
     * @param {'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING'} [marketType] 
     * @param {number} [startDateYear] Year of the date. Must be from 1 to 9999. Set to 0 to specify a date without a year.
     * @param {number} [startDateMonth] Month of a year. Must be from 1 to 12. Set to 0 to specify a year without a month. If zero, day is ignored.
     * @param {number} [startDateDay] Day of a month. Must be valid for the year and month. May be 0 to specify a year/month by itself.
     * @param {number} [days] Days indicates we\&#39;re looking for the nth open business day before the start_date to return.
     * @param {boolean} [inclusive] Inclusive indicates whether the start_date should be counted as the first business day in the calculation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketHoursServiceApi
     */
    public marketHoursServiceGetPreviousBusinessDays(marketType?: 'MARKET_TYPE_UNSPECIFIED' | 'MARKET_TYPE_SECURITIES' | 'MARKET_TYPE_CRYPTO' | 'MARKET_TYPE_BANKING', startDateYear?: number, startDateMonth?: number, startDateDay?: number, days?: number, inclusive?: boolean, options?: AxiosRequestConfig) {
        return MarketHoursServiceApiFp(this.configuration).marketHoursServiceGetPreviousBusinessDays(marketType, startDateYear, startDateMonth, startDateDay, days, inclusive, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MigrateUsersServiceApi - axios parameter creator
 * @export
 */
export const MigrateUsersServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary MigrateUsers
         * @param {V1MigrateUsersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateUsersServiceMigrateUsers: async (body: V1MigrateUsersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('migrateUsersServiceMigrateUsers', 'body', body)
            const localVarPath = `/v1/admin/users/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MigrateUsersServiceApi - functional programming interface
 * @export
 */
export const MigrateUsersServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MigrateUsersServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary MigrateUsers
         * @param {V1MigrateUsersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateUsersServiceMigrateUsers(body: V1MigrateUsersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateUsersServiceMigrateUsers(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MigrateUsersServiceApi - factory interface
 * @export
 */
export const MigrateUsersServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MigrateUsersServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary MigrateUsers
         * @param {V1MigrateUsersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateUsersServiceMigrateUsers(body: V1MigrateUsersRequest, options?: any): AxiosPromise<object> {
            return localVarFp.migrateUsersServiceMigrateUsers(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MigrateUsersServiceApi - object-oriented interface
 * @export
 * @class MigrateUsersServiceApi
 * @extends {BaseAPI}
 */
export class MigrateUsersServiceApi extends BaseAPI {
    /**
     * 
     * @summary MigrateUsers
     * @param {V1MigrateUsersRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrateUsersServiceApi
     */
    public migrateUsersServiceMigrateUsers(body: V1MigrateUsersRequest, options?: AxiosRequestConfig) {
        return MigrateUsersServiceApiFp(this.configuration).migrateUsersServiceMigrateUsers(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PingServiceApi - axios parameter creator
 * @export
 */
export const PingServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ConvertUID
         * @param {string} [stringUid] 
         * @param {string} [bytesUid] 
         * @param {string} [byte64Rep] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingServiceConvertUID: async (stringUid?: string, bytesUid?: string, byte64Rep?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/byte_converter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stringUid !== undefined) {
                localVarQueryParameter['stringUid'] = stringUid;
            }

            if (bytesUid !== undefined) {
                localVarQueryParameter['bytesUid'] = bytesUid;
            }

            if (byte64Rep !== undefined) {
                localVarQueryParameter['byte64Rep'] = byte64Rep;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingServicePing: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingServiceApi - functional programming interface
 * @export
 */
export const PingServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ConvertUID
         * @param {string} [stringUid] 
         * @param {string} [bytesUid] 
         * @param {string} [byte64Rep] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingServiceConvertUID(stringUid?: string, bytesUid?: string, byte64Rep?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ConvertUIDResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingServiceConvertUID(stringUid, bytesUid, byte64Rep, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingServicePing(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingServicePing(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PingServiceApi - factory interface
 * @export
 */
export const PingServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary ConvertUID
         * @param {string} [stringUid] 
         * @param {string} [bytesUid] 
         * @param {string} [byte64Rep] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingServiceConvertUID(stringUid?: string, bytesUid?: string, byte64Rep?: string, options?: any): AxiosPromise<V1ConvertUIDResponse> {
            return localVarFp.pingServiceConvertUID(stringUid, bytesUid, byte64Rep, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingServicePing(options?: any): AxiosPromise<V1PingResponse> {
            return localVarFp.pingServicePing(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingServiceApi - object-oriented interface
 * @export
 * @class PingServiceApi
 * @extends {BaseAPI}
 */
export class PingServiceApi extends BaseAPI {
    /**
     * 
     * @summary ConvertUID
     * @param {string} [stringUid] 
     * @param {string} [bytesUid] 
     * @param {string} [byte64Rep] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingServiceApi
     */
    public pingServiceConvertUID(stringUid?: string, bytesUid?: string, byte64Rep?: string, options?: AxiosRequestConfig) {
        return PingServiceApiFp(this.configuration).pingServiceConvertUID(stringUid, bytesUid, byte64Rep, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingServiceApi
     */
    public pingServicePing(options?: AxiosRequestConfig) {
        return PingServiceApiFp(this.configuration).pingServicePing(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaidServiceApi - axios parameter creator
 * @export
 */
export const PlaidServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CreateLinkToken creates a Plaid LinkToken to initialize Plaid Link in the frontend.
         * @summary CreateLinkToken
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] UserUid is the user who is going to connect bank account using Plaid UserUid is only needed for not authenticated users and it\&#39;s the device unique identifier. https://plaid.com/docs/api/tokens/#link-token-create-request-user-client-user-id Deprecated: use redirect uri or android_package_name
         * @param {string} [relationshipOwnerUid] RelationshipOwner is uid of the plaid relationship to use to create the link token.
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceCreateLinkToken: async (platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', relationshipOwnerUid?: string, redirectUri?: string, androidPackageName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/plaid/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (relationshipOwnerUid !== undefined) {
                localVarQueryParameter['relationshipOwnerUid'] = relationshipOwnerUid;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }

            if (androidPackageName !== undefined) {
                localVarQueryParameter['androidPackageName'] = androidPackageName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateLinkTokenForUpdateMode creates a Plaid LinkToken to initialize Plaid Link for update mode in the frontend.
         * @summary CreateLinkTokenForUpdateMode
         * @param {string} [externalAccountUid] ExternalAccountUid is the external account that is connected with the Plaid account that needs to be reconnected.
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] Deprecated: use redirect uri or android_package_name
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceCreateLinkTokenForUpdateMode: async (externalAccountUid?: string, platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', redirectUri?: string, androidPackageName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (externalAccountUid !== undefined) {
                localVarQueryParameter['externalAccountUid'] = externalAccountUid;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }

            if (androidPackageName !== undefined) {
                localVarQueryParameter['androidPackageName'] = androidPackageName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LinkAccount creates a Plaid account.
         * @summary LinkAccount
         * @param {V1LinkAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceLinkAccount: async (body: V1LinkAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('plaidServiceLinkAccount', 'body', body)
            const localVarPath = `/v1/plaid/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RefreshItem refreshes Plaid item and update or create APEX ACH relationships. Previously --> POST \'api/v4/plaid/accounts/refresh-item/\'
         * @summary RefreshItem
         * @param {V1RefreshItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceRefreshItem: async (body: V1RefreshItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('plaidServiceRefreshItem', 'body', body)
            const localVarPath = `/v1/plaid/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RemoveAccount removes a Plaid account.
         * @summary RemoveAccount
         * @param {string} externalAccountUid ExternalAccountUid is the external account that is connected with the Plaid account that needs to be removed.
         * @param {string} [comment] 
         * @param {'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX'} [removeBy] 
         * @param {'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceRemoveAccount: async (externalAccountUid: string, comment?: string, removeBy?: 'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX', status?: 'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalAccountUid' is not null or undefined
            assertParamExists('plaidServiceRemoveAccount', 'externalAccountUid', externalAccountUid)
            const localVarPath = `/accounts/{externalAccountUid}`
                .replace(`{${"externalAccountUid"}}`, encodeURIComponent(String(externalAccountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }

            if (removeBy !== undefined) {
                localVarQueryParameter['removeBy'] = removeBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ShouldRefresh let\'s the caller know if the Plaid item requires refresh. Previously --> POST \'api/v4/plaid/accounts/${achAccountID}/check-item/\'
         * @summary ShouldRefresh
         * @param {V1ShouldRefreshRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceShouldRefresh: async (body: V1ShouldRefreshRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('plaidServiceShouldRefresh', 'body', body)
            const localVarPath = `/v1/plaid/should-refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaidServiceApi - functional programming interface
 * @export
 */
export const PlaidServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaidServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CreateLinkToken creates a Plaid LinkToken to initialize Plaid Link in the frontend.
         * @summary CreateLinkToken
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] UserUid is the user who is going to connect bank account using Plaid UserUid is only needed for not authenticated users and it\&#39;s the device unique identifier. https://plaid.com/docs/api/tokens/#link-token-create-request-user-client-user-id Deprecated: use redirect uri or android_package_name
         * @param {string} [relationshipOwnerUid] RelationshipOwner is uid of the plaid relationship to use to create the link token.
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceCreateLinkToken(platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', relationshipOwnerUid?: string, redirectUri?: string, androidPackageName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateLinkTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceCreateLinkToken(platform, relationshipOwnerUid, redirectUri, androidPackageName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateLinkTokenForUpdateMode creates a Plaid LinkToken to initialize Plaid Link for update mode in the frontend.
         * @summary CreateLinkTokenForUpdateMode
         * @param {string} [externalAccountUid] ExternalAccountUid is the external account that is connected with the Plaid account that needs to be reconnected.
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] Deprecated: use redirect uri or android_package_name
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid?: string, platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', redirectUri?: string, androidPackageName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateLinkTokenForUpdateModeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid, platform, redirectUri, androidPackageName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * LinkAccount creates a Plaid account.
         * @summary LinkAccount
         * @param {V1LinkAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceLinkAccount(body: V1LinkAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1LinkAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceLinkAccount(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * RefreshItem refreshes Plaid item and update or create APEX ACH relationships. Previously --> POST \'api/v4/plaid/accounts/refresh-item/\'
         * @summary RefreshItem
         * @param {V1RefreshItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceRefreshItem(body: V1RefreshItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceRefreshItem(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * RemoveAccount removes a Plaid account.
         * @summary RemoveAccount
         * @param {string} externalAccountUid ExternalAccountUid is the external account that is connected with the Plaid account that needs to be removed.
         * @param {string} [comment] 
         * @param {'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX'} [removeBy] 
         * @param {'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceRemoveAccount(externalAccountUid: string, comment?: string, removeBy?: 'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX', status?: 'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceRemoveAccount(externalAccountUid, comment, removeBy, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ShouldRefresh let\'s the caller know if the Plaid item requires refresh. Previously --> POST \'api/v4/plaid/accounts/${achAccountID}/check-item/\'
         * @summary ShouldRefresh
         * @param {V1ShouldRefreshRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidServiceShouldRefresh(body: V1ShouldRefreshRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ShouldRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidServiceShouldRefresh(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaidServiceApi - factory interface
 * @export
 */
export const PlaidServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaidServiceApiFp(configuration)
    return {
        /**
         * CreateLinkToken creates a Plaid LinkToken to initialize Plaid Link in the frontend.
         * @summary CreateLinkToken
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] UserUid is the user who is going to connect bank account using Plaid UserUid is only needed for not authenticated users and it\&#39;s the device unique identifier. https://plaid.com/docs/api/tokens/#link-token-create-request-user-client-user-id Deprecated: use redirect uri or android_package_name
         * @param {string} [relationshipOwnerUid] RelationshipOwner is uid of the plaid relationship to use to create the link token.
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceCreateLinkToken(platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', relationshipOwnerUid?: string, redirectUri?: string, androidPackageName?: string, options?: any): AxiosPromise<V1CreateLinkTokenResponse> {
            return localVarFp.plaidServiceCreateLinkToken(platform, relationshipOwnerUid, redirectUri, androidPackageName, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateLinkTokenForUpdateMode creates a Plaid LinkToken to initialize Plaid Link for update mode in the frontend.
         * @summary CreateLinkTokenForUpdateMode
         * @param {string} [externalAccountUid] ExternalAccountUid is the external account that is connected with the Plaid account that needs to be reconnected.
         * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] Deprecated: use redirect uri or android_package_name
         * @param {string} [redirectUri] 
         * @param {string} [androidPackageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid?: string, platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', redirectUri?: string, androidPackageName?: string, options?: any): AxiosPromise<V1CreateLinkTokenForUpdateModeResponse> {
            return localVarFp.plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid, platform, redirectUri, androidPackageName, options).then((request) => request(axios, basePath));
        },
        /**
         * LinkAccount creates a Plaid account.
         * @summary LinkAccount
         * @param {V1LinkAccountRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceLinkAccount(body: V1LinkAccountRequest, options?: any): AxiosPromise<V1LinkAccountResponse> {
            return localVarFp.plaidServiceLinkAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * RefreshItem refreshes Plaid item and update or create APEX ACH relationships. Previously --> POST \'api/v4/plaid/accounts/refresh-item/\'
         * @summary RefreshItem
         * @param {V1RefreshItemRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceRefreshItem(body: V1RefreshItemRequest, options?: any): AxiosPromise<object> {
            return localVarFp.plaidServiceRefreshItem(body, options).then((request) => request(axios, basePath));
        },
        /**
         * RemoveAccount removes a Plaid account.
         * @summary RemoveAccount
         * @param {string} externalAccountUid ExternalAccountUid is the external account that is connected with the Plaid account that needs to be removed.
         * @param {string} [comment] 
         * @param {'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX'} [removeBy] 
         * @param {'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceRemoveAccount(externalAccountUid: string, comment?: string, removeBy?: 'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX', status?: 'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED', options?: any): AxiosPromise<object> {
            return localVarFp.plaidServiceRemoveAccount(externalAccountUid, comment, removeBy, status, options).then((request) => request(axios, basePath));
        },
        /**
         * ShouldRefresh let\'s the caller know if the Plaid item requires refresh. Previously --> POST \'api/v4/plaid/accounts/${achAccountID}/check-item/\'
         * @summary ShouldRefresh
         * @param {V1ShouldRefreshRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidServiceShouldRefresh(body: V1ShouldRefreshRequest, options?: any): AxiosPromise<V1ShouldRefreshResponse> {
            return localVarFp.plaidServiceShouldRefresh(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaidServiceApi - object-oriented interface
 * @export
 * @class PlaidServiceApi
 * @extends {BaseAPI}
 */
export class PlaidServiceApi extends BaseAPI {
    /**
     * CreateLinkToken creates a Plaid LinkToken to initialize Plaid Link in the frontend.
     * @summary CreateLinkToken
     * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] UserUid is the user who is going to connect bank account using Plaid UserUid is only needed for not authenticated users and it\&#39;s the device unique identifier. https://plaid.com/docs/api/tokens/#link-token-create-request-user-client-user-id Deprecated: use redirect uri or android_package_name
     * @param {string} [relationshipOwnerUid] RelationshipOwner is uid of the plaid relationship to use to create the link token.
     * @param {string} [redirectUri] 
     * @param {string} [androidPackageName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceCreateLinkToken(platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', relationshipOwnerUid?: string, redirectUri?: string, androidPackageName?: string, options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceCreateLinkToken(platform, relationshipOwnerUid, redirectUri, androidPackageName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateLinkTokenForUpdateMode creates a Plaid LinkToken to initialize Plaid Link for update mode in the frontend.
     * @summary CreateLinkTokenForUpdateMode
     * @param {string} [externalAccountUid] ExternalAccountUid is the external account that is connected with the Plaid account that needs to be reconnected.
     * @param {'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID'} [platform] Deprecated: use redirect uri or android_package_name
     * @param {string} [redirectUri] 
     * @param {string} [androidPackageName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid?: string, platform?: 'PLATFORM_UNSPECIFIED' | 'PLATFORM_IOS' | 'PLATFORM_ANDROID', redirectUri?: string, androidPackageName?: string, options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceCreateLinkTokenForUpdateMode(externalAccountUid, platform, redirectUri, androidPackageName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LinkAccount creates a Plaid account.
     * @summary LinkAccount
     * @param {V1LinkAccountRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceLinkAccount(body: V1LinkAccountRequest, options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceLinkAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RefreshItem refreshes Plaid item and update or create APEX ACH relationships. Previously --> POST \'api/v4/plaid/accounts/refresh-item/\'
     * @summary RefreshItem
     * @param {V1RefreshItemRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceRefreshItem(body: V1RefreshItemRequest, options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceRefreshItem(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RemoveAccount removes a Plaid account.
     * @summary RemoveAccount
     * @param {string} externalAccountUid ExternalAccountUid is the external account that is connected with the Plaid account that needs to be removed.
     * @param {string} [comment] 
     * @param {'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX'} [removeBy] 
     * @param {'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceRemoveAccount(externalAccountUid: string, comment?: string, removeBy?: 'REMOVE_BY_UNSPECIFIED' | 'REMOVE_BY_USER' | 'REMOVE_BY_FINTRON' | 'REMOVE_BY_APEX', status?: 'REMOVE_ACCOUNT_STATUS_UNSPECIFIED' | 'REMOVE_ACCOUNT_STATUS_REJECTED' | 'REMOVE_ACCOUNT_STATUS_CANCELED', options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceRemoveAccount(externalAccountUid, comment, removeBy, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ShouldRefresh let\'s the caller know if the Plaid item requires refresh. Previously --> POST \'api/v4/plaid/accounts/${achAccountID}/check-item/\'
     * @summary ShouldRefresh
     * @param {V1ShouldRefreshRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidServiceApi
     */
    public plaidServiceShouldRefresh(body: V1ShouldRefreshRequest, options?: AxiosRequestConfig) {
        return PlaidServiceApiFp(this.configuration).plaidServiceShouldRefresh(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaidTestServiceApi - axios parameter creator
 * @export
 */
export const PlaidTestServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CreatePublicToken uses `https://plaid.com/docs/api/sandbox/#sandboxpublic_tokencreate` endpoint to deliver a public token without the need to login to the bank.
         * @param {V1CreatePublicTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidTestServiceCreatePublicToken: async (body: V1CreatePublicTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('plaidTestServiceCreatePublicToken', 'body', body)
            const localVarPath = `/v1/uat/plaid/public-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaidTestServiceApi - functional programming interface
 * @export
 */
export const PlaidTestServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaidTestServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CreatePublicToken uses `https://plaid.com/docs/api/sandbox/#sandboxpublic_tokencreate` endpoint to deliver a public token without the need to login to the bank.
         * @param {V1CreatePublicTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plaidTestServiceCreatePublicToken(body: V1CreatePublicTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreatePublicTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plaidTestServiceCreatePublicToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaidTestServiceApi - factory interface
 * @export
 */
export const PlaidTestServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaidTestServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary CreatePublicToken uses `https://plaid.com/docs/api/sandbox/#sandboxpublic_tokencreate` endpoint to deliver a public token without the need to login to the bank.
         * @param {V1CreatePublicTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plaidTestServiceCreatePublicToken(body: V1CreatePublicTokenRequest, options?: any): AxiosPromise<V1CreatePublicTokenResponse> {
            return localVarFp.plaidTestServiceCreatePublicToken(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaidTestServiceApi - object-oriented interface
 * @export
 * @class PlaidTestServiceApi
 * @extends {BaseAPI}
 */
export class PlaidTestServiceApi extends BaseAPI {
    /**
     * 
     * @summary CreatePublicToken uses `https://plaid.com/docs/api/sandbox/#sandboxpublic_tokencreate` endpoint to deliver a public token without the need to login to the bank.
     * @param {V1CreatePublicTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaidTestServiceApi
     */
    public plaidTestServiceCreatePublicToken(body: V1CreatePublicTokenRequest, options?: AxiosRequestConfig) {
        return PlaidTestServiceApiFp(this.configuration).plaidTestServiceCreatePublicToken(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RTQAdminServiceApi - axios parameter creator
 * @export
 */
export const RTQAdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CreateNewLevelSet creates a new level set.
         * @summary CreateNewLevelSet
         * @param {V1CreateNewLevelSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceCreateNewLevelSet: async (body: V1CreateNewLevelSetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rTQAdminServiceCreateNewLevelSet', 'body', body)
            const localVarPath = `/v1/rtq/portfolio-level-set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SetActiveQuestionnaire sets agiven RTQ questionnaire as active, deactivates all previous questionnaires.
         * @summary SetActiveQuestionnaire
         * @param {string} questionnaireId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceSetActiveQuestionnaire: async (questionnaireId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionnaireId' is not null or undefined
            assertParamExists('rTQAdminServiceSetActiveQuestionnaire', 'questionnaireId', questionnaireId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rTQAdminServiceSetActiveQuestionnaire', 'body', body)
            const localVarPath = `/v1/rtq/questionnaire/{questionnaireId}/active`
                .replace(`{${"questionnaireId"}}`, encodeURIComponent(String(questionnaireId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UploadPortfolioLevelMapping submits portfolio mappings.
         * @summary UploadPortfolioLevelMapping
         * @param {V1UploadPortfolioLevelMappingRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceUploadPortfolioLevelMapping: async (body: V1UploadPortfolioLevelMappingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rTQAdminServiceUploadPortfolioLevelMapping', 'body', body)
            const localVarPath = `/v1/rtq/portfolio-level-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UploadQuestionnaire uploads a new RTQ questionnaire.
         * @summary UploadQuestionnaire
         * @param {V1UploadQuestionnaireRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceUploadQuestionnaire: async (body: V1UploadQuestionnaireRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rTQAdminServiceUploadQuestionnaire', 'body', body)
            const localVarPath = `/v1/rtq/questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RTQAdminServiceApi - functional programming interface
 * @export
 */
export const RTQAdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RTQAdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CreateNewLevelSet creates a new level set.
         * @summary CreateNewLevelSet
         * @param {V1CreateNewLevelSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rTQAdminServiceCreateNewLevelSet(body: V1CreateNewLevelSetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateNewLevelSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rTQAdminServiceCreateNewLevelSet(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * SetActiveQuestionnaire sets agiven RTQ questionnaire as active, deactivates all previous questionnaires.
         * @summary SetActiveQuestionnaire
         * @param {string} questionnaireId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rTQAdminServiceSetActiveQuestionnaire(questionnaireId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SetActiveQuestionnaireResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rTQAdminServiceSetActiveQuestionnaire(questionnaireId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UploadPortfolioLevelMapping submits portfolio mappings.
         * @summary UploadPortfolioLevelMapping
         * @param {V1UploadPortfolioLevelMappingRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rTQAdminServiceUploadPortfolioLevelMapping(body: V1UploadPortfolioLevelMappingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rTQAdminServiceUploadPortfolioLevelMapping(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UploadQuestionnaire uploads a new RTQ questionnaire.
         * @summary UploadQuestionnaire
         * @param {V1UploadQuestionnaireRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rTQAdminServiceUploadQuestionnaire(body: V1UploadQuestionnaireRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UploadQuestionnaireResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rTQAdminServiceUploadQuestionnaire(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RTQAdminServiceApi - factory interface
 * @export
 */
export const RTQAdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RTQAdminServiceApiFp(configuration)
    return {
        /**
         * CreateNewLevelSet creates a new level set.
         * @summary CreateNewLevelSet
         * @param {V1CreateNewLevelSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceCreateNewLevelSet(body: V1CreateNewLevelSetRequest, options?: any): AxiosPromise<V1CreateNewLevelSetResponse> {
            return localVarFp.rTQAdminServiceCreateNewLevelSet(body, options).then((request) => request(axios, basePath));
        },
        /**
         * SetActiveQuestionnaire sets agiven RTQ questionnaire as active, deactivates all previous questionnaires.
         * @summary SetActiveQuestionnaire
         * @param {string} questionnaireId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceSetActiveQuestionnaire(questionnaireId: string, body: object, options?: any): AxiosPromise<V1SetActiveQuestionnaireResponse> {
            return localVarFp.rTQAdminServiceSetActiveQuestionnaire(questionnaireId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * UploadPortfolioLevelMapping submits portfolio mappings.
         * @summary UploadPortfolioLevelMapping
         * @param {V1UploadPortfolioLevelMappingRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceUploadPortfolioLevelMapping(body: V1UploadPortfolioLevelMappingRequest, options?: any): AxiosPromise<object> {
            return localVarFp.rTQAdminServiceUploadPortfolioLevelMapping(body, options).then((request) => request(axios, basePath));
        },
        /**
         * UploadQuestionnaire uploads a new RTQ questionnaire.
         * @summary UploadQuestionnaire
         * @param {V1UploadQuestionnaireRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQAdminServiceUploadQuestionnaire(body: V1UploadQuestionnaireRequest, options?: any): AxiosPromise<V1UploadQuestionnaireResponse> {
            return localVarFp.rTQAdminServiceUploadQuestionnaire(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RTQAdminServiceApi - object-oriented interface
 * @export
 * @class RTQAdminServiceApi
 * @extends {BaseAPI}
 */
export class RTQAdminServiceApi extends BaseAPI {
    /**
     * CreateNewLevelSet creates a new level set.
     * @summary CreateNewLevelSet
     * @param {V1CreateNewLevelSetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RTQAdminServiceApi
     */
    public rTQAdminServiceCreateNewLevelSet(body: V1CreateNewLevelSetRequest, options?: AxiosRequestConfig) {
        return RTQAdminServiceApiFp(this.configuration).rTQAdminServiceCreateNewLevelSet(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SetActiveQuestionnaire sets agiven RTQ questionnaire as active, deactivates all previous questionnaires.
     * @summary SetActiveQuestionnaire
     * @param {string} questionnaireId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RTQAdminServiceApi
     */
    public rTQAdminServiceSetActiveQuestionnaire(questionnaireId: string, body: object, options?: AxiosRequestConfig) {
        return RTQAdminServiceApiFp(this.configuration).rTQAdminServiceSetActiveQuestionnaire(questionnaireId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UploadPortfolioLevelMapping submits portfolio mappings.
     * @summary UploadPortfolioLevelMapping
     * @param {V1UploadPortfolioLevelMappingRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RTQAdminServiceApi
     */
    public rTQAdminServiceUploadPortfolioLevelMapping(body: V1UploadPortfolioLevelMappingRequest, options?: AxiosRequestConfig) {
        return RTQAdminServiceApiFp(this.configuration).rTQAdminServiceUploadPortfolioLevelMapping(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UploadQuestionnaire uploads a new RTQ questionnaire.
     * @summary UploadQuestionnaire
     * @param {V1UploadQuestionnaireRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RTQAdminServiceApi
     */
    public rTQAdminServiceUploadQuestionnaire(body: V1UploadQuestionnaireRequest, options?: AxiosRequestConfig) {
        return RTQAdminServiceApiFp(this.configuration).rTQAdminServiceUploadQuestionnaire(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RTQServiceApi - axios parameter creator
 * @export
 */
export const RTQServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CreateSubmission submits user response against a RTQ Questionnaire.
         * @summary CreateSubmission
         * @param {V1CreateSubmissionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQServiceCreateSubmission: async (body: V1CreateSubmissionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rTQServiceCreateSubmission', 'body', body)
            const localVarPath = `/v1/rtq/submission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RTQServiceApi - functional programming interface
 * @export
 */
export const RTQServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RTQServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CreateSubmission submits user response against a RTQ Questionnaire.
         * @summary CreateSubmission
         * @param {V1CreateSubmissionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rTQServiceCreateSubmission(body: V1CreateSubmissionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rTQServiceCreateSubmission(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RTQServiceApi - factory interface
 * @export
 */
export const RTQServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RTQServiceApiFp(configuration)
    return {
        /**
         * CreateSubmission submits user response against a RTQ Questionnaire.
         * @summary CreateSubmission
         * @param {V1CreateSubmissionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rTQServiceCreateSubmission(body: V1CreateSubmissionRequest, options?: any): AxiosPromise<V1CreateSubmissionResponse> {
            return localVarFp.rTQServiceCreateSubmission(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RTQServiceApi - object-oriented interface
 * @export
 * @class RTQServiceApi
 * @extends {BaseAPI}
 */
export class RTQServiceApi extends BaseAPI {
    /**
     * CreateSubmission submits user response against a RTQ Questionnaire.
     * @summary CreateSubmission
     * @param {V1CreateSubmissionRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RTQServiceApi
     */
    public rTQServiceCreateSubmission(body: V1CreateSubmissionRequest, options?: AxiosRequestConfig) {
        return RTQServiceApiFp(this.configuration).rTQServiceCreateSubmission(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReconServiceApi - axios parameter creator
 * @export
 */
export const ReconServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CreateAdminOrder provides the ability to create an order that can be displayed to the user with customer operations.
         * @param {V1CreateAdminOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceCreateAdminOrder: async (body: V1CreateAdminOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reconServiceCreateAdminOrder', 'body', body)
            const localVarPath = `/v1/account/recon/order/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateReconOrder provides the ability to create an order that will adjust account values.
         * @param {V1CreateReconOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceCreateReconOrder: async (body: V1CreateReconOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reconServiceCreateReconOrder', 'body', body)
            const localVarPath = `/v1/account/recon/order/adjust`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modify Order provides the ability to add transactions to an existing order.
         * @param {V1ModifyExistingOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceModifyExistingOrder: async (body: V1ModifyExistingOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reconServiceModifyExistingOrder', 'body', body)
            const localVarPath = `/v1/account/recon/order/modify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RunPennyForTheLot provides the ability to execute a \"penny for the lot\" operation which will cancel all open orders for the provided asset and liquidation the entire position in return for $0.01.
         * @param {V1RunPennyForTheLotRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceRunPennyForTheLot: async (body: V1RunPennyForTheLotRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reconServiceRunPennyForTheLot', 'body', body)
            const localVarPath = `/v1/account/recon/penny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReconServiceApi - functional programming interface
 * @export
 */
export const ReconServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReconServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CreateAdminOrder provides the ability to create an order that can be displayed to the user with customer operations.
         * @param {V1CreateAdminOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconServiceCreateAdminOrder(body: V1CreateAdminOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateAdminOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconServiceCreateAdminOrder(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateReconOrder provides the ability to create an order that will adjust account values.
         * @param {V1CreateReconOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconServiceCreateReconOrder(body: V1CreateReconOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateReconOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconServiceCreateReconOrder(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Modify Order provides the ability to add transactions to an existing order.
         * @param {V1ModifyExistingOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconServiceModifyExistingOrder(body: V1ModifyExistingOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconServiceModifyExistingOrder(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary RunPennyForTheLot provides the ability to execute a \"penny for the lot\" operation which will cancel all open orders for the provided asset and liquidation the entire position in return for $0.01.
         * @param {V1RunPennyForTheLotRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reconServiceRunPennyForTheLot(body: V1RunPennyForTheLotRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reconServiceRunPennyForTheLot(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReconServiceApi - factory interface
 * @export
 */
export const ReconServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReconServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary CreateAdminOrder provides the ability to create an order that can be displayed to the user with customer operations.
         * @param {V1CreateAdminOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceCreateAdminOrder(body: V1CreateAdminOrderRequest, options?: any): AxiosPromise<V1CreateAdminOrderResponse> {
            return localVarFp.reconServiceCreateAdminOrder(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateReconOrder provides the ability to create an order that will adjust account values.
         * @param {V1CreateReconOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceCreateReconOrder(body: V1CreateReconOrderRequest, options?: any): AxiosPromise<V1CreateReconOrderResponse> {
            return localVarFp.reconServiceCreateReconOrder(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modify Order provides the ability to add transactions to an existing order.
         * @param {V1ModifyExistingOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceModifyExistingOrder(body: V1ModifyExistingOrderRequest, options?: any): AxiosPromise<object> {
            return localVarFp.reconServiceModifyExistingOrder(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RunPennyForTheLot provides the ability to execute a \"penny for the lot\" operation which will cancel all open orders for the provided asset and liquidation the entire position in return for $0.01.
         * @param {V1RunPennyForTheLotRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reconServiceRunPennyForTheLot(body: V1RunPennyForTheLotRequest, options?: any): AxiosPromise<object> {
            return localVarFp.reconServiceRunPennyForTheLot(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReconServiceApi - object-oriented interface
 * @export
 * @class ReconServiceApi
 * @extends {BaseAPI}
 */
export class ReconServiceApi extends BaseAPI {
    /**
     * 
     * @summary CreateAdminOrder provides the ability to create an order that can be displayed to the user with customer operations.
     * @param {V1CreateAdminOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconServiceApi
     */
    public reconServiceCreateAdminOrder(body: V1CreateAdminOrderRequest, options?: AxiosRequestConfig) {
        return ReconServiceApiFp(this.configuration).reconServiceCreateAdminOrder(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateReconOrder provides the ability to create an order that will adjust account values.
     * @param {V1CreateReconOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconServiceApi
     */
    public reconServiceCreateReconOrder(body: V1CreateReconOrderRequest, options?: AxiosRequestConfig) {
        return ReconServiceApiFp(this.configuration).reconServiceCreateReconOrder(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modify Order provides the ability to add transactions to an existing order.
     * @param {V1ModifyExistingOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconServiceApi
     */
    public reconServiceModifyExistingOrder(body: V1ModifyExistingOrderRequest, options?: AxiosRequestConfig) {
        return ReconServiceApiFp(this.configuration).reconServiceModifyExistingOrder(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RunPennyForTheLot provides the ability to execute a \"penny for the lot\" operation which will cancel all open orders for the provided asset and liquidation the entire position in return for $0.01.
     * @param {V1RunPennyForTheLotRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconServiceApi
     */
    public reconServiceRunPennyForTheLot(body: V1RunPennyForTheLotRequest, options?: AxiosRequestConfig) {
        return ReconServiceApiFp(this.configuration).reconServiceRunPennyForTheLot(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RecurringRuleServiceApi - axios parameter creator
 * @export
 */
export const RecurringRuleServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GoalSettings adjust the options for how a user\'s goals are handled.
         * @summary GoalSettings
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recurringRuleServiceRunRecurringRuleEtl: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('recurringRuleServiceRunRecurringRuleEtl', 'body', body)
            const localVarPath = `/v1/recurring/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecurringRuleServiceApi - functional programming interface
 * @export
 */
export const RecurringRuleServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecurringRuleServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * GoalSettings adjust the options for how a user\'s goals are handled.
         * @summary GoalSettings
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recurringRuleServiceRunRecurringRuleEtl(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recurringRuleServiceRunRecurringRuleEtl(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecurringRuleServiceApi - factory interface
 * @export
 */
export const RecurringRuleServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecurringRuleServiceApiFp(configuration)
    return {
        /**
         * GoalSettings adjust the options for how a user\'s goals are handled.
         * @summary GoalSettings
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recurringRuleServiceRunRecurringRuleEtl(body: object, options?: any): AxiosPromise<object> {
            return localVarFp.recurringRuleServiceRunRecurringRuleEtl(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecurringRuleServiceApi - object-oriented interface
 * @export
 * @class RecurringRuleServiceApi
 * @extends {BaseAPI}
 */
export class RecurringRuleServiceApi extends BaseAPI {
    /**
     * GoalSettings adjust the options for how a user\'s goals are handled.
     * @summary GoalSettings
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringRuleServiceApi
     */
    public recurringRuleServiceRunRecurringRuleEtl(body: object, options?: AxiosRequestConfig) {
        return RecurringRuleServiceApiFp(this.configuration).recurringRuleServiceRunRecurringRuleEtl(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RemoteAuthServiceApi - axios parameter creator
 * @export
 */
export const RemoteAuthServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * AssociateToken takes a foreign authentication token, generated by a remote system and associates the token with a particular user. This request is only required if the token does not carry the required user information.
         * @summary AssociateToken
         * @param {V1AssociateTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remoteAuthServiceAssociateToken: async (body: V1AssociateTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('remoteAuthServiceAssociateToken', 'body', body)
            const localVarPath = `/v1/auth/associate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RemoteAuthServiceApi - functional programming interface
 * @export
 */
export const RemoteAuthServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RemoteAuthServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * AssociateToken takes a foreign authentication token, generated by a remote system and associates the token with a particular user. This request is only required if the token does not carry the required user information.
         * @summary AssociateToken
         * @param {V1AssociateTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remoteAuthServiceAssociateToken(body: V1AssociateTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remoteAuthServiceAssociateToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RemoteAuthServiceApi - factory interface
 * @export
 */
export const RemoteAuthServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RemoteAuthServiceApiFp(configuration)
    return {
        /**
         * AssociateToken takes a foreign authentication token, generated by a remote system and associates the token with a particular user. This request is only required if the token does not carry the required user information.
         * @summary AssociateToken
         * @param {V1AssociateTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remoteAuthServiceAssociateToken(body: V1AssociateTokenRequest, options?: any): AxiosPromise<object> {
            return localVarFp.remoteAuthServiceAssociateToken(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RemoteAuthServiceApi - object-oriented interface
 * @export
 * @class RemoteAuthServiceApi
 * @extends {BaseAPI}
 */
export class RemoteAuthServiceApi extends BaseAPI {
    /**
     * AssociateToken takes a foreign authentication token, generated by a remote system and associates the token with a particular user. This request is only required if the token does not carry the required user information.
     * @summary AssociateToken
     * @param {V1AssociateTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemoteAuthServiceApi
     */
    public remoteAuthServiceAssociateToken(body: V1AssociateTokenRequest, options?: AxiosRequestConfig) {
        return RemoteAuthServiceApiFp(this.configuration).remoteAuthServiceAssociateToken(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoboServiceApi - axios parameter creator
 * @export
 */
export const RoboServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * AnalyzeGoal takes in the parameters of a goal, runs the GOE algorithm, and returns the statistics and allocation recommendation without storing anything.
         * @summary AnalyzeGoal
         * @param {V1AnalyzeGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceAnalyzeGoal: async (body: V1AnalyzeGoalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceAnalyzeGoal', 'body', body)
            const localVarPath = `/v1/robo/analyze_goal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CancelInfuse cancels a one-time infusion
         * @summary CancelInfuse
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCancelInfuse: async (actionUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionUid' is not null or undefined
            assertParamExists('roboServiceCancelInfuse', 'actionUid', actionUid)
            const localVarPath = `/v1/robo/infuse/cancel/{actionUid}`
                .replace(`{${"actionUid"}}`, encodeURIComponent(String(actionUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CancelWithdraw cancels a withdrawal
         * @summary CancelWithdraw
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCancelWithdraw: async (actionUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionUid' is not null or undefined
            assertParamExists('roboServiceCancelWithdraw', 'actionUid', actionUid)
            const localVarPath = `/v1/robo/withdraw/cancel/{actionUid}`
                .replace(`{${"actionUid"}}`, encodeURIComponent(String(actionUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CloseGeneralInvestment will deactivate the operations of a general investment. General investment must be fully liquidated before it can be closed.
         * @summary CloseGeneralInvestment
         * @param {string} investUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCloseGeneralInvestment: async (investUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investUid' is not null or undefined
            assertParamExists('roboServiceCloseGeneralInvestment', 'investUid', investUid)
            const localVarPath = `/v1/robo/invest/{investUid}`
                .replace(`{${"investUid"}}`, encodeURIComponent(String(investUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CloseGoal will deactivate the operations of a goal. Goal must be fully liquidated before it can be closed.
         * @summary CloseGoal
         * @param {string} goalUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCloseGoal: async (goalUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalUid' is not null or undefined
            assertParamExists('roboServiceCloseGoal', 'goalUid', goalUid)
            const localVarPath = `/v1/robo/goal/{goalUid}`
                .replace(`{${"goalUid"}}`, encodeURIComponent(String(goalUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateRoboGeneralInvestment adds a general investment to the user\'s portfolio.
         * @summary CreateRoboGeneralInvestment
         * @param {V1CreateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCreateRoboGeneralInvestment: async (body: V1CreateRoboGeneralInvestmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceCreateRoboGeneralInvestment', 'body', body)
            const localVarPath = `/v1/robo/invest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Infuse issues a one-time infusion into the allocation associated with the particular robo investment.
         * @summary Infuse
         * @param {V1InfuseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceInfuse: async (body: V1InfuseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceInfuse', 'body', body)
            const localVarPath = `/v1/robo/infuse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PauseInfusions will pause the active infusions into a particular robo investment.
         * @summary PauseInfusions
         * @param {V1PauseInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServicePauseInfusions: async (body: V1PauseInfusionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServicePauseInfusions', 'body', body)
            const localVarPath = `/v1/robo/pause_infusions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ReallocateGoal will check with GOE to see if the target portfolio has changed and will then run a rebalance.
         * @summary ReallocateGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceReallocateGoal: async (goalUid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalUid' is not null or undefined
            assertParamExists('roboServiceReallocateGoal', 'goalUid', goalUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceReallocateGoal', 'body', body)
            const localVarPath = `/v1/robo/goal/{goalUid}/reallocate`
                .replace(`{${"goalUid"}}`, encodeURIComponent(String(goalUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RebalanceGeneralInvestment will take an existing general investment portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGeneralInvestment
         * @param {string} investUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceRebalanceGeneralInvestment: async (investUid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investUid' is not null or undefined
            assertParamExists('roboServiceRebalanceGeneralInvestment', 'investUid', investUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceRebalanceGeneralInvestment', 'body', body)
            const localVarPath = `/v1/robo/invest/{investUid}/rebalance`
                .replace(`{${"investUid"}}`, encodeURIComponent(String(investUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RebalanceGoal will take an existing goal portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceRebalanceGoal: async (goalUid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalUid' is not null or undefined
            assertParamExists('roboServiceRebalanceGoal', 'goalUid', goalUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceRebalanceGoal', 'body', body)
            const localVarPath = `/v1/robo/goal/{goalUid}/rebalance`
                .replace(`{${"goalUid"}}`, encodeURIComponent(String(goalUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ResumeInfusions will immediately resume the planned infusions for the specified robo investment.
         * @summary ResumeInfusions
         * @param {V1ResumeInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceResumeInfusions: async (body: V1ResumeInfusionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceResumeInfusions', 'body', body)
            const localVarPath = `/v1/robo/resume_infusions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * StoreGoal takes in the goal parameters and performs the required steps to store the goal and performs the required steps to create the allocation.
         * @summary StoreGoal
         * @param {V1StoreGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceStoreGoal: async (body: V1StoreGoalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceStoreGoal', 'body', body)
            const localVarPath = `/v1/robo/goal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updating parameters will re-run the GOE algorithm and update the statistics associated with the goal. If the \"reallocate\" flag is set to true, the GOE algorithm is re-run and the assets are reallocated if a different portfolio is returned.
         * @summary UpdateGoal
         * @param {string} goalUid 
         * @param {RoboServiceUpdateGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceUpdateGoal: async (goalUid: string, body: RoboServiceUpdateGoalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalUid' is not null or undefined
            assertParamExists('roboServiceUpdateGoal', 'goalUid', goalUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceUpdateGoal', 'body', body)
            const localVarPath = `/v1/robo/goal/{goalUid}`
                .replace(`{${"goalUid"}}`, encodeURIComponent(String(goalUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateRoboGeneralInvestment updates a general investment in the user\'s portfolio.
         * @summary UpdateRoboGeneralInvestment
         * @param {string} investUid InvestUid is the uid of the general investment.
         * @param {RoboServiceUpdateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceUpdateRoboGeneralInvestment: async (investUid: string, body: RoboServiceUpdateRoboGeneralInvestmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'investUid' is not null or undefined
            assertParamExists('roboServiceUpdateRoboGeneralInvestment', 'investUid', investUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceUpdateRoboGeneralInvestment', 'body', body)
            const localVarPath = `/v1/robo/invest/{investUid}`
                .replace(`{${"investUid"}}`, encodeURIComponent(String(investUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Withdraw allows a user to take funds from a specific robo investment.
         * @summary Withdraw
         * @param {Robopbv1WithdrawRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceWithdraw: async (body: Robopbv1WithdrawRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('roboServiceWithdraw', 'body', body)
            const localVarPath = `/v1/robo/withdraw`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoboServiceApi - functional programming interface
 * @export
 */
export const RoboServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoboServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * AnalyzeGoal takes in the parameters of a goal, runs the GOE algorithm, and returns the statistics and allocation recommendation without storing anything.
         * @summary AnalyzeGoal
         * @param {V1AnalyzeGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceAnalyzeGoal(body: V1AnalyzeGoalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AnalyzeGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceAnalyzeGoal(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CancelInfuse cancels a one-time infusion
         * @summary CancelInfuse
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceCancelInfuse(actionUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceCancelInfuse(actionUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CancelWithdraw cancels a withdrawal
         * @summary CancelWithdraw
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceCancelWithdraw(actionUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceCancelWithdraw(actionUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CloseGeneralInvestment will deactivate the operations of a general investment. General investment must be fully liquidated before it can be closed.
         * @summary CloseGeneralInvestment
         * @param {string} investUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceCloseGeneralInvestment(investUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceCloseGeneralInvestment(investUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CloseGoal will deactivate the operations of a goal. Goal must be fully liquidated before it can be closed.
         * @summary CloseGoal
         * @param {string} goalUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceCloseGoal(goalUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceCloseGoal(goalUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateRoboGeneralInvestment adds a general investment to the user\'s portfolio.
         * @summary CreateRoboGeneralInvestment
         * @param {V1CreateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceCreateRoboGeneralInvestment(body: V1CreateRoboGeneralInvestmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateRoboGeneralInvestmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceCreateRoboGeneralInvestment(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Infuse issues a one-time infusion into the allocation associated with the particular robo investment.
         * @summary Infuse
         * @param {V1InfuseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceInfuse(body: V1InfuseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1InfuseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceInfuse(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PauseInfusions will pause the active infusions into a particular robo investment.
         * @summary PauseInfusions
         * @param {V1PauseInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServicePauseInfusions(body: V1PauseInfusionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServicePauseInfusions(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ReallocateGoal will check with GOE to see if the target portfolio has changed and will then run a rebalance.
         * @summary ReallocateGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceReallocateGoal(goalUid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceReallocateGoal(goalUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * RebalanceGeneralInvestment will take an existing general investment portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGeneralInvestment
         * @param {string} investUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceRebalanceGeneralInvestment(investUid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceRebalanceGeneralInvestment(investUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * RebalanceGoal will take an existing goal portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceRebalanceGoal(goalUid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceRebalanceGoal(goalUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ResumeInfusions will immediately resume the planned infusions for the specified robo investment.
         * @summary ResumeInfusions
         * @param {V1ResumeInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceResumeInfusions(body: V1ResumeInfusionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceResumeInfusions(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * StoreGoal takes in the goal parameters and performs the required steps to store the goal and performs the required steps to create the allocation.
         * @summary StoreGoal
         * @param {V1StoreGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceStoreGoal(body: V1StoreGoalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1StoreGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceStoreGoal(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updating parameters will re-run the GOE algorithm and update the statistics associated with the goal. If the \"reallocate\" flag is set to true, the GOE algorithm is re-run and the assets are reallocated if a different portfolio is returned.
         * @summary UpdateGoal
         * @param {string} goalUid 
         * @param {RoboServiceUpdateGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceUpdateGoal(goalUid: string, body: RoboServiceUpdateGoalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceUpdateGoal(goalUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UpdateRoboGeneralInvestment updates a general investment in the user\'s portfolio.
         * @summary UpdateRoboGeneralInvestment
         * @param {string} investUid InvestUid is the uid of the general investment.
         * @param {RoboServiceUpdateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceUpdateRoboGeneralInvestment(investUid: string, body: RoboServiceUpdateRoboGeneralInvestmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceUpdateRoboGeneralInvestment(investUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Withdraw allows a user to take funds from a specific robo investment.
         * @summary Withdraw
         * @param {Robopbv1WithdrawRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roboServiceWithdraw(body: Robopbv1WithdrawRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1WithdrawResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roboServiceWithdraw(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoboServiceApi - factory interface
 * @export
 */
export const RoboServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoboServiceApiFp(configuration)
    return {
        /**
         * AnalyzeGoal takes in the parameters of a goal, runs the GOE algorithm, and returns the statistics and allocation recommendation without storing anything.
         * @summary AnalyzeGoal
         * @param {V1AnalyzeGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceAnalyzeGoal(body: V1AnalyzeGoalRequest, options?: any): AxiosPromise<V1AnalyzeGoalResponse> {
            return localVarFp.roboServiceAnalyzeGoal(body, options).then((request) => request(axios, basePath));
        },
        /**
         * CancelInfuse cancels a one-time infusion
         * @summary CancelInfuse
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCancelInfuse(actionUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceCancelInfuse(actionUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * CancelWithdraw cancels a withdrawal
         * @summary CancelWithdraw
         * @param {string} actionUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCancelWithdraw(actionUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceCancelWithdraw(actionUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * CloseGeneralInvestment will deactivate the operations of a general investment. General investment must be fully liquidated before it can be closed.
         * @summary CloseGeneralInvestment
         * @param {string} investUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCloseGeneralInvestment(investUid: string, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceCloseGeneralInvestment(investUid, options).then((request) => request(axios, basePath));
        },
        /**
         * CloseGoal will deactivate the operations of a goal. Goal must be fully liquidated before it can be closed.
         * @summary CloseGoal
         * @param {string} goalUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCloseGoal(goalUid: string, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceCloseGoal(goalUid, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateRoboGeneralInvestment adds a general investment to the user\'s portfolio.
         * @summary CreateRoboGeneralInvestment
         * @param {V1CreateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceCreateRoboGeneralInvestment(body: V1CreateRoboGeneralInvestmentRequest, options?: any): AxiosPromise<V1CreateRoboGeneralInvestmentResponse> {
            return localVarFp.roboServiceCreateRoboGeneralInvestment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Infuse issues a one-time infusion into the allocation associated with the particular robo investment.
         * @summary Infuse
         * @param {V1InfuseRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceInfuse(body: V1InfuseRequest, options?: any): AxiosPromise<V1InfuseResponse> {
            return localVarFp.roboServiceInfuse(body, options).then((request) => request(axios, basePath));
        },
        /**
         * PauseInfusions will pause the active infusions into a particular robo investment.
         * @summary PauseInfusions
         * @param {V1PauseInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServicePauseInfusions(body: V1PauseInfusionsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.roboServicePauseInfusions(body, options).then((request) => request(axios, basePath));
        },
        /**
         * ReallocateGoal will check with GOE to see if the target portfolio has changed and will then run a rebalance.
         * @summary ReallocateGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceReallocateGoal(goalUid: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceReallocateGoal(goalUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * RebalanceGeneralInvestment will take an existing general investment portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGeneralInvestment
         * @param {string} investUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceRebalanceGeneralInvestment(investUid: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceRebalanceGeneralInvestment(investUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * RebalanceGoal will take an existing goal portfolio and bring it back into compliance with the target portfolio.
         * @summary RebalanceGoal
         * @param {string} goalUid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceRebalanceGoal(goalUid: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceRebalanceGoal(goalUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * ResumeInfusions will immediately resume the planned infusions for the specified robo investment.
         * @summary ResumeInfusions
         * @param {V1ResumeInfusionsRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceResumeInfusions(body: V1ResumeInfusionsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceResumeInfusions(body, options).then((request) => request(axios, basePath));
        },
        /**
         * StoreGoal takes in the goal parameters and performs the required steps to store the goal and performs the required steps to create the allocation.
         * @summary StoreGoal
         * @param {V1StoreGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceStoreGoal(body: V1StoreGoalRequest, options?: any): AxiosPromise<V1StoreGoalResponse> {
            return localVarFp.roboServiceStoreGoal(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Updating parameters will re-run the GOE algorithm and update the statistics associated with the goal. If the \"reallocate\" flag is set to true, the GOE algorithm is re-run and the assets are reallocated if a different portfolio is returned.
         * @summary UpdateGoal
         * @param {string} goalUid 
         * @param {RoboServiceUpdateGoalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceUpdateGoal(goalUid: string, body: RoboServiceUpdateGoalRequest, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceUpdateGoal(goalUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateRoboGeneralInvestment updates a general investment in the user\'s portfolio.
         * @summary UpdateRoboGeneralInvestment
         * @param {string} investUid InvestUid is the uid of the general investment.
         * @param {RoboServiceUpdateRoboGeneralInvestmentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceUpdateRoboGeneralInvestment(investUid: string, body: RoboServiceUpdateRoboGeneralInvestmentRequest, options?: any): AxiosPromise<object> {
            return localVarFp.roboServiceUpdateRoboGeneralInvestment(investUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Withdraw allows a user to take funds from a specific robo investment.
         * @summary Withdraw
         * @param {Robopbv1WithdrawRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roboServiceWithdraw(body: Robopbv1WithdrawRequest, options?: any): AxiosPromise<V1WithdrawResponse> {
            return localVarFp.roboServiceWithdraw(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoboServiceApi - object-oriented interface
 * @export
 * @class RoboServiceApi
 * @extends {BaseAPI}
 */
export class RoboServiceApi extends BaseAPI {
    /**
     * AnalyzeGoal takes in the parameters of a goal, runs the GOE algorithm, and returns the statistics and allocation recommendation without storing anything.
     * @summary AnalyzeGoal
     * @param {V1AnalyzeGoalRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceAnalyzeGoal(body: V1AnalyzeGoalRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceAnalyzeGoal(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CancelInfuse cancels a one-time infusion
     * @summary CancelInfuse
     * @param {string} actionUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceCancelInfuse(actionUid: string, reason?: string, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceCancelInfuse(actionUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CancelWithdraw cancels a withdrawal
     * @summary CancelWithdraw
     * @param {string} actionUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceCancelWithdraw(actionUid: string, reason?: string, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceCancelWithdraw(actionUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CloseGeneralInvestment will deactivate the operations of a general investment. General investment must be fully liquidated before it can be closed.
     * @summary CloseGeneralInvestment
     * @param {string} investUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceCloseGeneralInvestment(investUid: string, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceCloseGeneralInvestment(investUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CloseGoal will deactivate the operations of a goal. Goal must be fully liquidated before it can be closed.
     * @summary CloseGoal
     * @param {string} goalUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceCloseGoal(goalUid: string, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceCloseGoal(goalUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateRoboGeneralInvestment adds a general investment to the user\'s portfolio.
     * @summary CreateRoboGeneralInvestment
     * @param {V1CreateRoboGeneralInvestmentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceCreateRoboGeneralInvestment(body: V1CreateRoboGeneralInvestmentRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceCreateRoboGeneralInvestment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Infuse issues a one-time infusion into the allocation associated with the particular robo investment.
     * @summary Infuse
     * @param {V1InfuseRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceInfuse(body: V1InfuseRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceInfuse(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PauseInfusions will pause the active infusions into a particular robo investment.
     * @summary PauseInfusions
     * @param {V1PauseInfusionsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServicePauseInfusions(body: V1PauseInfusionsRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServicePauseInfusions(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ReallocateGoal will check with GOE to see if the target portfolio has changed and will then run a rebalance.
     * @summary ReallocateGoal
     * @param {string} goalUid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceReallocateGoal(goalUid: string, body: object, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceReallocateGoal(goalUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RebalanceGeneralInvestment will take an existing general investment portfolio and bring it back into compliance with the target portfolio.
     * @summary RebalanceGeneralInvestment
     * @param {string} investUid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceRebalanceGeneralInvestment(investUid: string, body: object, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceRebalanceGeneralInvestment(investUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RebalanceGoal will take an existing goal portfolio and bring it back into compliance with the target portfolio.
     * @summary RebalanceGoal
     * @param {string} goalUid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceRebalanceGoal(goalUid: string, body: object, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceRebalanceGoal(goalUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ResumeInfusions will immediately resume the planned infusions for the specified robo investment.
     * @summary ResumeInfusions
     * @param {V1ResumeInfusionsRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceResumeInfusions(body: V1ResumeInfusionsRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceResumeInfusions(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * StoreGoal takes in the goal parameters and performs the required steps to store the goal and performs the required steps to create the allocation.
     * @summary StoreGoal
     * @param {V1StoreGoalRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceStoreGoal(body: V1StoreGoalRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceStoreGoal(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updating parameters will re-run the GOE algorithm and update the statistics associated with the goal. If the \"reallocate\" flag is set to true, the GOE algorithm is re-run and the assets are reallocated if a different portfolio is returned.
     * @summary UpdateGoal
     * @param {string} goalUid 
     * @param {RoboServiceUpdateGoalRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceUpdateGoal(goalUid: string, body: RoboServiceUpdateGoalRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceUpdateGoal(goalUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateRoboGeneralInvestment updates a general investment in the user\'s portfolio.
     * @summary UpdateRoboGeneralInvestment
     * @param {string} investUid InvestUid is the uid of the general investment.
     * @param {RoboServiceUpdateRoboGeneralInvestmentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceUpdateRoboGeneralInvestment(investUid: string, body: RoboServiceUpdateRoboGeneralInvestmentRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceUpdateRoboGeneralInvestment(investUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Withdraw allows a user to take funds from a specific robo investment.
     * @summary Withdraw
     * @param {Robopbv1WithdrawRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoboServiceApi
     */
    public roboServiceWithdraw(body: Robopbv1WithdrawRequest, options?: AxiosRequestConfig) {
        return RoboServiceApiFp(this.configuration).roboServiceWithdraw(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SODReconciliationServiceApi - axios parameter creator
 * @export
 */
export const SODReconciliationServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * RunSODReconciliationEtl runs the full ETL pipeline: storing, parsing, and reconciling the SOD files.
         * @summary RunSODReconciliationEtl
         * @param {V1RunSODReconciliationEtlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sODReconciliationServiceRunSODReconciliationEtl: async (body: V1RunSODReconciliationEtlRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sODReconciliationServiceRunSODReconciliationEtl', 'body', body)
            const localVarPath = `/v1/sod/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SODReconciliationServiceApi - functional programming interface
 * @export
 */
export const SODReconciliationServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SODReconciliationServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * RunSODReconciliationEtl runs the full ETL pipeline: storing, parsing, and reconciling the SOD files.
         * @summary RunSODReconciliationEtl
         * @param {V1RunSODReconciliationEtlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sODReconciliationServiceRunSODReconciliationEtl(body: V1RunSODReconciliationEtlRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sODReconciliationServiceRunSODReconciliationEtl(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SODReconciliationServiceApi - factory interface
 * @export
 */
export const SODReconciliationServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SODReconciliationServiceApiFp(configuration)
    return {
        /**
         * RunSODReconciliationEtl runs the full ETL pipeline: storing, parsing, and reconciling the SOD files.
         * @summary RunSODReconciliationEtl
         * @param {V1RunSODReconciliationEtlRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sODReconciliationServiceRunSODReconciliationEtl(body: V1RunSODReconciliationEtlRequest, options?: any): AxiosPromise<object> {
            return localVarFp.sODReconciliationServiceRunSODReconciliationEtl(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SODReconciliationServiceApi - object-oriented interface
 * @export
 * @class SODReconciliationServiceApi
 * @extends {BaseAPI}
 */
export class SODReconciliationServiceApi extends BaseAPI {
    /**
     * RunSODReconciliationEtl runs the full ETL pipeline: storing, parsing, and reconciling the SOD files.
     * @summary RunSODReconciliationEtl
     * @param {V1RunSODReconciliationEtlRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SODReconciliationServiceApi
     */
    public sODReconciliationServiceRunSODReconciliationEtl(body: V1RunSODReconciliationEtlRequest, options?: AxiosRequestConfig) {
        return SODReconciliationServiceApiFp(this.configuration).sODReconciliationServiceRunSODReconciliationEtl(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupportServiceApi - axios parameter creator
 * @export
 */
export const SupportServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * NewTicket allows a user to add a new support ticket.
         * @summary NewTicket
         * @param {V1NewTicketRequest} body NewTicketRequest has the required information to file a support ticket.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportServiceNewTicket: async (body: V1NewTicketRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('supportServiceNewTicket', 'body', body)
            const localVarPath = `/api/v1/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportServiceApi - functional programming interface
 * @export
 */
export const SupportServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * NewTicket allows a user to add a new support ticket.
         * @summary NewTicket
         * @param {V1NewTicketRequest} body NewTicketRequest has the required information to file a support ticket.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportServiceNewTicket(body: V1NewTicketRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1NewTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportServiceNewTicket(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupportServiceApi - factory interface
 * @export
 */
export const SupportServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportServiceApiFp(configuration)
    return {
        /**
         * NewTicket allows a user to add a new support ticket.
         * @summary NewTicket
         * @param {V1NewTicketRequest} body NewTicketRequest has the required information to file a support ticket.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportServiceNewTicket(body: V1NewTicketRequest, options?: any): AxiosPromise<V1NewTicketResponse> {
            return localVarFp.supportServiceNewTicket(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportServiceApi - object-oriented interface
 * @export
 * @class SupportServiceApi
 * @extends {BaseAPI}
 */
export class SupportServiceApi extends BaseAPI {
    /**
     * NewTicket allows a user to add a new support ticket.
     * @summary NewTicket
     * @param {V1NewTicketRequest} body NewTicketRequest has the required information to file a support ticket.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportServiceApi
     */
    public supportServiceNewTicket(body: V1NewTicketRequest, options?: AxiosRequestConfig) {
        return SupportServiceApiFp(this.configuration).supportServiceNewTicket(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TradeServiceApi - axios parameter creator
 * @export
 */
export const TradeServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CancelTrade attempts to cancel an ongoing trade. This is best effort and the trade may not actually get canceled even if the call succeeds.
         * @summary CancelTrade
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCancelTrade: async (orderUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderUid' is not null or undefined
            assertParamExists('tradeServiceCancelTrade', 'orderUid', orderUid)
            const localVarPath = `/v1/trade/{orderUid}`
                .replace(`{${"orderUid"}}`, encodeURIComponent(String(orderUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {V1CreateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateRepeatTrade: async (body: V1CreateRepeatTradeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceCreateRepeatTrade', 'body', body)
            const localVarPath = `/v1/trade/repeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateTrade registers a request to place a new order.
         * @summary CreateTrade
         * @param {V1CreateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateTrade: async (body: V1CreateTradeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceCreateTrade', 'body', body)
            const localVarPath = `/v1/trade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateTradeSummary returns proposed details about a trade
         * @summary CreateTradeSummary
         * @param {V1CreateTradeSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateTradeSummary: async (body: V1CreateTradeSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceCreateTradeSummary', 'body', body)
            const localVarPath = `/v1/trade/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DeleteRepeatTrade inactivates a repeat trade so that no future trades are automatically triggered.
         * @summary DeleteRepeatTrade
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceDeleteRepeatTrade: async (ruleUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('tradeServiceDeleteRepeatTrade', 'ruleUid', ruleUid)
            const localVarPath = `/v1/trade/repeat/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SkipRepeatTrade inactivates a repeat trade so the next scheduled trade is not automatically triggered.
         * @summary SkipRepeatTrade
         * @param {string} ruleUid rule_uid is the uid of the rule to skip.
         * @param {TradeServiceSkipRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceSkipRepeatTrade: async (ruleUid: string, body: TradeServiceSkipRepeatTradeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('tradeServiceSkipRepeatTrade', 'ruleUid', ruleUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceSkipRepeatTrade', 'body', body)
            const localVarPath = `/v1/trade/repeat/skip/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {string} ruleUid 
         * @param {TradeServiceUpdateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceUpdateRepeatTrade: async (ruleUid: string, body: TradeServiceUpdateRepeatTradeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('tradeServiceUpdateRepeatTrade', 'ruleUid', ruleUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceUpdateRepeatTrade', 'body', body)
            const localVarPath = `/v1/trade/repeat/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateTrade
         * @param {string} orderUid 
         * @param {TradeServiceUpdateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceUpdateTrade: async (orderUid: string, body: TradeServiceUpdateTradeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderUid' is not null or undefined
            assertParamExists('tradeServiceUpdateTrade', 'orderUid', orderUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tradeServiceUpdateTrade', 'body', body)
            const localVarPath = `/v1/trade/{orderUid}`
                .replace(`{${"orderUid"}}`, encodeURIComponent(String(orderUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TradeServiceApi - functional programming interface
 * @export
 */
export const TradeServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TradeServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CancelTrade attempts to cancel an ongoing trade. This is best effort and the trade may not actually get canceled even if the call succeeds.
         * @summary CancelTrade
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceCancelTrade(orderUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceCancelTrade(orderUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {V1CreateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceCreateRepeatTrade(body: V1CreateRepeatTradeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateRepeatTradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceCreateRepeatTrade(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateTrade registers a request to place a new order.
         * @summary CreateTrade
         * @param {V1CreateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceCreateTrade(body: V1CreateTradeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateTradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceCreateTrade(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateTradeSummary returns proposed details about a trade
         * @summary CreateTradeSummary
         * @param {V1CreateTradeSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceCreateTradeSummary(body: V1CreateTradeSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateTradeSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceCreateTradeSummary(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DeleteRepeatTrade inactivates a repeat trade so that no future trades are automatically triggered.
         * @summary DeleteRepeatTrade
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceDeleteRepeatTrade(ruleUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceDeleteRepeatTrade(ruleUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * SkipRepeatTrade inactivates a repeat trade so the next scheduled trade is not automatically triggered.
         * @summary SkipRepeatTrade
         * @param {string} ruleUid rule_uid is the uid of the rule to skip.
         * @param {TradeServiceSkipRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceSkipRepeatTrade(ruleUid: string, body: TradeServiceSkipRepeatTradeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceSkipRepeatTrade(ruleUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {string} ruleUid 
         * @param {TradeServiceUpdateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceUpdateRepeatTrade(ruleUid: string, body: TradeServiceUpdateRepeatTradeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateRepeatTradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceUpdateRepeatTrade(ruleUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateTrade
         * @param {string} orderUid 
         * @param {TradeServiceUpdateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tradeServiceUpdateTrade(orderUid: string, body: TradeServiceUpdateTradeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateTradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tradeServiceUpdateTrade(orderUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TradeServiceApi - factory interface
 * @export
 */
export const TradeServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TradeServiceApiFp(configuration)
    return {
        /**
         * CancelTrade attempts to cancel an ongoing trade. This is best effort and the trade may not actually get canceled even if the call succeeds.
         * @summary CancelTrade
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCancelTrade(orderUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.tradeServiceCancelTrade(orderUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {V1CreateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateRepeatTrade(body: V1CreateRepeatTradeRequest, options?: any): AxiosPromise<V1CreateRepeatTradeResponse> {
            return localVarFp.tradeServiceCreateRepeatTrade(body, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateTrade registers a request to place a new order.
         * @summary CreateTrade
         * @param {V1CreateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateTrade(body: V1CreateTradeRequest, options?: any): AxiosPromise<V1CreateTradeResponse> {
            return localVarFp.tradeServiceCreateTrade(body, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateTradeSummary returns proposed details about a trade
         * @summary CreateTradeSummary
         * @param {V1CreateTradeSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceCreateTradeSummary(body: V1CreateTradeSummaryRequest, options?: any): AxiosPromise<V1CreateTradeSummaryResponse> {
            return localVarFp.tradeServiceCreateTradeSummary(body, options).then((request) => request(axios, basePath));
        },
        /**
         * DeleteRepeatTrade inactivates a repeat trade so that no future trades are automatically triggered.
         * @summary DeleteRepeatTrade
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceDeleteRepeatTrade(ruleUid: string, options?: any): AxiosPromise<object> {
            return localVarFp.tradeServiceDeleteRepeatTrade(ruleUid, options).then((request) => request(axios, basePath));
        },
        /**
         * SkipRepeatTrade inactivates a repeat trade so the next scheduled trade is not automatically triggered.
         * @summary SkipRepeatTrade
         * @param {string} ruleUid rule_uid is the uid of the rule to skip.
         * @param {TradeServiceSkipRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceSkipRepeatTrade(ruleUid: string, body: TradeServiceSkipRepeatTradeRequest, options?: any): AxiosPromise<object> {
            return localVarFp.tradeServiceSkipRepeatTrade(ruleUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
         * @summary CreateRepeatTrade
         * @param {string} ruleUid 
         * @param {TradeServiceUpdateRepeatTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceUpdateRepeatTrade(ruleUid: string, body: TradeServiceUpdateRepeatTradeRequest, options?: any): AxiosPromise<V1UpdateRepeatTradeResponse> {
            return localVarFp.tradeServiceUpdateRepeatTrade(ruleUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateTrade
         * @param {string} orderUid 
         * @param {TradeServiceUpdateTradeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tradeServiceUpdateTrade(orderUid: string, body: TradeServiceUpdateTradeRequest, options?: any): AxiosPromise<V1UpdateTradeResponse> {
            return localVarFp.tradeServiceUpdateTrade(orderUid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TradeServiceApi - object-oriented interface
 * @export
 * @class TradeServiceApi
 * @extends {BaseAPI}
 */
export class TradeServiceApi extends BaseAPI {
    /**
     * CancelTrade attempts to cancel an ongoing trade. This is best effort and the trade may not actually get canceled even if the call succeeds.
     * @summary CancelTrade
     * @param {string} orderUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceCancelTrade(orderUid: string, reason?: string, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceCancelTrade(orderUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
     * @summary CreateRepeatTrade
     * @param {V1CreateRepeatTradeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceCreateRepeatTrade(body: V1CreateRepeatTradeRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceCreateRepeatTrade(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateTrade registers a request to place a new order.
     * @summary CreateTrade
     * @param {V1CreateTradeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceCreateTrade(body: V1CreateTradeRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceCreateTrade(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateTradeSummary returns proposed details about a trade
     * @summary CreateTradeSummary
     * @param {V1CreateTradeSummaryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceCreateTradeSummary(body: V1CreateTradeSummaryRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceCreateTradeSummary(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DeleteRepeatTrade inactivates a repeat trade so that no future trades are automatically triggered.
     * @summary DeleteRepeatTrade
     * @param {string} ruleUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceDeleteRepeatTrade(ruleUid: string, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceDeleteRepeatTrade(ruleUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SkipRepeatTrade inactivates a repeat trade so the next scheduled trade is not automatically triggered.
     * @summary SkipRepeatTrade
     * @param {string} ruleUid rule_uid is the uid of the rule to skip.
     * @param {TradeServiceSkipRepeatTradeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceSkipRepeatTrade(ruleUid: string, body: TradeServiceSkipRepeatTradeRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceSkipRepeatTrade(ruleUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateRepeatTrade creates a periodic trade that is triggered by the user\'s schedule.
     * @summary CreateRepeatTrade
     * @param {string} ruleUid 
     * @param {TradeServiceUpdateRepeatTradeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceUpdateRepeatTrade(ruleUid: string, body: TradeServiceUpdateRepeatTradeRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceUpdateRepeatTrade(ruleUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateTrade
     * @param {string} orderUid 
     * @param {TradeServiceUpdateTradeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeServiceApi
     */
    public tradeServiceUpdateTrade(orderUid: string, body: TradeServiceUpdateTradeRequest, options?: AxiosRequestConfig) {
        return TradeServiceApiFp(this.configuration).tradeServiceUpdateTrade(orderUid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransferServiceApi - axios parameter creator
 * @export
 */
export const TransferServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CancelTransfer attempts to cancel an ongoing transfer. This is best effort and the transfer may not actually get canceled even if the call succeeds.
         * @summary CancelTransfer
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCancelTransfer: async (orderUid: string, reason?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderUid' is not null or undefined
            assertParamExists('transferServiceCancelTransfer', 'orderUid', orderUid)
            const localVarPath = `/v1/transfer/{orderUid}`
                .replace(`{${"orderUid"}}`, encodeURIComponent(String(orderUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CreateDepositSummary returns proposed details about a deposit.
         * @param {V1CreateDepositSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateDepositSummary: async (body: V1CreateDepositSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferServiceCreateDepositSummary', 'body', body)
            const localVarPath = `/v1/transfer/depositsummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateRepeatTransfer creates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary CreateRepeatTransfer
         * @param {V1CreateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateRepeatTransfer: async (body: V1CreateRepeatTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferServiceCreateRepeatTransfer', 'body', body)
            const localVarPath = `/v1/transfer/repeat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateTransfer will initiate a user created transfer.
         * @summary CreateTransfer
         * @param {V1CreateTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateTransfer: async (body: V1CreateTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferServiceCreateTransfer', 'body', body)
            const localVarPath = `/v1/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DeleteRepeatTransfer inactivates a repeat transfer so that no future transfers are automatically triggered.
         * @summary DeleteRepeatTransfer
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceDeleteRepeatTransfer: async (ruleUid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('transferServiceDeleteRepeatTransfer', 'ruleUid', ruleUid)
            const localVarPath = `/v1/transfer/repeat/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SkipRepeatTransfer inactivates a repeat transfer so that next scheduled transfer is not automatically triggered.
         * @summary SkipRepeatTransfer
         * @param {string} ruleUid RuleUid is the uid of the rule to skip.
         * @param {TransferServiceSkipRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceSkipRepeatTransfer: async (ruleUid: string, body: TransferServiceSkipRepeatTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('transferServiceSkipRepeatTransfer', 'ruleUid', ruleUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferServiceSkipRepeatTransfer', 'body', body)
            const localVarPath = `/v1/transfer/repeat/skip/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateRepeatTransfer updates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary UpdateRepeatTransfer
         * @param {string} ruleUid 
         * @param {TransferServiceUpdateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceUpdateRepeatTransfer: async (ruleUid: string, body: TransferServiceUpdateRepeatTransferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleUid' is not null or undefined
            assertParamExists('transferServiceUpdateRepeatTransfer', 'ruleUid', ruleUid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferServiceUpdateRepeatTransfer', 'body', body)
            const localVarPath = `/v1/transfer/repeat/{ruleUid}`
                .replace(`{${"ruleUid"}}`, encodeURIComponent(String(ruleUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransferServiceApi - functional programming interface
 * @export
 */
export const TransferServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransferServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CancelTransfer attempts to cancel an ongoing transfer. This is best effort and the transfer may not actually get canceled even if the call succeeds.
         * @summary CancelTransfer
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceCancelTransfer(orderUid: string, reason?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceCancelTransfer(orderUid, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary CreateDepositSummary returns proposed details about a deposit.
         * @param {V1CreateDepositSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceCreateDepositSummary(body: V1CreateDepositSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateDepositSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceCreateDepositSummary(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateRepeatTransfer creates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary CreateRepeatTransfer
         * @param {V1CreateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceCreateRepeatTransfer(body: V1CreateRepeatTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateRepeatTransferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceCreateRepeatTransfer(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * CreateTransfer will initiate a user created transfer.
         * @summary CreateTransfer
         * @param {V1CreateTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceCreateTransfer(body: V1CreateTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateTransferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceCreateTransfer(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * DeleteRepeatTransfer inactivates a repeat transfer so that no future transfers are automatically triggered.
         * @summary DeleteRepeatTransfer
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceDeleteRepeatTransfer(ruleUid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceDeleteRepeatTransfer(ruleUid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * SkipRepeatTransfer inactivates a repeat transfer so that next scheduled transfer is not automatically triggered.
         * @summary SkipRepeatTransfer
         * @param {string} ruleUid RuleUid is the uid of the rule to skip.
         * @param {TransferServiceSkipRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceSkipRepeatTransfer(ruleUid: string, body: TransferServiceSkipRepeatTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceSkipRepeatTransfer(ruleUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UpdateRepeatTransfer updates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary UpdateRepeatTransfer
         * @param {string} ruleUid 
         * @param {TransferServiceUpdateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferServiceUpdateRepeatTransfer(ruleUid: string, body: TransferServiceUpdateRepeatTransferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateRepeatTransferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferServiceUpdateRepeatTransfer(ruleUid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransferServiceApi - factory interface
 * @export
 */
export const TransferServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransferServiceApiFp(configuration)
    return {
        /**
         * CancelTransfer attempts to cancel an ongoing transfer. This is best effort and the transfer may not actually get canceled even if the call succeeds.
         * @summary CancelTransfer
         * @param {string} orderUid 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCancelTransfer(orderUid: string, reason?: string, options?: any): AxiosPromise<object> {
            return localVarFp.transferServiceCancelTransfer(orderUid, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CreateDepositSummary returns proposed details about a deposit.
         * @param {V1CreateDepositSummaryRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateDepositSummary(body: V1CreateDepositSummaryRequest, options?: any): AxiosPromise<V1CreateDepositSummaryResponse> {
            return localVarFp.transferServiceCreateDepositSummary(body, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateRepeatTransfer creates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary CreateRepeatTransfer
         * @param {V1CreateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateRepeatTransfer(body: V1CreateRepeatTransferRequest, options?: any): AxiosPromise<V1CreateRepeatTransferResponse> {
            return localVarFp.transferServiceCreateRepeatTransfer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateTransfer will initiate a user created transfer.
         * @summary CreateTransfer
         * @param {V1CreateTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceCreateTransfer(body: V1CreateTransferRequest, options?: any): AxiosPromise<V1CreateTransferResponse> {
            return localVarFp.transferServiceCreateTransfer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * DeleteRepeatTransfer inactivates a repeat transfer so that no future transfers are automatically triggered.
         * @summary DeleteRepeatTransfer
         * @param {string} ruleUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceDeleteRepeatTransfer(ruleUid: string, options?: any): AxiosPromise<object> {
            return localVarFp.transferServiceDeleteRepeatTransfer(ruleUid, options).then((request) => request(axios, basePath));
        },
        /**
         * SkipRepeatTransfer inactivates a repeat transfer so that next scheduled transfer is not automatically triggered.
         * @summary SkipRepeatTransfer
         * @param {string} ruleUid RuleUid is the uid of the rule to skip.
         * @param {TransferServiceSkipRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceSkipRepeatTransfer(ruleUid: string, body: TransferServiceSkipRepeatTransferRequest, options?: any): AxiosPromise<object> {
            return localVarFp.transferServiceSkipRepeatTransfer(ruleUid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateRepeatTransfer updates a periodic transfer request that triggers based on the user\'s schedule.
         * @summary UpdateRepeatTransfer
         * @param {string} ruleUid 
         * @param {TransferServiceUpdateRepeatTransferRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferServiceUpdateRepeatTransfer(ruleUid: string, body: TransferServiceUpdateRepeatTransferRequest, options?: any): AxiosPromise<V1UpdateRepeatTransferResponse> {
            return localVarFp.transferServiceUpdateRepeatTransfer(ruleUid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransferServiceApi - object-oriented interface
 * @export
 * @class TransferServiceApi
 * @extends {BaseAPI}
 */
export class TransferServiceApi extends BaseAPI {
    /**
     * CancelTransfer attempts to cancel an ongoing transfer. This is best effort and the transfer may not actually get canceled even if the call succeeds.
     * @summary CancelTransfer
     * @param {string} orderUid 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceCancelTransfer(orderUid: string, reason?: string, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceCancelTransfer(orderUid, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CreateDepositSummary returns proposed details about a deposit.
     * @param {V1CreateDepositSummaryRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceCreateDepositSummary(body: V1CreateDepositSummaryRequest, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceCreateDepositSummary(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateRepeatTransfer creates a periodic transfer request that triggers based on the user\'s schedule.
     * @summary CreateRepeatTransfer
     * @param {V1CreateRepeatTransferRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceCreateRepeatTransfer(body: V1CreateRepeatTransferRequest, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceCreateRepeatTransfer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateTransfer will initiate a user created transfer.
     * @summary CreateTransfer
     * @param {V1CreateTransferRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceCreateTransfer(body: V1CreateTransferRequest, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceCreateTransfer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DeleteRepeatTransfer inactivates a repeat transfer so that no future transfers are automatically triggered.
     * @summary DeleteRepeatTransfer
     * @param {string} ruleUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceDeleteRepeatTransfer(ruleUid: string, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceDeleteRepeatTransfer(ruleUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SkipRepeatTransfer inactivates a repeat transfer so that next scheduled transfer is not automatically triggered.
     * @summary SkipRepeatTransfer
     * @param {string} ruleUid RuleUid is the uid of the rule to skip.
     * @param {TransferServiceSkipRepeatTransferRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceSkipRepeatTransfer(ruleUid: string, body: TransferServiceSkipRepeatTransferRequest, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceSkipRepeatTransfer(ruleUid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateRepeatTransfer updates a periodic transfer request that triggers based on the user\'s schedule.
     * @summary UpdateRepeatTransfer
     * @param {string} ruleUid 
     * @param {TransferServiceUpdateRepeatTransferRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferServiceApi
     */
    public transferServiceUpdateRepeatTransfer(ruleUid: string, body: TransferServiceUpdateRepeatTransferRequest, options?: AxiosRequestConfig) {
        return TransferServiceApiFp(this.configuration).transferServiceUpdateRepeatTransfer(ruleUid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAdminServiceApi - axios parameter creator
 * @export
 */
export const UserAdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CreateUser allows an admin to manually create a user in the database without subjecting that user to the normal signup flow.
         * @summary CreateUser
         * @param {Userpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceCreateUser: async (body: Userpbv1CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userAdminServiceCreateUser', 'body', body)
            const localVarPath = `/v1/admin/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateUserProfile allows an admin to update a user\'s profile.
         * @summary UpdateUserProfile
         * @param {V1UpdateUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceUpdateUserProfile: async (body: V1UpdateUserProfileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userAdminServiceUpdateUserProfile', 'body', body)
            const localVarPath = `/v1/admin/user/profile/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateUserRestriction allows an admin to update a user\'s restriction status.
         * @summary UpdateUserRestriction
         * @param {V1UpdateUserRestrictionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceUpdateUserRestriction: async (body: V1UpdateUserRestrictionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userAdminServiceUpdateUserRestriction', 'body', body)
            const localVarPath = `/v1/admin/user/restriction/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAdminServiceApi - functional programming interface
 * @export
 */
export const UserAdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CreateUser allows an admin to manually create a user in the database without subjecting that user to the normal signup flow.
         * @summary CreateUser
         * @param {Userpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAdminServiceCreateUser(body: Userpbv1CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Userpbv1CreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAdminServiceCreateUser(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UpdateUserProfile allows an admin to update a user\'s profile.
         * @summary UpdateUserProfile
         * @param {V1UpdateUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAdminServiceUpdateUserProfile(body: V1UpdateUserProfileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAdminServiceUpdateUserProfile(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UpdateUserRestriction allows an admin to update a user\'s restriction status.
         * @summary UpdateUserRestriction
         * @param {V1UpdateUserRestrictionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAdminServiceUpdateUserRestriction(body: V1UpdateUserRestrictionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateUserRestrictionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAdminServiceUpdateUserRestriction(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAdminServiceApi - factory interface
 * @export
 */
export const UserAdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAdminServiceApiFp(configuration)
    return {
        /**
         * CreateUser allows an admin to manually create a user in the database without subjecting that user to the normal signup flow.
         * @summary CreateUser
         * @param {Userpbv1CreateUserRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceCreateUser(body: Userpbv1CreateUserRequest, options?: any): AxiosPromise<Userpbv1CreateUserResponse> {
            return localVarFp.userAdminServiceCreateUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateUserProfile allows an admin to update a user\'s profile.
         * @summary UpdateUserProfile
         * @param {V1UpdateUserProfileRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceUpdateUserProfile(body: V1UpdateUserProfileRequest, options?: any): AxiosPromise<V1UpdateUserProfileResponse> {
            return localVarFp.userAdminServiceUpdateUserProfile(body, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateUserRestriction allows an admin to update a user\'s restriction status.
         * @summary UpdateUserRestriction
         * @param {V1UpdateUserRestrictionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminServiceUpdateUserRestriction(body: V1UpdateUserRestrictionRequest, options?: any): AxiosPromise<V1UpdateUserRestrictionResponse> {
            return localVarFp.userAdminServiceUpdateUserRestriction(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAdminServiceApi - object-oriented interface
 * @export
 * @class UserAdminServiceApi
 * @extends {BaseAPI}
 */
export class UserAdminServiceApi extends BaseAPI {
    /**
     * CreateUser allows an admin to manually create a user in the database without subjecting that user to the normal signup flow.
     * @summary CreateUser
     * @param {Userpbv1CreateUserRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminServiceApi
     */
    public userAdminServiceCreateUser(body: Userpbv1CreateUserRequest, options?: AxiosRequestConfig) {
        return UserAdminServiceApiFp(this.configuration).userAdminServiceCreateUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateUserProfile allows an admin to update a user\'s profile.
     * @summary UpdateUserProfile
     * @param {V1UpdateUserProfileRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminServiceApi
     */
    public userAdminServiceUpdateUserProfile(body: V1UpdateUserProfileRequest, options?: AxiosRequestConfig) {
        return UserAdminServiceApiFp(this.configuration).userAdminServiceUpdateUserProfile(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateUserRestriction allows an admin to update a user\'s restriction status.
     * @summary UpdateUserRestriction
     * @param {V1UpdateUserRestrictionRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminServiceApi
     */
    public userAdminServiceUpdateUserRestriction(body: V1UpdateUserRestrictionRequest, options?: AxiosRequestConfig) {
        return UserAdminServiceApiFp(this.configuration).userAdminServiceUpdateUserRestriction(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserClaimServiceApi - axios parameter creator
 * @export
 */
export const UserClaimServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CheckUserExists takes in the user\'s contact information and checks if the user exists. Returns an error if the user doesn\'t exist or if the user is already claimed.
         * @param {V1CheckUserExistsRequest} body CheckUserExistsRequest is the request message for CheckUserExists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceCheckUserExists: async (body: V1CheckUserExistsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userClaimServiceCheckUserExists', 'body', body)
            const localVarPath = `/v1/userclaim/checkuserexists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ClaimUser allows a caller to set the username and password to a user account that was preloaded.
         * @param {V1ClaimUserRequest} body ClaimUserRequest is the request message for ClaimUser.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceClaimUser: async (body: V1ClaimUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userClaimServiceClaimUser', 'body', body)
            const localVarPath = `/v1/userclaim/claimuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SendMFAVerificationCode sends a verification code to the user\'s contact information. Both email and phone number are required and will only be sent if both match the user\'s stored information.
         * @param {V1SendMFAVerificationCodeRequest} body SendMFAVerificationCodeRequest is the request message for SendMFAVerificationCode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceSendMFAVerificationCode: async (body: V1SendMFAVerificationCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userClaimServiceSendMFAVerificationCode', 'body', body)
            const localVarPath = `/v1/userclaim/sendmfaverificationcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary VerifyMFA accepts a validation code to prove the user has access to the MFA. A verification token is returned that can be used to prove the user has validated via MFA.
         * @param {V1VerifyMFARequest} body VerifyMFARequest is the request message for VerifyMFA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceVerifyMFA: async (body: V1VerifyMFARequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userClaimServiceVerifyMFA', 'body', body)
            const localVarPath = `/v1/userclaim/verifymfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserClaimServiceApi - functional programming interface
 * @export
 */
export const UserClaimServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserClaimServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CheckUserExists takes in the user\'s contact information and checks if the user exists. Returns an error if the user doesn\'t exist or if the user is already claimed.
         * @param {V1CheckUserExistsRequest} body CheckUserExistsRequest is the request message for CheckUserExists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userClaimServiceCheckUserExists(body: V1CheckUserExistsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userClaimServiceCheckUserExists(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ClaimUser allows a caller to set the username and password to a user account that was preloaded.
         * @param {V1ClaimUserRequest} body ClaimUserRequest is the request message for ClaimUser.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userClaimServiceClaimUser(body: V1ClaimUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userClaimServiceClaimUser(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SendMFAVerificationCode sends a verification code to the user\'s contact information. Both email and phone number are required and will only be sent if both match the user\'s stored information.
         * @param {V1SendMFAVerificationCodeRequest} body SendMFAVerificationCodeRequest is the request message for SendMFAVerificationCode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userClaimServiceSendMFAVerificationCode(body: V1SendMFAVerificationCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SendMFAVerificationCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userClaimServiceSendMFAVerificationCode(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary VerifyMFA accepts a validation code to prove the user has access to the MFA. A verification token is returned that can be used to prove the user has validated via MFA.
         * @param {V1VerifyMFARequest} body VerifyMFARequest is the request message for VerifyMFA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userClaimServiceVerifyMFA(body: V1VerifyMFARequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1VerifyMFAResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userClaimServiceVerifyMFA(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserClaimServiceApi - factory interface
 * @export
 */
export const UserClaimServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserClaimServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary CheckUserExists takes in the user\'s contact information and checks if the user exists. Returns an error if the user doesn\'t exist or if the user is already claimed.
         * @param {V1CheckUserExistsRequest} body CheckUserExistsRequest is the request message for CheckUserExists.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceCheckUserExists(body: V1CheckUserExistsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.userClaimServiceCheckUserExists(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ClaimUser allows a caller to set the username and password to a user account that was preloaded.
         * @param {V1ClaimUserRequest} body ClaimUserRequest is the request message for ClaimUser.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceClaimUser(body: V1ClaimUserRequest, options?: any): AxiosPromise<object> {
            return localVarFp.userClaimServiceClaimUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SendMFAVerificationCode sends a verification code to the user\'s contact information. Both email and phone number are required and will only be sent if both match the user\'s stored information.
         * @param {V1SendMFAVerificationCodeRequest} body SendMFAVerificationCodeRequest is the request message for SendMFAVerificationCode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceSendMFAVerificationCode(body: V1SendMFAVerificationCodeRequest, options?: any): AxiosPromise<V1SendMFAVerificationCodeResponse> {
            return localVarFp.userClaimServiceSendMFAVerificationCode(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary VerifyMFA accepts a validation code to prove the user has access to the MFA. A verification token is returned that can be used to prove the user has validated via MFA.
         * @param {V1VerifyMFARequest} body VerifyMFARequest is the request message for VerifyMFA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userClaimServiceVerifyMFA(body: V1VerifyMFARequest, options?: any): AxiosPromise<V1VerifyMFAResponse> {
            return localVarFp.userClaimServiceVerifyMFA(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserClaimServiceApi - object-oriented interface
 * @export
 * @class UserClaimServiceApi
 * @extends {BaseAPI}
 */
export class UserClaimServiceApi extends BaseAPI {
    /**
     * 
     * @summary CheckUserExists takes in the user\'s contact information and checks if the user exists. Returns an error if the user doesn\'t exist or if the user is already claimed.
     * @param {V1CheckUserExistsRequest} body CheckUserExistsRequest is the request message for CheckUserExists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserClaimServiceApi
     */
    public userClaimServiceCheckUserExists(body: V1CheckUserExistsRequest, options?: AxiosRequestConfig) {
        return UserClaimServiceApiFp(this.configuration).userClaimServiceCheckUserExists(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ClaimUser allows a caller to set the username and password to a user account that was preloaded.
     * @param {V1ClaimUserRequest} body ClaimUserRequest is the request message for ClaimUser.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserClaimServiceApi
     */
    public userClaimServiceClaimUser(body: V1ClaimUserRequest, options?: AxiosRequestConfig) {
        return UserClaimServiceApiFp(this.configuration).userClaimServiceClaimUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SendMFAVerificationCode sends a verification code to the user\'s contact information. Both email and phone number are required and will only be sent if both match the user\'s stored information.
     * @param {V1SendMFAVerificationCodeRequest} body SendMFAVerificationCodeRequest is the request message for SendMFAVerificationCode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserClaimServiceApi
     */
    public userClaimServiceSendMFAVerificationCode(body: V1SendMFAVerificationCodeRequest, options?: AxiosRequestConfig) {
        return UserClaimServiceApiFp(this.configuration).userClaimServiceSendMFAVerificationCode(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary VerifyMFA accepts a validation code to prove the user has access to the MFA. A verification token is returned that can be used to prove the user has validated via MFA.
     * @param {V1VerifyMFARequest} body VerifyMFARequest is the request message for VerifyMFA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserClaimServiceApi
     */
    public userClaimServiceVerifyMFA(body: V1VerifyMFARequest, options?: AxiosRequestConfig) {
        return UserClaimServiceApiFp(this.configuration).userClaimServiceVerifyMFA(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserServiceApi - axios parameter creator
 * @export
 */
export const UserServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AddDocumentSet is used to add a set of documents to a user\'s profile. This is composed of a set of documents uploaded to blob service.
         * @param {V1AddDocumentSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceAddDocumentSet: async (body: V1AddDocumentSetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceAddDocumentSet', 'body', body)
            const localVarPath = `/v1/user/documents/set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RegisterDevice is used to register a user\'s device and associate a device with an fcm token.
         * @summary RegisterDevice
         * @param {V1RegisterDeviceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceRegisterDevice: async (body: V1RegisterDeviceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceRegisterDevice', 'body', body)
            const localVarPath = `/v1/user/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateKYC is used to update the respective entity\'s KYC information.
         * @param {V1UpdateKYCRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdateKYC: async (body: V1UpdateKYCRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceUpdateKYC', 'body', body)
            const localVarPath = `/v1/user/kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UpdateProfile
         * @param {V1UpdateProfileRequest} body UpdateProfileRequest is used to create a user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdateProfile: async (body: V1UpdateProfileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceUpdateProfile', 'body', body)
            const localVarPath = `/v1/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload files to S3 so they can be uploaded to other places: ex Apex
         * @param {V1UploadDocumentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUploadDocument: async (body: V1UploadDocumentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceUploadDocument', 'body', body)
            const localVarPath = `/v1/user/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserServiceApi - functional programming interface
 * @export
 */
export const UserServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AddDocumentSet is used to add a set of documents to a user\'s profile. This is composed of a set of documents uploaded to blob service.
         * @param {V1AddDocumentSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceAddDocumentSet(body: V1AddDocumentSetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddDocumentSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceAddDocumentSet(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * RegisterDevice is used to register a user\'s device and associate a device with an fcm token.
         * @summary RegisterDevice
         * @param {V1RegisterDeviceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceRegisterDevice(body: V1RegisterDeviceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceRegisterDevice(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateKYC is used to update the respective entity\'s KYC information.
         * @param {V1UpdateKYCRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceUpdateKYC(body: V1UpdateKYCRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateKYCResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceUpdateKYC(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UpdateProfile
         * @param {V1UpdateProfileRequest} body UpdateProfileRequest is used to create a user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceUpdateProfile(body: V1UpdateProfileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceUpdateProfile(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload files to S3 so they can be uploaded to other places: ex Apex
         * @param {V1UploadDocumentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceUploadDocument(body: V1UploadDocumentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UploadDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceUploadDocument(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserServiceApi - factory interface
 * @export
 */
export const UserServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary AddDocumentSet is used to add a set of documents to a user\'s profile. This is composed of a set of documents uploaded to blob service.
         * @param {V1AddDocumentSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceAddDocumentSet(body: V1AddDocumentSetRequest, options?: any): AxiosPromise<V1AddDocumentSetResponse> {
            return localVarFp.userServiceAddDocumentSet(body, options).then((request) => request(axios, basePath));
        },
        /**
         * RegisterDevice is used to register a user\'s device and associate a device with an fcm token.
         * @summary RegisterDevice
         * @param {V1RegisterDeviceRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceRegisterDevice(body: V1RegisterDeviceRequest, options?: any): AxiosPromise<object> {
            return localVarFp.userServiceRegisterDevice(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateKYC is used to update the respective entity\'s KYC information.
         * @param {V1UpdateKYCRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdateKYC(body: V1UpdateKYCRequest, options?: any): AxiosPromise<V1UpdateKYCResponse> {
            return localVarFp.userServiceUpdateKYC(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UpdateProfile
         * @param {V1UpdateProfileRequest} body UpdateProfileRequest is used to create a user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdateProfile(body: V1UpdateProfileRequest, options?: any): AxiosPromise<V1UpdateProfileResponse> {
            return localVarFp.userServiceUpdateProfile(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload files to S3 so they can be uploaded to other places: ex Apex
         * @param {V1UploadDocumentRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUploadDocument(body: V1UploadDocumentRequest, options?: any): AxiosPromise<V1UploadDocumentResponse> {
            return localVarFp.userServiceUploadDocument(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserServiceApi - object-oriented interface
 * @export
 * @class UserServiceApi
 * @extends {BaseAPI}
 */
export class UserServiceApi extends BaseAPI {
    /**
     * 
     * @summary AddDocumentSet is used to add a set of documents to a user\'s profile. This is composed of a set of documents uploaded to blob service.
     * @param {V1AddDocumentSetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceAddDocumentSet(body: V1AddDocumentSetRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceAddDocumentSet(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RegisterDevice is used to register a user\'s device and associate a device with an fcm token.
     * @summary RegisterDevice
     * @param {V1RegisterDeviceRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceRegisterDevice(body: V1RegisterDeviceRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceRegisterDevice(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateKYC is used to update the respective entity\'s KYC information.
     * @param {V1UpdateKYCRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceUpdateKYC(body: V1UpdateKYCRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceUpdateKYC(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UpdateProfile
     * @param {V1UpdateProfileRequest} body UpdateProfileRequest is used to create a user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceUpdateProfile(body: V1UpdateProfileRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceUpdateProfile(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload files to S3 so they can be uploaded to other places: ex Apex
     * @param {V1UploadDocumentRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceUploadDocument(body: V1UploadDocumentRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceUploadDocument(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserSettingsServiceApi - axios parameter creator
 * @export
 */
export const UserSettingsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary UpdateUserSettings endpoint will update the user\'s settings.
         * @param {V1UpdateUserSettingsRequest} body UpdateUserSettingsRequest is the request object for the UpdateUserSettings endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSettingsServiceUpdateUserSettings: async (body: V1UpdateUserSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userSettingsServiceUpdateUserSettings', 'body', body)
            const localVarPath = `/v1/usersettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsServiceApi - functional programming interface
 * @export
 */
export const UserSettingsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary UpdateUserSettings endpoint will update the user\'s settings.
         * @param {V1UpdateUserSettingsRequest} body UpdateUserSettingsRequest is the request object for the UpdateUserSettings endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSettingsServiceUpdateUserSettings(body: V1UpdateUserSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSettingsServiceUpdateUserSettings(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserSettingsServiceApi - factory interface
 * @export
 */
export const UserSettingsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary UpdateUserSettings endpoint will update the user\'s settings.
         * @param {V1UpdateUserSettingsRequest} body UpdateUserSettingsRequest is the request object for the UpdateUserSettings endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSettingsServiceUpdateUserSettings(body: V1UpdateUserSettingsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.userSettingsServiceUpdateUserSettings(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsServiceApi - object-oriented interface
 * @export
 * @class UserSettingsServiceApi
 * @extends {BaseAPI}
 */
export class UserSettingsServiceApi extends BaseAPI {
    /**
     * 
     * @summary UpdateUserSettings endpoint will update the user\'s settings.
     * @param {V1UpdateUserSettingsRequest} body UpdateUserSettingsRequest is the request object for the UpdateUserSettings endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsServiceApi
     */
    public userSettingsServiceUpdateUserSettings(body: V1UpdateUserSettingsRequest, options?: AxiosRequestConfig) {
        return UserSettingsServiceApiFp(this.configuration).userSettingsServiceUpdateUserSettings(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WatchlistServiceApi - axios parameter creator
 * @export
 */
export const WatchlistServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete removes the asset(s) from the user\'s watchlist. Delete request has no effect if the user does not have a watchlist with the given name. Note, a user\'s default watchlist (name is an empty string) can not be deleted.
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistServiceDelete: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('watchlistServiceDelete', 'name', name)
            const localVarPath = `/api/v1/watchlist/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set will associate the provided asset id(s) with the user\'s watchlist. If the watchlist with the provided name already exists, the list values are replaced. If the watchlist with the provided name does not exist, the list is created with     the provided values.
         * @summary Set
         * @param {string} name 
         * @param {WatchlistServiceSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistServiceSet: async (name: string, body: WatchlistServiceSetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('watchlistServiceSet', 'name', name)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('watchlistServiceSet', 'body', body)
            const localVarPath = `/api/v1/watchlist/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WatchlistServiceApi - functional programming interface
 * @export
 */
export const WatchlistServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WatchlistServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete removes the asset(s) from the user\'s watchlist. Delete request has no effect if the user does not have a watchlist with the given name. Note, a user\'s default watchlist (name is an empty string) can not be deleted.
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistServiceDelete(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistServiceDelete(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set will associate the provided asset id(s) with the user\'s watchlist. If the watchlist with the provided name already exists, the list values are replaced. If the watchlist with the provided name does not exist, the list is created with     the provided values.
         * @summary Set
         * @param {string} name 
         * @param {WatchlistServiceSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistServiceSet(name: string, body: WatchlistServiceSetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistServiceSet(name, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WatchlistServiceApi - factory interface
 * @export
 */
export const WatchlistServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WatchlistServiceApiFp(configuration)
    return {
        /**
         * Delete removes the asset(s) from the user\'s watchlist. Delete request has no effect if the user does not have a watchlist with the given name. Note, a user\'s default watchlist (name is an empty string) can not be deleted.
         * @summary Delete
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistServiceDelete(name: string, options?: any): AxiosPromise<object> {
            return localVarFp.watchlistServiceDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Set will associate the provided asset id(s) with the user\'s watchlist. If the watchlist with the provided name already exists, the list values are replaced. If the watchlist with the provided name does not exist, the list is created with     the provided values.
         * @summary Set
         * @param {string} name 
         * @param {WatchlistServiceSetRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistServiceSet(name: string, body: WatchlistServiceSetRequest, options?: any): AxiosPromise<object> {
            return localVarFp.watchlistServiceSet(name, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WatchlistServiceApi - object-oriented interface
 * @export
 * @class WatchlistServiceApi
 * @extends {BaseAPI}
 */
export class WatchlistServiceApi extends BaseAPI {
    /**
     * Delete removes the asset(s) from the user\'s watchlist. Delete request has no effect if the user does not have a watchlist with the given name. Note, a user\'s default watchlist (name is an empty string) can not be deleted.
     * @summary Delete
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistServiceApi
     */
    public watchlistServiceDelete(name: string, options?: AxiosRequestConfig) {
        return WatchlistServiceApiFp(this.configuration).watchlistServiceDelete(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set will associate the provided asset id(s) with the user\'s watchlist. If the watchlist with the provided name already exists, the list values are replaced. If the watchlist with the provided name does not exist, the list is created with     the provided values.
     * @summary Set
     * @param {string} name 
     * @param {WatchlistServiceSetRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistServiceApi
     */
    public watchlistServiceSet(name: string, body: WatchlistServiceSetRequest, options?: AxiosRequestConfig) {
        return WatchlistServiceApiFp(this.configuration).watchlistServiceSet(name, body, options).then((request) => request(this.axios, this.basePath));
    }
}


